var la = Object.defineProperty, ua = Object.defineProperties;
var ca = Object.getOwnPropertyDescriptors;
var Jn = Object.getOwnPropertySymbols;
var fa = Object.prototype.hasOwnProperty, pa = Object.prototype.propertyIsEnumerable;
var Yn = (e, t, r) => t in e ? la(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, pt = (e, t) => {
  for (var r in t || (t = {}))
    fa.call(t, r) && Yn(e, r, t[r]);
  if (Jn)
    for (var r of Jn(t))
      pa.call(t, r) && Yn(e, r, t[r]);
  return e;
}, dt = (e, t) => ua(e, ca(t));
var Qn = (e, t, r) => new Promise((n, o) => {
  var i = (s) => {
    try {
      l(r.next(s));
    } catch (h) {
      o(h);
    }
  }, a = (s) => {
    try {
      l(r.throw(s));
    } catch (h) {
      o(h);
    }
  }, l = (s) => s.done ? n(s.value) : Promise.resolve(s.value).then(i, a);
  l((r = r.apply(e, t)).next());
});
import { defineComponent as ge, toRefs as Ae, computed as Q, openBlock as Y, createElementBlock as ee, normalizeClass as oe, unref as m, createCommentVNode as he, renderSlot as Re, useSlots as Ho, useAttrs as da, ref as fe, watch as Ft, onMounted as gr, createBlock as Ne, Teleport as wn, createElementVNode as G, normalizeStyle as Ut, toDisplayString as ye, withCtx as Ie, createTextVNode as $t, inject as zo, provide as Sn, onUnmounted as ya, nextTick as Wo, withDirectives as Lt, createVNode as Tr, vModelText as ha, withKeys as ma, withModifiers as Vo, Fragment as rt, renderList as It, Transition as qo, vShow as ga, pushScopeId as va, popScopeId as ba, h as wa, render as Sa } from "vue";
import { LogReport as Oa } from "@bilibili-intl/log-report";
var Te = "top", Ue = "bottom", Le = "right", De = "left", On = "auto", vr = [Te, Ue, Le, De], Ht = "start", dr = "end", Ea = "clippingParents", Go = "viewport", lr = "popper", Aa = "reference", Kn = /* @__PURE__ */ vr.reduce(function(e, t) {
  return e.concat([t + "-" + Ht, t + "-" + dr]);
}, []), Jo = /* @__PURE__ */ [].concat(vr, [On]).reduce(function(e, t) {
  return e.concat([t, t + "-" + Ht, t + "-" + dr]);
}, []), xa = "beforeRead", Pa = "read", ja = "afterRead", Ra = "beforeMain", _a = "main", ka = "afterMain", $a = "beforeWrite", Ca = "write", Na = "afterWrite", Ta = [xa, Pa, ja, Ra, _a, ka, $a, Ca, Na];
function Qe(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function He(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function Nt(e) {
  var t = He(e).Element;
  return e instanceof t || e instanceof Element;
}
function Fe(e) {
  var t = He(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function En(e) {
  if (typeof ShadowRoot == "undefined")
    return !1;
  var t = He(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function Da(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(r) {
    var n = t.styles[r] || {}, o = t.attributes[r] || {}, i = t.elements[r];
    !Fe(i) || !Qe(i) || (Object.assign(i.style, n), Object.keys(o).forEach(function(a) {
      var l = o[a];
      l === !1 ? i.removeAttribute(a) : i.setAttribute(a, l === !0 ? "" : l);
    }));
  });
}
function Ma(e) {
  var t = e.state, r = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, r.popper), t.styles = r, t.elements.arrow && Object.assign(t.elements.arrow.style, r.arrow), function() {
    Object.keys(t.elements).forEach(function(n) {
      var o = t.elements[n], i = t.attributes[n] || {}, a = Object.keys(t.styles.hasOwnProperty(n) ? t.styles[n] : r[n]), l = a.reduce(function(s, h) {
        return s[h] = "", s;
      }, {});
      !Fe(o) || !Qe(o) || (Object.assign(o.style, l), Object.keys(i).forEach(function(s) {
        o.removeAttribute(s);
      }));
    });
  };
}
const Ba = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Da,
  effect: Ma,
  requires: ["computeStyles"]
};
function Ye(e) {
  return e.split("-")[0];
}
var Ct = Math.max, Dr = Math.min, zt = Math.round;
function un() {
  var e = navigator.userAgentData;
  return e != null && e.brands ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function Yo() {
  return !/^((?!chrome|android).)*safari/i.test(un());
}
function Wt(e, t, r) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  var n = e.getBoundingClientRect(), o = 1, i = 1;
  t && Fe(e) && (o = e.offsetWidth > 0 && zt(n.width) / e.offsetWidth || 1, i = e.offsetHeight > 0 && zt(n.height) / e.offsetHeight || 1);
  var a = Nt(e) ? He(e) : window, l = a.visualViewport, s = !Yo() && r, h = (n.left + (s && l ? l.offsetLeft : 0)) / o, d = (n.top + (s && l ? l.offsetTop : 0)) / i, S = n.width / o, O = n.height / i;
  return {
    width: S,
    height: O,
    top: d,
    right: h + S,
    bottom: d + O,
    left: h,
    x: h,
    y: d
  };
}
function An(e) {
  var t = Wt(e), r = e.offsetWidth, n = e.offsetHeight;
  return Math.abs(t.width - r) <= 1 && (r = t.width), Math.abs(t.height - n) <= 1 && (n = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: r,
    height: n
  };
}
function Qo(e, t) {
  var r = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (r && En(r)) {
    var n = t;
    do {
      if (n && e.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function at(e) {
  return He(e).getComputedStyle(e);
}
function Ia(e) {
  return ["table", "td", "th"].indexOf(Qe(e)) >= 0;
}
function bt(e) {
  return ((Nt(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function Ir(e) {
  return Qe(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (En(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    bt(e)
  );
}
function Zn(e) {
  return !Fe(e) || // https://github.com/popperjs/popper-core/issues/837
  at(e).position === "fixed" ? null : e.offsetParent;
}
function Fa(e) {
  var t = /firefox/i.test(un()), r = /Trident/i.test(un());
  if (r && Fe(e)) {
    var n = at(e);
    if (n.position === "fixed")
      return null;
  }
  var o = Ir(e);
  for (En(o) && (o = o.host); Fe(o) && ["html", "body"].indexOf(Qe(o)) < 0; ) {
    var i = at(o);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function br(e) {
  for (var t = He(e), r = Zn(e); r && Ia(r) && at(r).position === "static"; )
    r = Zn(r);
  return r && (Qe(r) === "html" || Qe(r) === "body" && at(r).position === "static") ? t : r || Fa(e) || t;
}
function xn(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function fr(e, t, r) {
  return Ct(e, Dr(t, r));
}
function Ua(e, t, r) {
  var n = fr(e, t, r);
  return n > r ? r : n;
}
function Ko() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Zo(e) {
  return Object.assign({}, Ko(), e);
}
function Xo(e, t) {
  return t.reduce(function(r, n) {
    return r[n] = e, r;
  }, {});
}
var La = function(t, r) {
  return t = typeof t == "function" ? t(Object.assign({}, r.rects, {
    placement: r.placement
  })) : t, Zo(typeof t != "number" ? t : Xo(t, vr));
};
function Ha(e) {
  var t, r = e.state, n = e.name, o = e.options, i = r.elements.arrow, a = r.modifiersData.popperOffsets, l = Ye(r.placement), s = xn(l), h = [De, Le].indexOf(l) >= 0, d = h ? "height" : "width";
  if (!(!i || !a)) {
    var S = La(o.padding, r), O = An(i), p = s === "y" ? Te : De, f = s === "y" ? Ue : Le, P = r.rects.reference[d] + r.rects.reference[s] - a[s] - r.rects.popper[d], k = a[s] - r.rects.reference[s], A = br(i), u = A ? s === "y" ? A.clientHeight || 0 : A.clientWidth || 0 : 0, v = P / 2 - k / 2, b = S[p], g = u - O[d] - S[f], w = u / 2 - O[d] / 2 + v, R = fr(b, w, g), D = s;
    r.modifiersData[n] = (t = {}, t[D] = R, t.centerOffset = R - w, t);
  }
}
function za(e) {
  var t = e.state, r = e.options, n = r.element, o = n === void 0 ? "[data-popper-arrow]" : n;
  o != null && (typeof o == "string" && (o = t.elements.popper.querySelector(o), !o) || Qo(t.elements.popper, o) && (t.elements.arrow = o));
}
const Wa = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: Ha,
  effect: za,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Vt(e) {
  return e.split("-")[1];
}
var Va = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function qa(e) {
  var t = e.x, r = e.y, n = window, o = n.devicePixelRatio || 1;
  return {
    x: zt(t * o) / o || 0,
    y: zt(r * o) / o || 0
  };
}
function Xn(e) {
  var t, r = e.popper, n = e.popperRect, o = e.placement, i = e.variation, a = e.offsets, l = e.position, s = e.gpuAcceleration, h = e.adaptive, d = e.roundOffsets, S = e.isFixed, O = a.x, p = O === void 0 ? 0 : O, f = a.y, P = f === void 0 ? 0 : f, k = typeof d == "function" ? d({
    x: p,
    y: P
  }) : {
    x: p,
    y: P
  };
  p = k.x, P = k.y;
  var A = a.hasOwnProperty("x"), u = a.hasOwnProperty("y"), v = De, b = Te, g = window;
  if (h) {
    var w = br(r), R = "clientHeight", D = "clientWidth";
    if (w === He(r) && (w = bt(r), at(w).position !== "static" && l === "absolute" && (R = "scrollHeight", D = "scrollWidth")), w = w, o === Te || (o === De || o === Le) && i === dr) {
      b = Ue;
      var j = S && w === g && g.visualViewport ? g.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        w[R]
      );
      P -= j - n.height, P *= s ? 1 : -1;
    }
    if (o === De || (o === Te || o === Ue) && i === dr) {
      v = Le;
      var M = S && w === g && g.visualViewport ? g.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        w[D]
      );
      p -= M - n.width, p *= s ? 1 : -1;
    }
  }
  var H = Object.assign({
    position: l
  }, h && Va), K = d === !0 ? qa({
    x: p,
    y: P
  }) : {
    x: p,
    y: P
  };
  if (p = K.x, P = K.y, s) {
    var C;
    return Object.assign({}, H, (C = {}, C[b] = u ? "0" : "", C[v] = A ? "0" : "", C.transform = (g.devicePixelRatio || 1) <= 1 ? "translate(" + p + "px, " + P + "px)" : "translate3d(" + p + "px, " + P + "px, 0)", C));
  }
  return Object.assign({}, H, (t = {}, t[b] = u ? P + "px" : "", t[v] = A ? p + "px" : "", t.transform = "", t));
}
function Ga(e) {
  var t = e.state, r = e.options, n = r.gpuAcceleration, o = n === void 0 ? !0 : n, i = r.adaptive, a = i === void 0 ? !0 : i, l = r.roundOffsets, s = l === void 0 ? !0 : l, h = {
    placement: Ye(t.placement),
    variation: Vt(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: o,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, Xn(Object.assign({}, h, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: a,
    roundOffsets: s
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, Xn(Object.assign({}, h, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: s
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const Ja = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: Ga,
  data: {}
};
var Or = {
  passive: !0
};
function Ya(e) {
  var t = e.state, r = e.instance, n = e.options, o = n.scroll, i = o === void 0 ? !0 : o, a = n.resize, l = a === void 0 ? !0 : a, s = He(t.elements.popper), h = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && h.forEach(function(d) {
    d.addEventListener("scroll", r.update, Or);
  }), l && s.addEventListener("resize", r.update, Or), function() {
    i && h.forEach(function(d) {
      d.removeEventListener("scroll", r.update, Or);
    }), l && s.removeEventListener("resize", r.update, Or);
  };
}
const Qa = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: Ya,
  data: {}
};
var Ka = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Er(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return Ka[t];
  });
}
var Za = {
  start: "end",
  end: "start"
};
function eo(e) {
  return e.replace(/start|end/g, function(t) {
    return Za[t];
  });
}
function Pn(e) {
  var t = He(e), r = t.pageXOffset, n = t.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: n
  };
}
function jn(e) {
  return Wt(bt(e)).left + Pn(e).scrollLeft;
}
function Xa(e, t) {
  var r = He(e), n = bt(e), o = r.visualViewport, i = n.clientWidth, a = n.clientHeight, l = 0, s = 0;
  if (o) {
    i = o.width, a = o.height;
    var h = Yo();
    (h || !h && t === "fixed") && (l = o.offsetLeft, s = o.offsetTop);
  }
  return {
    width: i,
    height: a,
    x: l + jn(e),
    y: s
  };
}
function es(e) {
  var t, r = bt(e), n = Pn(e), o = (t = e.ownerDocument) == null ? void 0 : t.body, i = Ct(r.scrollWidth, r.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), a = Ct(r.scrollHeight, r.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), l = -n.scrollLeft + jn(e), s = -n.scrollTop;
  return at(o || r).direction === "rtl" && (l += Ct(r.clientWidth, o ? o.clientWidth : 0) - i), {
    width: i,
    height: a,
    x: l,
    y: s
  };
}
function Rn(e) {
  var t = at(e), r = t.overflow, n = t.overflowX, o = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + o + n);
}
function ei(e) {
  return ["html", "body", "#document"].indexOf(Qe(e)) >= 0 ? e.ownerDocument.body : Fe(e) && Rn(e) ? e : ei(Ir(e));
}
function pr(e, t) {
  var r;
  t === void 0 && (t = []);
  var n = ei(e), o = n === ((r = e.ownerDocument) == null ? void 0 : r.body), i = He(n), a = o ? [i].concat(i.visualViewport || [], Rn(n) ? n : []) : n, l = t.concat(a);
  return o ? l : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    l.concat(pr(Ir(a)))
  );
}
function cn(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function ts(e, t) {
  var r = Wt(e, !1, t === "fixed");
  return r.top = r.top + e.clientTop, r.left = r.left + e.clientLeft, r.bottom = r.top + e.clientHeight, r.right = r.left + e.clientWidth, r.width = e.clientWidth, r.height = e.clientHeight, r.x = r.left, r.y = r.top, r;
}
function to(e, t, r) {
  return t === Go ? cn(Xa(e, r)) : Nt(t) ? ts(t, r) : cn(es(bt(e)));
}
function rs(e) {
  var t = pr(Ir(e)), r = ["absolute", "fixed"].indexOf(at(e).position) >= 0, n = r && Fe(e) ? br(e) : e;
  return Nt(n) ? t.filter(function(o) {
    return Nt(o) && Qo(o, n) && Qe(o) !== "body";
  }) : [];
}
function ns(e, t, r, n) {
  var o = t === "clippingParents" ? rs(e) : [].concat(t), i = [].concat(o, [r]), a = i[0], l = i.reduce(function(s, h) {
    var d = to(e, h, n);
    return s.top = Ct(d.top, s.top), s.right = Dr(d.right, s.right), s.bottom = Dr(d.bottom, s.bottom), s.left = Ct(d.left, s.left), s;
  }, to(e, a, n));
  return l.width = l.right - l.left, l.height = l.bottom - l.top, l.x = l.left, l.y = l.top, l;
}
function ti(e) {
  var t = e.reference, r = e.element, n = e.placement, o = n ? Ye(n) : null, i = n ? Vt(n) : null, a = t.x + t.width / 2 - r.width / 2, l = t.y + t.height / 2 - r.height / 2, s;
  switch (o) {
    case Te:
      s = {
        x: a,
        y: t.y - r.height
      };
      break;
    case Ue:
      s = {
        x: a,
        y: t.y + t.height
      };
      break;
    case Le:
      s = {
        x: t.x + t.width,
        y: l
      };
      break;
    case De:
      s = {
        x: t.x - r.width,
        y: l
      };
      break;
    default:
      s = {
        x: t.x,
        y: t.y
      };
  }
  var h = o ? xn(o) : null;
  if (h != null) {
    var d = h === "y" ? "height" : "width";
    switch (i) {
      case Ht:
        s[h] = s[h] - (t[d] / 2 - r[d] / 2);
        break;
      case dr:
        s[h] = s[h] + (t[d] / 2 - r[d] / 2);
        break;
    }
  }
  return s;
}
function yr(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, o = n === void 0 ? e.placement : n, i = r.strategy, a = i === void 0 ? e.strategy : i, l = r.boundary, s = l === void 0 ? Ea : l, h = r.rootBoundary, d = h === void 0 ? Go : h, S = r.elementContext, O = S === void 0 ? lr : S, p = r.altBoundary, f = p === void 0 ? !1 : p, P = r.padding, k = P === void 0 ? 0 : P, A = Zo(typeof k != "number" ? k : Xo(k, vr)), u = O === lr ? Aa : lr, v = e.rects.popper, b = e.elements[f ? u : O], g = ns(Nt(b) ? b : b.contextElement || bt(e.elements.popper), s, d, a), w = Wt(e.elements.reference), R = ti({
    reference: w,
    element: v,
    strategy: "absolute",
    placement: o
  }), D = cn(Object.assign({}, v, R)), j = O === lr ? D : w, M = {
    top: g.top - j.top + A.top,
    bottom: j.bottom - g.bottom + A.bottom,
    left: g.left - j.left + A.left,
    right: j.right - g.right + A.right
  }, H = e.modifiersData.offset;
  if (O === lr && H) {
    var K = H[o];
    Object.keys(M).forEach(function(C) {
      var $ = [Le, Ue].indexOf(C) >= 0 ? 1 : -1, x = [Te, Ue].indexOf(C) >= 0 ? "y" : "x";
      M[C] += K[x] * $;
    });
  }
  return M;
}
function os(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, o = r.boundary, i = r.rootBoundary, a = r.padding, l = r.flipVariations, s = r.allowedAutoPlacements, h = s === void 0 ? Jo : s, d = Vt(n), S = d ? l ? Kn : Kn.filter(function(f) {
    return Vt(f) === d;
  }) : vr, O = S.filter(function(f) {
    return h.indexOf(f) >= 0;
  });
  O.length === 0 && (O = S);
  var p = O.reduce(function(f, P) {
    return f[P] = yr(e, {
      placement: P,
      boundary: o,
      rootBoundary: i,
      padding: a
    })[Ye(P)], f;
  }, {});
  return Object.keys(p).sort(function(f, P) {
    return p[f] - p[P];
  });
}
function is(e) {
  if (Ye(e) === On)
    return [];
  var t = Er(e);
  return [eo(e), t, eo(t)];
}
function as(e) {
  var t = e.state, r = e.options, n = e.name;
  if (!t.modifiersData[n]._skip) {
    for (var o = r.mainAxis, i = o === void 0 ? !0 : o, a = r.altAxis, l = a === void 0 ? !0 : a, s = r.fallbackPlacements, h = r.padding, d = r.boundary, S = r.rootBoundary, O = r.altBoundary, p = r.flipVariations, f = p === void 0 ? !0 : p, P = r.allowedAutoPlacements, k = t.options.placement, A = Ye(k), u = A === k, v = s || (u || !f ? [Er(k)] : is(k)), b = [k].concat(v).reduce(function(L, Z) {
      return L.concat(Ye(Z) === On ? os(t, {
        placement: Z,
        boundary: d,
        rootBoundary: S,
        padding: h,
        flipVariations: f,
        allowedAutoPlacements: P
      }) : Z);
    }, []), g = t.rects.reference, w = t.rects.popper, R = /* @__PURE__ */ new Map(), D = !0, j = b[0], M = 0; M < b.length; M++) {
      var H = b[M], K = Ye(H), C = Vt(H) === Ht, $ = [Te, Ue].indexOf(K) >= 0, x = $ ? "width" : "height", T = yr(t, {
        placement: H,
        boundary: d,
        rootBoundary: S,
        altBoundary: O,
        padding: h
      }), _ = $ ? C ? Le : De : C ? Ue : Te;
      g[x] > w[x] && (_ = Er(_));
      var N = Er(_), E = [];
      if (i && E.push(T[K] <= 0), l && E.push(T[_] <= 0, T[N] <= 0), E.every(function(L) {
        return L;
      })) {
        j = H, D = !1;
        break;
      }
      R.set(H, E);
    }
    if (D)
      for (var F = f ? 3 : 1, V = function(Z) {
        var te = b.find(function(re) {
          var ie = R.get(re);
          if (ie)
            return ie.slice(0, Z).every(function(ne) {
              return ne;
            });
        });
        if (te)
          return j = te, "break";
      }, z = F; z > 0; z--) {
        var W = V(z);
        if (W === "break")
          break;
      }
    t.placement !== j && (t.modifiersData[n]._skip = !0, t.placement = j, t.reset = !0);
  }
}
const ss = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: as,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function ro(e, t, r) {
  return r === void 0 && (r = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - r.y,
    right: e.right - t.width + r.x,
    bottom: e.bottom - t.height + r.y,
    left: e.left - t.width - r.x
  };
}
function no(e) {
  return [Te, Le, Ue, De].some(function(t) {
    return e[t] >= 0;
  });
}
function ls(e) {
  var t = e.state, r = e.name, n = t.rects.reference, o = t.rects.popper, i = t.modifiersData.preventOverflow, a = yr(t, {
    elementContext: "reference"
  }), l = yr(t, {
    altBoundary: !0
  }), s = ro(a, n), h = ro(l, o, i), d = no(s), S = no(h);
  t.modifiersData[r] = {
    referenceClippingOffsets: s,
    popperEscapeOffsets: h,
    isReferenceHidden: d,
    hasPopperEscaped: S
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": d,
    "data-popper-escaped": S
  });
}
const us = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: ls
};
function cs(e, t, r) {
  var n = Ye(e), o = [De, Te].indexOf(n) >= 0 ? -1 : 1, i = typeof r == "function" ? r(Object.assign({}, t, {
    placement: e
  })) : r, a = i[0], l = i[1];
  return a = a || 0, l = (l || 0) * o, [De, Le].indexOf(n) >= 0 ? {
    x: l,
    y: a
  } : {
    x: a,
    y: l
  };
}
function fs(e) {
  var t = e.state, r = e.options, n = e.name, o = r.offset, i = o === void 0 ? [0, 0] : o, a = Jo.reduce(function(d, S) {
    return d[S] = cs(S, t.rects, i), d;
  }, {}), l = a[t.placement], s = l.x, h = l.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += s, t.modifiersData.popperOffsets.y += h), t.modifiersData[n] = a;
}
const ps = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: fs
};
function ds(e) {
  var t = e.state, r = e.name;
  t.modifiersData[r] = ti({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const ys = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: ds,
  data: {}
};
function hs(e) {
  return e === "x" ? "y" : "x";
}
function ms(e) {
  var t = e.state, r = e.options, n = e.name, o = r.mainAxis, i = o === void 0 ? !0 : o, a = r.altAxis, l = a === void 0 ? !1 : a, s = r.boundary, h = r.rootBoundary, d = r.altBoundary, S = r.padding, O = r.tether, p = O === void 0 ? !0 : O, f = r.tetherOffset, P = f === void 0 ? 0 : f, k = yr(t, {
    boundary: s,
    rootBoundary: h,
    padding: S,
    altBoundary: d
  }), A = Ye(t.placement), u = Vt(t.placement), v = !u, b = xn(A), g = hs(b), w = t.modifiersData.popperOffsets, R = t.rects.reference, D = t.rects.popper, j = typeof P == "function" ? P(Object.assign({}, t.rects, {
    placement: t.placement
  })) : P, M = typeof j == "number" ? {
    mainAxis: j,
    altAxis: j
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, j), H = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, K = {
    x: 0,
    y: 0
  };
  if (w) {
    if (i) {
      var C, $ = b === "y" ? Te : De, x = b === "y" ? Ue : Le, T = b === "y" ? "height" : "width", _ = w[b], N = _ + k[$], E = _ - k[x], F = p ? -D[T] / 2 : 0, V = u === Ht ? R[T] : D[T], z = u === Ht ? -D[T] : -R[T], W = t.elements.arrow, L = p && W ? An(W) : {
        width: 0,
        height: 0
      }, Z = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : Ko(), te = Z[$], re = Z[x], ie = fr(0, R[T], L[T]), ne = v ? R[T] / 2 - F - ie - te - M.mainAxis : V - ie - te - M.mainAxis, me = v ? -R[T] / 2 + F + ie + re + M.mainAxis : z + ie + re + M.mainAxis, ve = t.elements.arrow && br(t.elements.arrow), Se = ve ? b === "y" ? ve.clientTop || 0 : ve.clientLeft || 0 : 0, pe = (C = H == null ? void 0 : H[b]) != null ? C : 0, We = _ + ne - pe - Se, Ke = _ + me - pe, ce = fr(p ? Dr(N, We) : N, _, p ? Ct(E, Ke) : E);
      w[b] = ce, K[b] = ce - _;
    }
    if (l) {
      var ae, Zt = b === "x" ? Te : De, wt = b === "x" ? Ue : Le, Ve = w[g], ct = g === "y" ? "height" : "width", Tt = Ve + k[Zt], Dt = Ve - k[wt], St = [Te, De].indexOf(A) !== -1, Mt = (ae = H == null ? void 0 : H[g]) != null ? ae : 0, ft = St ? Tt : Ve - R[ct] - D[ct] - Mt + M.altAxis, Bt = St ? Ve + R[ct] + D[ct] - Mt - M.altAxis : Dt, Ce = p && St ? Ua(ft, Ve, Bt) : fr(p ? ft : Tt, Ve, p ? Bt : Dt);
      w[g] = Ce, K[g] = Ce - Ve;
    }
    t.modifiersData[n] = K;
  }
}
const gs = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: ms,
  requiresIfExists: ["offset"]
};
function vs(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function bs(e) {
  return e === He(e) || !Fe(e) ? Pn(e) : vs(e);
}
function ws(e) {
  var t = e.getBoundingClientRect(), r = zt(t.width) / e.offsetWidth || 1, n = zt(t.height) / e.offsetHeight || 1;
  return r !== 1 || n !== 1;
}
function Ss(e, t, r) {
  r === void 0 && (r = !1);
  var n = Fe(t), o = Fe(t) && ws(t), i = bt(t), a = Wt(e, o, r), l = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = {
    x: 0,
    y: 0
  };
  return (n || !n && !r) && ((Qe(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Rn(i)) && (l = bs(t)), Fe(t) ? (s = Wt(t, !0), s.x += t.clientLeft, s.y += t.clientTop) : i && (s.x = jn(i))), {
    x: a.left + l.scrollLeft - s.x,
    y: a.top + l.scrollTop - s.y,
    width: a.width,
    height: a.height
  };
}
function Os(e) {
  var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), n = [];
  e.forEach(function(i) {
    t.set(i.name, i);
  });
  function o(i) {
    r.add(i.name);
    var a = [].concat(i.requires || [], i.requiresIfExists || []);
    a.forEach(function(l) {
      if (!r.has(l)) {
        var s = t.get(l);
        s && o(s);
      }
    }), n.push(i);
  }
  return e.forEach(function(i) {
    r.has(i.name) || o(i);
  }), n;
}
function Es(e) {
  var t = Os(e);
  return Ta.reduce(function(r, n) {
    return r.concat(t.filter(function(o) {
      return o.phase === n;
    }));
  }, []);
}
function As(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(r) {
      Promise.resolve().then(function() {
        t = void 0, r(e());
      });
    })), t;
  };
}
function xs(e) {
  var t = e.reduce(function(r, n) {
    var o = r[n.name];
    return r[n.name] = o ? Object.assign({}, o, n, {
      options: Object.assign({}, o.options, n.options),
      data: Object.assign({}, o.data, n.data)
    }) : n, r;
  }, {});
  return Object.keys(t).map(function(r) {
    return t[r];
  });
}
var oo = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function io() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return !t.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function Ps(e) {
  e === void 0 && (e = {});
  var t = e, r = t.defaultModifiers, n = r === void 0 ? [] : r, o = t.defaultOptions, i = o === void 0 ? oo : o;
  return function(l, s, h) {
    h === void 0 && (h = i);
    var d = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, oo, i),
      modifiersData: {},
      elements: {
        reference: l,
        popper: s
      },
      attributes: {},
      styles: {}
    }, S = [], O = !1, p = {
      state: d,
      setOptions: function(A) {
        var u = typeof A == "function" ? A(d.options) : A;
        P(), d.options = Object.assign({}, i, d.options, u), d.scrollParents = {
          reference: Nt(l) ? pr(l) : l.contextElement ? pr(l.contextElement) : [],
          popper: pr(s)
        };
        var v = Es(xs([].concat(n, d.options.modifiers)));
        return d.orderedModifiers = v.filter(function(b) {
          return b.enabled;
        }), f(), p.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!O) {
          var A = d.elements, u = A.reference, v = A.popper;
          if (io(u, v)) {
            d.rects = {
              reference: Ss(u, br(v), d.options.strategy === "fixed"),
              popper: An(v)
            }, d.reset = !1, d.placement = d.options.placement, d.orderedModifiers.forEach(function(M) {
              return d.modifiersData[M.name] = Object.assign({}, M.data);
            });
            for (var b = 0; b < d.orderedModifiers.length; b++) {
              if (d.reset === !0) {
                d.reset = !1, b = -1;
                continue;
              }
              var g = d.orderedModifiers[b], w = g.fn, R = g.options, D = R === void 0 ? {} : R, j = g.name;
              typeof w == "function" && (d = w({
                state: d,
                options: D,
                name: j,
                instance: p
              }) || d);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: As(function() {
        return new Promise(function(k) {
          p.forceUpdate(), k(d);
        });
      }),
      destroy: function() {
        P(), O = !0;
      }
    };
    if (!io(l, s))
      return p;
    p.setOptions(h).then(function(k) {
      !O && h.onFirstUpdate && h.onFirstUpdate(k);
    });
    function f() {
      d.orderedModifiers.forEach(function(k) {
        var A = k.name, u = k.options, v = u === void 0 ? {} : u, b = k.effect;
        if (typeof b == "function") {
          var g = b({
            state: d,
            name: A,
            instance: p,
            options: v
          }), w = function() {
          };
          S.push(g || w);
        }
      });
    }
    function P() {
      S.forEach(function(k) {
        return k();
      }), S = [];
    }
    return p;
  };
}
var js = [Qa, ys, Ja, Ba, ps, ss, gs, Wa, us], ri = /* @__PURE__ */ Ps({
  defaultModifiers: js
}), Rs = Object.defineProperty, _s = Object.defineProperties, ks = Object.getOwnPropertyDescriptors, ao = Object.getOwnPropertySymbols, $s = Object.prototype.hasOwnProperty, Cs = Object.prototype.propertyIsEnumerable, so = (e, t, r) => t in e ? Rs(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, be = (e, t) => {
  for (var r in t || (t = {}))
    $s.call(t, r) && so(e, r, t[r]);
  if (ao)
    for (var r of ao(t))
      Cs.call(t, r) && so(e, r, t[r]);
  return e;
}, we = (e, t) => _s(e, ks(t));
const ze = (e, t) => {
  if (e.install = (r) => {
    for (const n of [e, ...Object.values(t != null ? t : {})])
      r.component(n.name, n);
  }, t)
    for (const [r, n] of Object.entries(t))
      e[r] = n;
  return e;
}, Ns = ["disabled"], Ts = {
  name: "BButton"
}, Ar = /* @__PURE__ */ ge(we(be({}, Ts), {
  props: {
    size: { default: "default" },
    type: { default: "default" },
    primary: { type: Boolean },
    cancel: { type: Boolean },
    hollow: { type: Boolean },
    disabled: { type: Boolean },
    loading: { type: Boolean },
    block: { type: Boolean },
    bold: { type: Boolean },
    largeSpace: { type: Boolean }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const r = e, { size: n, type: o, disabled: i, loading: a, block: l, bold: s, largeSpace: h, hollow: d } = Ae(r), S = "bstar-button", O = `${S}--loading-icon`, p = Q(
      () => [
        S,
        `${S}--${n.value}`,
        `${S}--color-${o != null && o.value ? o.value : "default"}`,
        {
          [`${S}--hollow`]: d == null ? void 0 : d.value,
          [`${S}--disabled`]: i == null ? void 0 : i.value,
          [`${S}--block`]: l == null ? void 0 : l.value,
          [`${S}--bold`]: s == null ? void 0 : s.value,
          [`${S}--loading`]: a == null ? void 0 : a.value,
          [`${S}--large-space`]: h == null ? void 0 : h.value
        }
      ]
    ), f = (P) => {
      if (i != null && i.value || a != null && a.value)
        return !1;
      t("click", P);
    };
    return (P, k) => (Y(), ee("button", {
      type: "button",
      class: oe(m(p)),
      disabled: m(i) || m(a),
      onClick: f
    }, [
      m(a) ? (Y(), ee("i", {
        key: 0,
        class: oe(O)
      })) : he("", !0),
      Re(P.$slots, "default")
    ], 10, Ns));
  }
})), Ds = ze(Ar), xr = typeof window != "undefined", ni = () => xr ? {
  inBrowser: xr,
  isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)
} : { inBrowser: xr }, Ms = { class: "dialog__header-title" }, Bs = {
  key: 0,
  class: "dialog__footer"
}, Is = {
  name: "BDialog"
}, Fs = /* @__PURE__ */ ge(we(be({}, Is), {
  props: {
    visible: { type: Boolean },
    size: { default: "medium" },
    title: null,
    titleAlign: { default: "left" },
    type: { default: "default" },
    cancelButtonText: { default: void 0 },
    buttonText: { default: void 0 },
    fullscreen: { type: Boolean, default: !0 },
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    showBack: { type: Boolean, default: !1 },
    showClose: { type: Boolean, default: !0 },
    zIndex: { default: 9700 },
    dark: { type: Boolean, default: !1 },
    to: { default: "body" }
  },
  emits: ["back", "close", "submit", "cancel", "show", "hide"],
  setup(e, { emit: t }) {
    const r = e, { visible: n, size: o, titleAlign: i, fullscreen: a, showBack: l, showClose: s, cancelButtonText: h, buttonText: d, zIndex: S } = Ae(r), O = Ho(), p = da(), { isMobile: f } = ni(), P = fe(!1), k = fe(!1), A = fe(!1), u = fe(0), v = Q(() => [
      "dialog__wrap",
      {
        "dialog__wrap--show": m(k),
        "dialog__wrap--show-bg": m(P)
      }
    ]), b = Q(() => ({ "z-index": m(S) })), g = Q(() => {
      const E = "dialog__container";
      return [
        E,
        `${E}--${o.value}`,
        `${E}--${p.class}`,
        { [`${E}--fullscreen`]: a.value },
        { [`${E}--show`]: A.value }
      ];
    }), w = Q(() => [
      "dialog__body",
      { "dialog__body--empty": m(N) }
    ]), R = Q(() => i.value === "center" || (l == null ? void 0 : l.value)), D = Q(() => {
      const E = "dialog__header";
      return [
        E,
        { [`${E}--center`]: R.value },
        { [`${E}--no-button`]: !(l != null && l.value) && !s.value }
      ];
    }), j = Q(() => m(h) || m(d) || O.footer), M = Q(() => ({ "--height": `${m(u)}px` })), H = () => {
      t("back");
    }, K = () => {
      t("close");
    }, C = () => {
      t("cancel");
    }, $ = () => {
      t("submit");
    }, x = () => {
      u.value = window.innerHeight;
    }, T = () => {
      k.value = !0, x(), window.addEventListener("resize", x), setTimeout(() => {
        P.value = !0, A.value = !0, t("show");
      }, 100);
    }, _ = () => {
      A.value = !1, P.value = !1, setTimeout(() => {
        k.value = !1, window.removeEventListener("resize", x), t("hide");
      }, 400);
    };
    Ft(n, (E) => {
      xr && (document.body.style.overflow = E ? "hidden" : "", E ? T() : _());
    });
    const N = Q(() => {
      var E;
      return (((E = O.default) == null ? void 0 : E.call(O)) || []).every((F) => !F.children);
    });
    return gr(() => {
      m(n) && (document.body.style.overflow = "hidden", T());
    }), (E, F) => (Y(), Ne(wn, { to: e.to }, [
      G("div", {
        class: oe([
          "dialog",
          E.$attrs.class,
          { ["dialog--mobile"]: m(f), ["dialog--dark"]: e.dark }
        ])
      }, [
        G("div", {
          class: oe(m(v)),
          style: Ut(m(b))
        }, [
          G("div", {
            class: oe(m(g)),
            style: Ut(m(M))
          }, [
            G("div", {
              class: oe(m(D))
            }, [
              m(l) ? (Y(), ee("button", {
                key: 0,
                class: "dialog__back",
                onClick: H
              })) : he("", !0),
              Re(E.$slots, "header", {}, () => [
                G("span", Ms, ye(e.title), 1)
              ], !0),
              m(s) ? (Y(), ee("button", {
                key: 1,
                class: "dialog__close",
                onClick: K
              })) : he("", !0)
            ], 2),
            G("div", {
              class: oe(m(w))
            }, [
              Re(E.$slots, "default", {}, void 0, !0)
            ], 2),
            m(j) ? (Y(), ee("div", Bs, [
              Re(E.$slots, "footer", {}, () => [
                m(h) ? (Y(), Ne(Ar, {
                  key: 0,
                  size: "large",
                  type: e.type,
                  hollow: "",
                  bold: "",
                  class: "dialog__cancel",
                  onClick: C
                }, {
                  default: Ie(() => [
                    $t(ye(m(h)), 1)
                  ]),
                  _: 1
                }, 8, ["type"])) : he("", !0),
                m(d) ? (Y(), Ne(Ar, {
                  key: 1,
                  type: e.type,
                  size: "large",
                  bold: "",
                  disabled: e.disabled,
                  loading: e.loading,
                  onClick: $
                }, {
                  default: Ie(() => [
                    $t(ye(m(d)), 1)
                  ]),
                  _: 1
                }, 8, ["type", "disabled", "loading"])) : he("", !0),
                m(h) ? (Y(), Ne(Ar, {
                  key: 2,
                  type: "white",
                  size: "large",
                  bold: "",
                  class: "dialog__cancel-min",
                  onClick: C
                }, {
                  default: Ie(() => [
                    $t(ye(m(h)), 1)
                  ]),
                  _: 1
                })) : he("", !0)
              ], !0)
            ])) : he("", !0)
          ], 6)
        ], 6)
      ], 2)
    ], 8, ["to"]));
  }
})), st = (e, t) => {
  const r = e.__vccOpts || e;
  for (const [n, o] of t)
    r[n] = o;
  return r;
}, Us = /* @__PURE__ */ st(Fs, [["__scopeId", "data-v-a9eea325"]]);
ze(Us);
var Ls = Object.create, oi = Object.defineProperty, Hs = Object.getOwnPropertyDescriptor, zs = Object.getOwnPropertyNames, Ws = Object.getPrototypeOf, Vs = Object.prototype.hasOwnProperty, _e = (e, t) => () => (t || e((t = { exports: {} }).exports, t), t.exports), qs = (e, t, r, n) => {
  if (t && typeof t == "object" || typeof t == "function")
    for (let o of zs(t))
      !Vs.call(e, o) && o !== r && oi(e, o, { get: () => t[o], enumerable: !(n = Hs(t, o)) || n.enumerable });
  return e;
}, Gs = (e, t, r) => (r = e != null ? Ls(Ws(e)) : {}, qs(t || !e || !e.__esModule ? oi(r, "default", { value: e, enumerable: !0 }) : r, e)), Js = _e((e, t) => {
  t.exports = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var r = {}, n = Symbol("test"), o = Object(n);
    if (typeof n == "string" || Object.prototype.toString.call(n) !== "[object Symbol]" || Object.prototype.toString.call(o) !== "[object Symbol]")
      return !1;
    var i = 42;
    r[n] = i;
    for (n in r)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(r).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(r).length !== 0)
      return !1;
    var a = Object.getOwnPropertySymbols(r);
    if (a.length !== 1 || a[0] !== n || !Object.prototype.propertyIsEnumerable.call(r, n))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var l = Object.getOwnPropertyDescriptor(r, n);
      if (l.value !== i || l.enumerable !== !0)
        return !1;
    }
    return !0;
  };
}), Ys = _e((e, t) => {
  var r = typeof Symbol != "undefined" && Symbol, n = Js();
  t.exports = function() {
    return typeof r != "function" || typeof Symbol != "function" || typeof r("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : n();
  };
}), Qs = _e((e, t) => {
  var r = "Function.prototype.bind called on incompatible ", n = Array.prototype.slice, o = Object.prototype.toString, i = "[object Function]";
  t.exports = function(a) {
    var l = this;
    if (typeof l != "function" || o.call(l) !== i)
      throw new TypeError(r + l);
    for (var s = n.call(arguments, 1), h, d = function() {
      if (this instanceof h) {
        var P = l.apply(this, s.concat(n.call(arguments)));
        return Object(P) === P ? P : this;
      } else
        return l.apply(a, s.concat(n.call(arguments)));
    }, S = Math.max(0, l.length - s.length), O = [], p = 0; p < S; p++)
      O.push("$" + p);
    if (h = Function("binder", "return function (" + O.join(",") + "){ return binder.apply(this,arguments); }")(d), l.prototype) {
      var f = function() {
      };
      f.prototype = l.prototype, h.prototype = new f(), f.prototype = null;
    }
    return h;
  };
}), _n = _e((e, t) => {
  var r = Qs();
  t.exports = Function.prototype.bind || r;
}), Ks = _e((e, t) => {
  var r = _n();
  t.exports = r.call(Function.call, Object.prototype.hasOwnProperty);
}), kn = _e((e, t) => {
  var r, n = SyntaxError, o = Function, i = TypeError, a = function(C) {
    try {
      return o('"use strict"; return (' + C + ").constructor;")();
    } catch ($) {
    }
  }, l = Object.getOwnPropertyDescriptor;
  if (l)
    try {
      l({}, "");
    } catch (C) {
      l = null;
    }
  var s = function() {
    throw new i();
  }, h = l ? function() {
    try {
      return arguments.callee, s;
    } catch (C) {
      try {
        return l(arguments, "callee").get;
      } catch ($) {
        return s;
      }
    }
  }() : s, d = Ys()(), S = Object.getPrototypeOf || function(C) {
    return C.__proto__;
  }, O = {}, p = typeof Uint8Array == "undefined" ? r : S(Uint8Array), f = { "%AggregateError%": typeof AggregateError == "undefined" ? r : AggregateError, "%Array%": Array, "%ArrayBuffer%": typeof ArrayBuffer == "undefined" ? r : ArrayBuffer, "%ArrayIteratorPrototype%": d ? S([][Symbol.iterator]()) : r, "%AsyncFromSyncIteratorPrototype%": r, "%AsyncFunction%": O, "%AsyncGenerator%": O, "%AsyncGeneratorFunction%": O, "%AsyncIteratorPrototype%": O, "%Atomics%": typeof Atomics == "undefined" ? r : Atomics, "%BigInt%": typeof BigInt == "undefined" ? r : BigInt, "%BigInt64Array%": typeof BigInt64Array == "undefined" ? r : BigInt64Array, "%BigUint64Array%": typeof BigUint64Array == "undefined" ? r : BigUint64Array, "%Boolean%": Boolean, "%DataView%": typeof DataView == "undefined" ? r : DataView, "%Date%": Date, "%decodeURI%": decodeURI, "%decodeURIComponent%": decodeURIComponent, "%encodeURI%": encodeURI, "%encodeURIComponent%": encodeURIComponent, "%Error%": Error, "%eval%": eval, "%EvalError%": EvalError, "%Float32Array%": typeof Float32Array == "undefined" ? r : Float32Array, "%Float64Array%": typeof Float64Array == "undefined" ? r : Float64Array, "%FinalizationRegistry%": typeof FinalizationRegistry == "undefined" ? r : FinalizationRegistry, "%Function%": o, "%GeneratorFunction%": O, "%Int8Array%": typeof Int8Array == "undefined" ? r : Int8Array, "%Int16Array%": typeof Int16Array == "undefined" ? r : Int16Array, "%Int32Array%": typeof Int32Array == "undefined" ? r : Int32Array, "%isFinite%": isFinite, "%isNaN%": isNaN, "%IteratorPrototype%": d ? S(S([][Symbol.iterator]())) : r, "%JSON%": typeof JSON == "object" ? JSON : r, "%Map%": typeof Map == "undefined" ? r : Map, "%MapIteratorPrototype%": typeof Map == "undefined" || !d ? r : S((/* @__PURE__ */ new Map())[Symbol.iterator]()), "%Math%": Math, "%Number%": Number, "%Object%": Object, "%parseFloat%": parseFloat, "%parseInt%": parseInt, "%Promise%": typeof Promise == "undefined" ? r : Promise, "%Proxy%": typeof Proxy == "undefined" ? r : Proxy, "%RangeError%": RangeError, "%ReferenceError%": ReferenceError, "%Reflect%": typeof Reflect == "undefined" ? r : Reflect, "%RegExp%": RegExp, "%Set%": typeof Set == "undefined" ? r : Set, "%SetIteratorPrototype%": typeof Set == "undefined" || !d ? r : S((/* @__PURE__ */ new Set())[Symbol.iterator]()), "%SharedArrayBuffer%": typeof SharedArrayBuffer == "undefined" ? r : SharedArrayBuffer, "%String%": String, "%StringIteratorPrototype%": d ? S(""[Symbol.iterator]()) : r, "%Symbol%": d ? Symbol : r, "%SyntaxError%": n, "%ThrowTypeError%": h, "%TypedArray%": p, "%TypeError%": i, "%Uint8Array%": typeof Uint8Array == "undefined" ? r : Uint8Array, "%Uint8ClampedArray%": typeof Uint8ClampedArray == "undefined" ? r : Uint8ClampedArray, "%Uint16Array%": typeof Uint16Array == "undefined" ? r : Uint16Array, "%Uint32Array%": typeof Uint32Array == "undefined" ? r : Uint32Array, "%URIError%": URIError, "%WeakMap%": typeof WeakMap == "undefined" ? r : WeakMap, "%WeakRef%": typeof WeakRef == "undefined" ? r : WeakRef, "%WeakSet%": typeof WeakSet == "undefined" ? r : WeakSet };
  try {
    null.error;
  } catch (C) {
    P = S(S(C)), f["%Error.prototype%"] = P;
  }
  var P, k = function C($) {
    var x;
    if ($ === "%AsyncFunction%")
      x = a("async function () {}");
    else if ($ === "%GeneratorFunction%")
      x = a("function* () {}");
    else if ($ === "%AsyncGeneratorFunction%")
      x = a("async function* () {}");
    else if ($ === "%AsyncGenerator%") {
      var T = C("%AsyncGeneratorFunction%");
      T && (x = T.prototype);
    } else if ($ === "%AsyncIteratorPrototype%") {
      var _ = C("%AsyncGenerator%");
      _ && (x = S(_.prototype));
    }
    return f[$] = x, x;
  }, A = { "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"], "%ArrayPrototype%": ["Array", "prototype"], "%ArrayProto_entries%": ["Array", "prototype", "entries"], "%ArrayProto_forEach%": ["Array", "prototype", "forEach"], "%ArrayProto_keys%": ["Array", "prototype", "keys"], "%ArrayProto_values%": ["Array", "prototype", "values"], "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"], "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"], "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"], "%BooleanPrototype%": ["Boolean", "prototype"], "%DataViewPrototype%": ["DataView", "prototype"], "%DatePrototype%": ["Date", "prototype"], "%ErrorPrototype%": ["Error", "prototype"], "%EvalErrorPrototype%": ["EvalError", "prototype"], "%Float32ArrayPrototype%": ["Float32Array", "prototype"], "%Float64ArrayPrototype%": ["Float64Array", "prototype"], "%FunctionPrototype%": ["Function", "prototype"], "%Generator%": ["GeneratorFunction", "prototype"], "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"], "%Int8ArrayPrototype%": ["Int8Array", "prototype"], "%Int16ArrayPrototype%": ["Int16Array", "prototype"], "%Int32ArrayPrototype%": ["Int32Array", "prototype"], "%JSONParse%": ["JSON", "parse"], "%JSONStringify%": ["JSON", "stringify"], "%MapPrototype%": ["Map", "prototype"], "%NumberPrototype%": ["Number", "prototype"], "%ObjectPrototype%": ["Object", "prototype"], "%ObjProto_toString%": ["Object", "prototype", "toString"], "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"], "%PromisePrototype%": ["Promise", "prototype"], "%PromiseProto_then%": ["Promise", "prototype", "then"], "%Promise_all%": ["Promise", "all"], "%Promise_reject%": ["Promise", "reject"], "%Promise_resolve%": ["Promise", "resolve"], "%RangeErrorPrototype%": ["RangeError", "prototype"], "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"], "%RegExpPrototype%": ["RegExp", "prototype"], "%SetPrototype%": ["Set", "prototype"], "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"], "%StringPrototype%": ["String", "prototype"], "%SymbolPrototype%": ["Symbol", "prototype"], "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"], "%TypedArrayPrototype%": ["TypedArray", "prototype"], "%TypeErrorPrototype%": ["TypeError", "prototype"], "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"], "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"], "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"], "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"], "%URIErrorPrototype%": ["URIError", "prototype"], "%WeakMapPrototype%": ["WeakMap", "prototype"], "%WeakSetPrototype%": ["WeakSet", "prototype"] }, u = _n(), v = Ks(), b = u.call(Function.call, Array.prototype.concat), g = u.call(Function.apply, Array.prototype.splice), w = u.call(Function.call, String.prototype.replace), R = u.call(Function.call, String.prototype.slice), D = u.call(Function.call, RegExp.prototype.exec), j = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, M = /\\(\\)?/g, H = function(C) {
    var $ = R(C, 0, 1), x = R(C, -1);
    if ($ === "%" && x !== "%")
      throw new n("invalid intrinsic syntax, expected closing `%`");
    if (x === "%" && $ !== "%")
      throw new n("invalid intrinsic syntax, expected opening `%`");
    var T = [];
    return w(C, j, function(_, N, E, F) {
      T[T.length] = E ? w(F, M, "$1") : N || _;
    }), T;
  }, K = function(C, $) {
    var x = C, T;
    if (v(A, x) && (T = A[x], x = "%" + T[0] + "%"), v(f, x)) {
      var _ = f[x];
      if (_ === O && (_ = k(x)), typeof _ == "undefined" && !$)
        throw new i("intrinsic " + C + " exists, but is not available. Please file an issue!");
      return { alias: T, name: x, value: _ };
    }
    throw new n("intrinsic " + C + " does not exist!");
  };
  t.exports = function(C, $) {
    if (typeof C != "string" || C.length === 0)
      throw new i("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof $ != "boolean")
      throw new i('"allowMissing" argument must be a boolean');
    if (D(/^%?[^%]*%?$/, C) === null)
      throw new n("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var x = H(C), T = x.length > 0 ? x[0] : "", _ = K("%" + T + "%", $), N = _.name, E = _.value, F = !1, V = _.alias;
    V && (T = V[0], g(x, b([0, 1], V)));
    for (var z = 1, W = !0; z < x.length; z += 1) {
      var L = x[z], Z = R(L, 0, 1), te = R(L, -1);
      if ((Z === '"' || Z === "'" || Z === "`" || te === '"' || te === "'" || te === "`") && Z !== te)
        throw new n("property names with quotes must have matching quotes");
      if ((L === "constructor" || !W) && (F = !0), T += "." + L, N = "%" + T + "%", v(f, N))
        E = f[N];
      else if (E != null) {
        if (!(L in E)) {
          if (!$)
            throw new i("base intrinsic for " + C + " exists, but the property is not available.");
          return;
        }
        if (l && z + 1 >= x.length) {
          var re = l(E, L);
          W = !!re, W && "get" in re && !("originalValue" in re.get) ? E = re.get : E = E[L];
        } else
          W = v(E, L), E = E[L];
        W && !F && (f[N] = E);
      }
    }
    return E;
  };
}), Zs = _e((e, t) => {
  var r = _n(), n = kn(), o = n("%Function.prototype.apply%"), i = n("%Function.prototype.call%"), a = n("%Reflect.apply%", !0) || r.call(i, o), l = n("%Object.getOwnPropertyDescriptor%", !0), s = n("%Object.defineProperty%", !0), h = n("%Math.max%");
  if (s)
    try {
      s({}, "a", { value: 1 });
    } catch (S) {
      s = null;
    }
  t.exports = function(S) {
    var O = a(r, i, arguments);
    if (l && s) {
      var p = l(O, "length");
      p.configurable && s(O, "length", { value: 1 + h(0, S.length - (arguments.length - 1)) });
    }
    return O;
  };
  var d = function() {
    return a(r, o, arguments);
  };
  s ? s(t.exports, "apply", { value: d }) : t.exports.apply = d;
}), Xs = _e((e, t) => {
  var r = kn(), n = Zs(), o = n(r("String.prototype.indexOf"));
  t.exports = function(i, a) {
    var l = r(i, !!a);
    return typeof l == "function" && o(i, ".prototype.") > -1 ? n(l) : l;
  };
}), el = _e(() => {
}), tl = _e((e, t) => {
  var r = typeof Map == "function" && Map.prototype, n = Object.getOwnPropertyDescriptor && r ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, o = r && n && typeof n.get == "function" ? n.get : null, i = r && Map.prototype.forEach, a = typeof Set == "function" && Set.prototype, l = Object.getOwnPropertyDescriptor && a ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, s = a && l && typeof l.get == "function" ? l.get : null, h = a && Set.prototype.forEach, d = typeof WeakMap == "function" && WeakMap.prototype, S = d ? WeakMap.prototype.has : null, O = typeof WeakSet == "function" && WeakSet.prototype, p = O ? WeakSet.prototype.has : null, f = typeof WeakRef == "function" && WeakRef.prototype, P = f ? WeakRef.prototype.deref : null, k = Boolean.prototype.valueOf, A = Object.prototype.toString, u = Function.prototype.toString, v = String.prototype.match, b = String.prototype.slice, g = String.prototype.replace, w = String.prototype.toUpperCase, R = String.prototype.toLowerCase, D = RegExp.prototype.test, j = Array.prototype.concat, M = Array.prototype.join, H = Array.prototype.slice, K = Math.floor, C = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, $ = Object.getOwnPropertySymbols, x = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, T = typeof Symbol == "function" && typeof Symbol.iterator == "object", _ = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === T || "symbol") ? Symbol.toStringTag : null, N = Object.prototype.propertyIsEnumerable, E = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(c) {
    return c.__proto__;
  } : null);
  function F(c, y) {
    if (c === 1 / 0 || c === -1 / 0 || c !== c || c && c > -1e3 && c < 1e3 || D.call(/e/, y))
      return y;
    var q = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof c == "number") {
      var J = c < 0 ? -K(-c) : K(c);
      if (J !== c) {
        var X = String(J), U = b.call(y, X.length + 1);
        return g.call(X, q, "$&_") + "." + g.call(g.call(U, /([0-9]{3})/g, "$&_"), /_$/, "");
      }
    }
    return g.call(y, q, "$&_");
  }
  var V = el(), z = V.custom, W = pe(z) ? z : null;
  t.exports = function c(y, q, J, X) {
    var U = q || {};
    if (ce(U, "quoteStyle") && U.quoteStyle !== "single" && U.quoteStyle !== "double")
      throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (ce(U, "maxStringLength") && (typeof U.maxStringLength == "number" ? U.maxStringLength < 0 && U.maxStringLength !== 1 / 0 : U.maxStringLength !== null))
      throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var xe = ce(U, "customInspect") ? U.customInspect : !0;
    if (typeof xe != "boolean" && xe !== "symbol")
      throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if (ce(U, "indent") && U.indent !== null && U.indent !== "	" && !(parseInt(U.indent, 10) === U.indent && U.indent > 0))
      throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if (ce(U, "numericSeparator") && typeof U.numericSeparator != "boolean")
      throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var $e = U.numericSeparator;
    if (typeof y == "undefined")
      return "undefined";
    if (y === null)
      return "null";
    if (typeof y == "boolean")
      return y ? "true" : "false";
    if (typeof y == "string")
      return ft(y, U);
    if (typeof y == "number") {
      if (y === 0)
        return 1 / 0 / y > 0 ? "0" : "-0";
      var ue = String(y);
      return $e ? F(y, ue) : ue;
    }
    if (typeof y == "bigint") {
      var Pe = String(y) + "n";
      return $e ? F(y, Pe) : Pe;
    }
    var At = typeof U.depth == "undefined" ? 5 : U.depth;
    if (typeof J == "undefined" && (J = 0), J >= At && At > 0 && typeof y == "object")
      return te(y) ? "[Array]" : "[Object]";
    var Me = Qr(U, J);
    if (typeof X == "undefined")
      X = [];
    else if (wt(X, y) >= 0)
      return "[Circular]";
    function de(Be, et, Zr) {
      if (et && (X = H.call(X), X.push(et)), Zr) {
        var sr = { depth: U.depth };
        return ce(U, "quoteStyle") && (sr.quoteStyle = U.quoteStyle), c(Be, sr, J + 1, X);
      }
      return c(Be, U, J + 1, X);
    }
    if (typeof y == "function" && !ie(y)) {
      var er = Zt(y), tr = Ze(y, de);
      return "[Function" + (er ? ": " + er : " (anonymous)") + "]" + (tr.length > 0 ? " { " + M.call(tr, ", ") + " }" : "");
    }
    if (pe(y)) {
      var rr = T ? g.call(String(y), /^(Symbol\(.*\))_[^)]*$/, "$1") : x.call(y);
      return typeof y == "object" && !T ? Ce(rr) : rr;
    }
    if (Mt(y)) {
      for (var qe = "<" + R.call(String(y.nodeName)), xt = y.attributes || [], Xe = 0; Xe < xt.length; Xe++)
        qe += " " + xt[Xe].name + "=" + L(Z(xt[Xe].value), "double", U);
      return qe += ">", y.childNodes && y.childNodes.length && (qe += "..."), qe += "</" + R.call(String(y.nodeName)) + ">", qe;
    }
    if (te(y)) {
      if (y.length === 0)
        return "[]";
      var Pt = Ze(y, de);
      return Me && !Yr(Pt) ? "[" + Et(Pt, Me) + "]" : "[ " + M.call(Pt, ", ") + " ]";
    }
    if (ne(y)) {
      var jt = Ze(y, de);
      return !("cause" in Error.prototype) && "cause" in y && !N.call(y, "cause") ? "{ [" + String(y) + "] " + M.call(j.call("[cause]: " + de(y.cause), jt), ", ") + " }" : jt.length === 0 ? "[" + String(y) + "]" : "{ [" + String(y) + "] " + M.call(jt, ", ") + " }";
    }
    if (typeof y == "object" && xe) {
      if (W && typeof y[W] == "function" && V)
        return V(y, { depth: At - J });
      if (xe !== "symbol" && typeof y.inspect == "function")
        return y.inspect();
    }
    if (Ve(y)) {
      var nr = [];
      return i && i.call(y, function(Be, et) {
        nr.push(de(et, y, !0) + " => " + de(Be, y));
      }), Xt("Map", o.call(y), nr, Me);
    }
    if (Dt(y)) {
      var or = [];
      return h && h.call(y, function(Be) {
        or.push(de(Be, y));
      }), Xt("Set", s.call(y), or, Me);
    }
    if (ct(y))
      return Ot("WeakMap");
    if (St(y))
      return Ot("WeakSet");
    if (Tt(y))
      return Ot("WeakRef");
    if (ve(y))
      return Ce(de(Number(y)));
    if (We(y))
      return Ce(de(C.call(y)));
    if (Se(y))
      return Ce(k.call(y));
    if (me(y))
      return Ce(de(String(y)));
    if (!re(y) && !ie(y)) {
      var Rt = Ze(y, de), ir = E ? E(y) === Object.prototype : y instanceof Object || y.constructor === Object, _t = y instanceof Object ? "" : "null prototype", ar = !ir && _ && Object(y) === y && _ in y ? b.call(ae(y), 8, -1) : _t ? "Object" : "", Kr = ir || typeof y.constructor != "function" ? "" : y.constructor.name ? y.constructor.name + " " : "", kt = Kr + (ar || _t ? "[" + M.call(j.call([], ar || [], _t || []), ": ") + "] " : "");
      return Rt.length === 0 ? kt + "{}" : Me ? kt + "{" + Et(Rt, Me) + "}" : kt + "{ " + M.call(Rt, ", ") + " }";
    }
    return String(y);
  };
  function L(c, y, q) {
    var J = (q.quoteStyle || y) === "double" ? '"' : "'";
    return J + c + J;
  }
  function Z(c) {
    return g.call(String(c), /"/g, "&quot;");
  }
  function te(c) {
    return ae(c) === "[object Array]" && (!_ || !(typeof c == "object" && _ in c));
  }
  function re(c) {
    return ae(c) === "[object Date]" && (!_ || !(typeof c == "object" && _ in c));
  }
  function ie(c) {
    return ae(c) === "[object RegExp]" && (!_ || !(typeof c == "object" && _ in c));
  }
  function ne(c) {
    return ae(c) === "[object Error]" && (!_ || !(typeof c == "object" && _ in c));
  }
  function me(c) {
    return ae(c) === "[object String]" && (!_ || !(typeof c == "object" && _ in c));
  }
  function ve(c) {
    return ae(c) === "[object Number]" && (!_ || !(typeof c == "object" && _ in c));
  }
  function Se(c) {
    return ae(c) === "[object Boolean]" && (!_ || !(typeof c == "object" && _ in c));
  }
  function pe(c) {
    if (T)
      return c && typeof c == "object" && c instanceof Symbol;
    if (typeof c == "symbol")
      return !0;
    if (!c || typeof c != "object" || !x)
      return !1;
    try {
      return x.call(c), !0;
    } catch (y) {
    }
    return !1;
  }
  function We(c) {
    if (!c || typeof c != "object" || !C)
      return !1;
    try {
      return C.call(c), !0;
    } catch (y) {
    }
    return !1;
  }
  var Ke = Object.prototype.hasOwnProperty || function(c) {
    return c in this;
  };
  function ce(c, y) {
    return Ke.call(c, y);
  }
  function ae(c) {
    return A.call(c);
  }
  function Zt(c) {
    if (c.name)
      return c.name;
    var y = v.call(u.call(c), /^function\s*([\w$]+)/);
    return y ? y[1] : null;
  }
  function wt(c, y) {
    if (c.indexOf)
      return c.indexOf(y);
    for (var q = 0, J = c.length; q < J; q++)
      if (c[q] === y)
        return q;
    return -1;
  }
  function Ve(c) {
    if (!o || !c || typeof c != "object")
      return !1;
    try {
      o.call(c);
      try {
        s.call(c);
      } catch (y) {
        return !0;
      }
      return c instanceof Map;
    } catch (y) {
    }
    return !1;
  }
  function ct(c) {
    if (!S || !c || typeof c != "object")
      return !1;
    try {
      S.call(c, S);
      try {
        p.call(c, p);
      } catch (y) {
        return !0;
      }
      return c instanceof WeakMap;
    } catch (y) {
    }
    return !1;
  }
  function Tt(c) {
    if (!P || !c || typeof c != "object")
      return !1;
    try {
      return P.call(c), !0;
    } catch (y) {
    }
    return !1;
  }
  function Dt(c) {
    if (!s || !c || typeof c != "object")
      return !1;
    try {
      s.call(c);
      try {
        o.call(c);
      } catch (y) {
        return !0;
      }
      return c instanceof Set;
    } catch (y) {
    }
    return !1;
  }
  function St(c) {
    if (!p || !c || typeof c != "object")
      return !1;
    try {
      p.call(c, p);
      try {
        S.call(c, S);
      } catch (y) {
        return !0;
      }
      return c instanceof WeakSet;
    } catch (y) {
    }
    return !1;
  }
  function Mt(c) {
    return !c || typeof c != "object" ? !1 : typeof HTMLElement != "undefined" && c instanceof HTMLElement ? !0 : typeof c.nodeName == "string" && typeof c.getAttribute == "function";
  }
  function ft(c, y) {
    if (c.length > y.maxStringLength) {
      var q = c.length - y.maxStringLength, J = "... " + q + " more character" + (q > 1 ? "s" : "");
      return ft(b.call(c, 0, y.maxStringLength), y) + J;
    }
    var X = g.call(g.call(c, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, Bt);
    return L(X, "single", y);
  }
  function Bt(c) {
    var y = c.charCodeAt(0), q = { 8: "b", 9: "t", 10: "n", 12: "f", 13: "r" }[y];
    return q ? "\\" + q : "\\x" + (y < 16 ? "0" : "") + w.call(y.toString(16));
  }
  function Ce(c) {
    return "Object(" + c + ")";
  }
  function Ot(c) {
    return c + " { ? }";
  }
  function Xt(c, y, q, J) {
    var X = J ? Et(q, J) : M.call(q, ", ");
    return c + " (" + y + ") {" + X + "}";
  }
  function Yr(c) {
    for (var y = 0; y < c.length; y++)
      if (wt(c[y], `
`) >= 0)
        return !1;
    return !0;
  }
  function Qr(c, y) {
    var q;
    if (c.indent === "	")
      q = "	";
    else if (typeof c.indent == "number" && c.indent > 0)
      q = M.call(Array(c.indent + 1), " ");
    else
      return null;
    return { base: q, prev: M.call(Array(y + 1), q) };
  }
  function Et(c, y) {
    if (c.length === 0)
      return "";
    var q = `
` + y.prev + y.base;
    return q + M.call(c, "," + q) + `
` + y.prev;
  }
  function Ze(c, y) {
    var q = te(c), J = [];
    if (q) {
      J.length = c.length;
      for (var X = 0; X < c.length; X++)
        J[X] = ce(c, X) ? y(c[X], c) : "";
    }
    var U = typeof $ == "function" ? $(c) : [], xe;
    if (T) {
      xe = {};
      for (var $e = 0; $e < U.length; $e++)
        xe["$" + U[$e]] = U[$e];
    }
    for (var ue in c)
      !ce(c, ue) || q && String(Number(ue)) === ue && ue < c.length || T && xe["$" + ue] instanceof Symbol || (D.call(/[^\w$]/, ue) ? J.push(y(ue, c) + ": " + y(c[ue], c)) : J.push(ue + ": " + y(c[ue], c)));
    if (typeof $ == "function")
      for (var Pe = 0; Pe < U.length; Pe++)
        N.call(c, U[Pe]) && J.push("[" + y(U[Pe]) + "]: " + y(c[U[Pe]], c));
    return J;
  }
}), rl = _e((e, t) => {
  var r = kn(), n = Xs(), o = tl(), i = r("%TypeError%"), a = r("%WeakMap%", !0), l = r("%Map%", !0), s = n("WeakMap.prototype.get", !0), h = n("WeakMap.prototype.set", !0), d = n("WeakMap.prototype.has", !0), S = n("Map.prototype.get", !0), O = n("Map.prototype.set", !0), p = n("Map.prototype.has", !0), f = function(u, v) {
    for (var b = u, g; (g = b.next) !== null; b = g)
      if (g.key === v)
        return b.next = g.next, g.next = u.next, u.next = g, g;
  }, P = function(u, v) {
    var b = f(u, v);
    return b && b.value;
  }, k = function(u, v, b) {
    var g = f(u, v);
    g ? g.value = b : u.next = { key: v, next: u.next, value: b };
  }, A = function(u, v) {
    return !!f(u, v);
  };
  t.exports = function() {
    var u, v, b, g = { assert: function(w) {
      if (!g.has(w))
        throw new i("Side channel does not contain " + o(w));
    }, get: function(w) {
      if (a && w && (typeof w == "object" || typeof w == "function")) {
        if (u)
          return s(u, w);
      } else if (l) {
        if (v)
          return S(v, w);
      } else if (b)
        return P(b, w);
    }, has: function(w) {
      if (a && w && (typeof w == "object" || typeof w == "function")) {
        if (u)
          return d(u, w);
      } else if (l) {
        if (v)
          return p(v, w);
      } else if (b)
        return A(b, w);
      return !1;
    }, set: function(w, R) {
      a && w && (typeof w == "object" || typeof w == "function") ? (u || (u = new a()), h(u, w, R)) : l ? (v || (v = new l()), O(v, w, R)) : (b || (b = { key: {}, next: null }), k(b, w, R));
    } };
    return g;
  };
}), $n = _e((e, t) => {
  var r = String.prototype.replace, n = /%20/g, o = { RFC1738: "RFC1738", RFC3986: "RFC3986" };
  t.exports = { default: o.RFC3986, formatters: { RFC1738: function(i) {
    return r.call(i, n, "+");
  }, RFC3986: function(i) {
    return String(i);
  } }, RFC1738: o.RFC1738, RFC3986: o.RFC3986 };
}), ii = _e((e, t) => {
  var r = $n(), n = Object.prototype.hasOwnProperty, o = Array.isArray, i = function() {
    for (var A = [], u = 0; u < 256; ++u)
      A.push("%" + ((u < 16 ? "0" : "") + u.toString(16)).toUpperCase());
    return A;
  }(), a = function(A) {
    for (; A.length > 1; ) {
      var u = A.pop(), v = u.obj[u.prop];
      if (o(v)) {
        for (var b = [], g = 0; g < v.length; ++g)
          typeof v[g] != "undefined" && b.push(v[g]);
        u.obj[u.prop] = b;
      }
    }
  }, l = function(A, u) {
    for (var v = u && u.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, b = 0; b < A.length; ++b)
      typeof A[b] != "undefined" && (v[b] = A[b]);
    return v;
  }, s = function A(u, v, b) {
    if (!v)
      return u;
    if (typeof v != "object") {
      if (o(u))
        u.push(v);
      else if (u && typeof u == "object")
        (b && (b.plainObjects || b.allowPrototypes) || !n.call(Object.prototype, v)) && (u[v] = !0);
      else
        return [u, v];
      return u;
    }
    if (!u || typeof u != "object")
      return [u].concat(v);
    var g = u;
    return o(u) && !o(v) && (g = l(u, b)), o(u) && o(v) ? (v.forEach(function(w, R) {
      if (n.call(u, R)) {
        var D = u[R];
        D && typeof D == "object" && w && typeof w == "object" ? u[R] = A(D, w, b) : u.push(w);
      } else
        u[R] = w;
    }), u) : Object.keys(v).reduce(function(w, R) {
      var D = v[R];
      return n.call(w, R) ? w[R] = A(w[R], D, b) : w[R] = D, w;
    }, g);
  }, h = function(A, u) {
    return Object.keys(u).reduce(function(v, b) {
      return v[b] = u[b], v;
    }, A);
  }, d = function(A, u, v) {
    var b = A.replace(/\+/g, " ");
    if (v === "iso-8859-1")
      return b.replace(/%[0-9a-f]{2}/gi, unescape);
    try {
      return decodeURIComponent(b);
    } catch (g) {
      return b;
    }
  }, S = function(A, u, v, b, g) {
    if (A.length === 0)
      return A;
    var w = A;
    if (typeof A == "symbol" ? w = Symbol.prototype.toString.call(A) : typeof A != "string" && (w = String(A)), v === "iso-8859-1")
      return escape(w).replace(/%u[0-9a-f]{4}/gi, function(M) {
        return "%26%23" + parseInt(M.slice(2), 16) + "%3B";
      });
    for (var R = "", D = 0; D < w.length; ++D) {
      var j = w.charCodeAt(D);
      if (j === 45 || j === 46 || j === 95 || j === 126 || j >= 48 && j <= 57 || j >= 65 && j <= 90 || j >= 97 && j <= 122 || g === r.RFC1738 && (j === 40 || j === 41)) {
        R += w.charAt(D);
        continue;
      }
      if (j < 128) {
        R = R + i[j];
        continue;
      }
      if (j < 2048) {
        R = R + (i[192 | j >> 6] + i[128 | j & 63]);
        continue;
      }
      if (j < 55296 || j >= 57344) {
        R = R + (i[224 | j >> 12] + i[128 | j >> 6 & 63] + i[128 | j & 63]);
        continue;
      }
      D += 1, j = 65536 + ((j & 1023) << 10 | w.charCodeAt(D) & 1023), R += i[240 | j >> 18] + i[128 | j >> 12 & 63] + i[128 | j >> 6 & 63] + i[128 | j & 63];
    }
    return R;
  }, O = function(A) {
    for (var u = [{ obj: { o: A }, prop: "o" }], v = [], b = 0; b < u.length; ++b)
      for (var g = u[b], w = g.obj[g.prop], R = Object.keys(w), D = 0; D < R.length; ++D) {
        var j = R[D], M = w[j];
        typeof M == "object" && M !== null && v.indexOf(M) === -1 && (u.push({ obj: w, prop: j }), v.push(M));
      }
    return a(u), A;
  }, p = function(A) {
    return Object.prototype.toString.call(A) === "[object RegExp]";
  }, f = function(A) {
    return !A || typeof A != "object" ? !1 : !!(A.constructor && A.constructor.isBuffer && A.constructor.isBuffer(A));
  }, P = function(A, u) {
    return [].concat(A, u);
  }, k = function(A, u) {
    if (o(A)) {
      for (var v = [], b = 0; b < A.length; b += 1)
        v.push(u(A[b]));
      return v;
    }
    return u(A);
  };
  t.exports = { arrayToObject: l, assign: h, combine: P, compact: O, decode: d, encode: S, isBuffer: f, isRegExp: p, maybeMap: k, merge: s };
}), nl = _e((e, t) => {
  var r = rl(), n = ii(), o = $n(), i = Object.prototype.hasOwnProperty, a = { brackets: function(u) {
    return u + "[]";
  }, comma: "comma", indices: function(u, v) {
    return u + "[" + v + "]";
  }, repeat: function(u) {
    return u;
  } }, l = Array.isArray, s = String.prototype.split, h = Array.prototype.push, d = function(u, v) {
    h.apply(u, l(v) ? v : [v]);
  }, S = Date.prototype.toISOString, O = o.default, p = { addQueryPrefix: !1, allowDots: !1, charset: "utf-8", charsetSentinel: !1, delimiter: "&", encode: !0, encoder: n.encode, encodeValuesOnly: !1, format: O, formatter: o.formatters[O], indices: !1, serializeDate: function(u) {
    return S.call(u);
  }, skipNulls: !1, strictNullHandling: !1 }, f = function(u) {
    return typeof u == "string" || typeof u == "number" || typeof u == "boolean" || typeof u == "symbol" || typeof u == "bigint";
  }, P = {}, k = function u(v, b, g, w, R, D, j, M, H, K, C, $, x, T, _, N) {
    for (var E = v, F = N, V = 0, z = !1; (F = F.get(P)) !== void 0 && !z; ) {
      var W = F.get(v);
      if (V += 1, typeof W != "undefined") {
        if (W === V)
          throw new RangeError("Cyclic object value");
        z = !0;
      }
      typeof F.get(P) == "undefined" && (V = 0);
    }
    if (typeof M == "function" ? E = M(b, E) : E instanceof Date ? E = C(E) : g === "comma" && l(E) && (E = n.maybeMap(E, function(ae) {
      return ae instanceof Date ? C(ae) : ae;
    })), E === null) {
      if (R)
        return j && !T ? j(b, p.encoder, _, "key", $) : b;
      E = "";
    }
    if (f(E) || n.isBuffer(E)) {
      if (j) {
        var L = T ? b : j(b, p.encoder, _, "key", $);
        if (g === "comma" && T) {
          for (var Z = s.call(String(E), ","), te = "", re = 0; re < Z.length; ++re)
            te += (re === 0 ? "" : ",") + x(j(Z[re], p.encoder, _, "value", $));
          return [x(L) + (w && l(E) && Z.length === 1 ? "[]" : "") + "=" + te];
        }
        return [x(L) + "=" + x(j(E, p.encoder, _, "value", $))];
      }
      return [x(b) + "=" + x(String(E))];
    }
    var ie = [];
    if (typeof E == "undefined")
      return ie;
    var ne;
    if (g === "comma" && l(E))
      ne = [{ value: E.length > 0 ? E.join(",") || null : void 0 }];
    else if (l(M))
      ne = M;
    else {
      var me = Object.keys(E);
      ne = H ? me.sort(H) : me;
    }
    for (var ve = w && l(E) && E.length === 1 ? b + "[]" : b, Se = 0; Se < ne.length; ++Se) {
      var pe = ne[Se], We = typeof pe == "object" && typeof pe.value != "undefined" ? pe.value : E[pe];
      if (!(D && We === null)) {
        var Ke = l(E) ? typeof g == "function" ? g(ve, pe) : ve : ve + (K ? "." + pe : "[" + pe + "]");
        N.set(v, V);
        var ce = r();
        ce.set(P, N), d(ie, u(We, Ke, g, w, R, D, j, M, H, K, C, $, x, T, _, ce));
      }
    }
    return ie;
  }, A = function(u) {
    if (!u)
      return p;
    if (u.encoder !== null && typeof u.encoder != "undefined" && typeof u.encoder != "function")
      throw new TypeError("Encoder has to be a function.");
    var v = u.charset || p.charset;
    if (typeof u.charset != "undefined" && u.charset !== "utf-8" && u.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var b = o.default;
    if (typeof u.format != "undefined") {
      if (!i.call(o.formatters, u.format))
        throw new TypeError("Unknown format option provided.");
      b = u.format;
    }
    var g = o.formatters[b], w = p.filter;
    return (typeof u.filter == "function" || l(u.filter)) && (w = u.filter), { addQueryPrefix: typeof u.addQueryPrefix == "boolean" ? u.addQueryPrefix : p.addQueryPrefix, allowDots: typeof u.allowDots == "undefined" ? p.allowDots : !!u.allowDots, charset: v, charsetSentinel: typeof u.charsetSentinel == "boolean" ? u.charsetSentinel : p.charsetSentinel, delimiter: typeof u.delimiter == "undefined" ? p.delimiter : u.delimiter, encode: typeof u.encode == "boolean" ? u.encode : p.encode, encoder: typeof u.encoder == "function" ? u.encoder : p.encoder, encodeValuesOnly: typeof u.encodeValuesOnly == "boolean" ? u.encodeValuesOnly : p.encodeValuesOnly, filter: w, format: b, formatter: g, serializeDate: typeof u.serializeDate == "function" ? u.serializeDate : p.serializeDate, skipNulls: typeof u.skipNulls == "boolean" ? u.skipNulls : p.skipNulls, sort: typeof u.sort == "function" ? u.sort : null, strictNullHandling: typeof u.strictNullHandling == "boolean" ? u.strictNullHandling : p.strictNullHandling };
  };
  t.exports = function(u, v) {
    var b = u, g = A(v), w, R;
    typeof g.filter == "function" ? (R = g.filter, b = R("", b)) : l(g.filter) && (R = g.filter, w = R);
    var D = [];
    if (typeof b != "object" || b === null)
      return "";
    var j;
    v && v.arrayFormat in a ? j = v.arrayFormat : v && "indices" in v ? j = v.indices ? "indices" : "repeat" : j = "indices";
    var M = a[j];
    if (v && "commaRoundTrip" in v && typeof v.commaRoundTrip != "boolean")
      throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var H = M === "comma" && v && v.commaRoundTrip;
    w || (w = Object.keys(b)), g.sort && w.sort(g.sort);
    for (var K = r(), C = 0; C < w.length; ++C) {
      var $ = w[C];
      g.skipNulls && b[$] === null || d(D, k(b[$], $, M, H, g.strictNullHandling, g.skipNulls, g.encode ? g.encoder : null, g.filter, g.sort, g.allowDots, g.serializeDate, g.format, g.formatter, g.encodeValuesOnly, g.charset, K));
    }
    var x = D.join(g.delimiter), T = g.addQueryPrefix === !0 ? "?" : "";
    return g.charsetSentinel && (g.charset === "iso-8859-1" ? T += "utf8=%26%2310003%3B&" : T += "utf8=%E2%9C%93&"), x.length > 0 ? T + x : "";
  };
}), ol = _e((e, t) => {
  var r = ii(), n = Object.prototype.hasOwnProperty, o = Array.isArray, i = { allowDots: !1, allowPrototypes: !1, allowSparse: !1, arrayLimit: 20, charset: "utf-8", charsetSentinel: !1, comma: !1, decoder: r.decode, delimiter: "&", depth: 5, ignoreQueryPrefix: !1, interpretNumericEntities: !1, parameterLimit: 1e3, parseArrays: !0, plainObjects: !1, strictNullHandling: !1 }, a = function(f) {
    return f.replace(/&#(\d+);/g, function(P, k) {
      return String.fromCharCode(parseInt(k, 10));
    });
  }, l = function(f, P) {
    return f && typeof f == "string" && P.comma && f.indexOf(",") > -1 ? f.split(",") : f;
  }, s = "utf8=%26%2310003%3B", h = "utf8=%E2%9C%93", d = function(f, P) {
    var k = {}, A = P.ignoreQueryPrefix ? f.replace(/^\?/, "") : f, u = P.parameterLimit === 1 / 0 ? void 0 : P.parameterLimit, v = A.split(P.delimiter, u), b = -1, g, w = P.charset;
    if (P.charsetSentinel)
      for (g = 0; g < v.length; ++g)
        v[g].indexOf("utf8=") === 0 && (v[g] === h ? w = "utf-8" : v[g] === s && (w = "iso-8859-1"), b = g, g = v.length);
    for (g = 0; g < v.length; ++g)
      if (g !== b) {
        var R = v[g], D = R.indexOf("]="), j = D === -1 ? R.indexOf("=") : D + 1, M, H;
        j === -1 ? (M = P.decoder(R, i.decoder, w, "key"), H = P.strictNullHandling ? null : "") : (M = P.decoder(R.slice(0, j), i.decoder, w, "key"), H = r.maybeMap(l(R.slice(j + 1), P), function(K) {
          return P.decoder(K, i.decoder, w, "value");
        })), H && P.interpretNumericEntities && w === "iso-8859-1" && (H = a(H)), R.indexOf("[]=") > -1 && (H = o(H) ? [H] : H), n.call(k, M) ? k[M] = r.combine(k[M], H) : k[M] = H;
      }
    return k;
  }, S = function(f, P, k, A) {
    for (var u = A ? P : l(P, k), v = f.length - 1; v >= 0; --v) {
      var b, g = f[v];
      if (g === "[]" && k.parseArrays)
        b = [].concat(u);
      else {
        b = k.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
        var w = g.charAt(0) === "[" && g.charAt(g.length - 1) === "]" ? g.slice(1, -1) : g, R = parseInt(w, 10);
        !k.parseArrays && w === "" ? b = { 0: u } : !isNaN(R) && g !== w && String(R) === w && R >= 0 && k.parseArrays && R <= k.arrayLimit ? (b = [], b[R] = u) : w !== "__proto__" && (b[w] = u);
      }
      u = b;
    }
    return u;
  }, O = function(f, P, k, A) {
    if (f) {
      var u = k.allowDots ? f.replace(/\.([^.[]+)/g, "[$1]") : f, v = /(\[[^[\]]*])/, b = /(\[[^[\]]*])/g, g = k.depth > 0 && v.exec(u), w = g ? u.slice(0, g.index) : u, R = [];
      if (w) {
        if (!k.plainObjects && n.call(Object.prototype, w) && !k.allowPrototypes)
          return;
        R.push(w);
      }
      for (var D = 0; k.depth > 0 && (g = b.exec(u)) !== null && D < k.depth; ) {
        if (D += 1, !k.plainObjects && n.call(Object.prototype, g[1].slice(1, -1)) && !k.allowPrototypes)
          return;
        R.push(g[1]);
      }
      return g && R.push("[" + u.slice(g.index) + "]"), S(R, P, k, A);
    }
  }, p = function(f) {
    if (!f)
      return i;
    if (f.decoder !== null && f.decoder !== void 0 && typeof f.decoder != "function")
      throw new TypeError("Decoder has to be a function.");
    if (typeof f.charset != "undefined" && f.charset !== "utf-8" && f.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var P = typeof f.charset == "undefined" ? i.charset : f.charset;
    return { allowDots: typeof f.allowDots == "undefined" ? i.allowDots : !!f.allowDots, allowPrototypes: typeof f.allowPrototypes == "boolean" ? f.allowPrototypes : i.allowPrototypes, allowSparse: typeof f.allowSparse == "boolean" ? f.allowSparse : i.allowSparse, arrayLimit: typeof f.arrayLimit == "number" ? f.arrayLimit : i.arrayLimit, charset: P, charsetSentinel: typeof f.charsetSentinel == "boolean" ? f.charsetSentinel : i.charsetSentinel, comma: typeof f.comma == "boolean" ? f.comma : i.comma, decoder: typeof f.decoder == "function" ? f.decoder : i.decoder, delimiter: typeof f.delimiter == "string" || r.isRegExp(f.delimiter) ? f.delimiter : i.delimiter, depth: typeof f.depth == "number" || f.depth === !1 ? +f.depth : i.depth, ignoreQueryPrefix: f.ignoreQueryPrefix === !0, interpretNumericEntities: typeof f.interpretNumericEntities == "boolean" ? f.interpretNumericEntities : i.interpretNumericEntities, parameterLimit: typeof f.parameterLimit == "number" ? f.parameterLimit : i.parameterLimit, parseArrays: f.parseArrays !== !1, plainObjects: typeof f.plainObjects == "boolean" ? f.plainObjects : i.plainObjects, strictNullHandling: typeof f.strictNullHandling == "boolean" ? f.strictNullHandling : i.strictNullHandling };
  };
  t.exports = function(f, P) {
    var k = p(P);
    if (f === "" || f === null || typeof f == "undefined")
      return k.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
    for (var A = typeof f == "string" ? d(f, k) : f, u = k.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, v = Object.keys(A), b = 0; b < v.length; ++b) {
      var g = v[b], w = O(g, A[g], k, typeof f == "string");
      u = r.merge(u, w, k);
    }
    return k.allowSparse === !0 ? u : r.compact(u);
  };
}), il = _e((e, t) => {
  var r = nl(), n = ol(), o = $n();
  t.exports = { formats: o, parse: n, stringify: r };
}), al = (e) => {
  var t, r, n, o, i, a;
  let l = typeof window != "undefined";
  if (!e && !l)
    return { inBrowser: l };
  let s = e != null ? e : window.navigator.userAgent;
  return { inBrowser: l, isAndroid: s.includes("Android") || s.includes("Adr"), androidVersion: (r = (t = s.match(/Android\s*([\d|\\.]+)/)) == null ? void 0 : t[1]) != null ? r : "0", iosVersion: ((o = (n = s.match(/\s*OS\s*([\d|\\_]+)/)) == null ? void 0 : n[1]) != null ? o : "0").replace(/_/g, "."), isiOS: /iPad|iPhone|iPod/.test(s), isSafari: s.includes("Safari") && !s.includes("Chrome"), isOpera: !!window.opr && !!window.opr.addons || !!window.opera || s.includes("OPR/"), isChrome: s.includes("Chrome"), isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(s), isInApp: /bstar_[a|i]/i.test(s), safariVersion: (a = (i = s.match(/[v|V]ersion\/([\w|.]+)/)) == null ? void 0 : i[1]) != null ? a : "0" };
}, lo = al();
function ai(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
var { toString: si } = Object.prototype, { getPrototypeOf: Cn } = Object, Nn = ((e) => (t) => {
  let r = si.call(t);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), lt = (e) => (e = e.toLowerCase(), (t) => Nn(t) === e), Fr = (e) => (t) => typeof t === e, { isArray: Qt } = Array, hr = Fr("undefined");
function sl(e) {
  return e !== null && !hr(e) && e.constructor !== null && !hr(e.constructor) && gt(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
var li = lt("ArrayBuffer");
function ll(e) {
  let t;
  return typeof ArrayBuffer != "undefined" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && li(e.buffer), t;
}
var ul = Fr("string"), gt = Fr("function"), ui = Fr("number"), Tn = (e) => e !== null && typeof e == "object", cl = (e) => e === !0 || e === !1, Pr = (e) => {
  if (Nn(e) !== "object")
    return !1;
  let t = Cn(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, fl = lt("Date"), pl = lt("File"), dl = lt("Blob"), yl = lt("FileList"), hl = (e) => Tn(e) && gt(e.pipe), ml = (e) => {
  let t = "[object FormData]";
  return e && (typeof FormData == "function" && e instanceof FormData || si.call(e) === t || gt(e.toString) && e.toString() === t);
}, gl = lt("URLSearchParams"), vl = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function wr(e, t, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e == "undefined")
    return;
  let n, o;
  if (typeof e != "object" && (e = [e]), Qt(e))
    for (n = 0, o = e.length; n < o; n++)
      t.call(null, e[n], n, e);
  else {
    let i = r ? Object.getOwnPropertyNames(e) : Object.keys(e), a = i.length, l;
    for (n = 0; n < a; n++)
      l = i[n], t.call(null, e[l], l, e);
  }
}
function ci(e, t) {
  t = t.toLowerCase();
  let r = Object.keys(e), n = r.length, o;
  for (; n-- > 0; )
    if (o = r[n], t === o.toLowerCase())
      return o;
  return null;
}
var fi = (() => typeof globalThis != "undefined" ? globalThis : typeof self != "undefined" ? self : typeof window != "undefined" ? window : global)(), pi = (e) => !hr(e) && e !== fi;
function fn() {
  let { caseless: e } = pi(this) && this || {}, t = {}, r = (n, o) => {
    let i = e && ci(t, o) || o;
    Pr(t[i]) && Pr(n) ? t[i] = fn(t[i], n) : Pr(n) ? t[i] = fn({}, n) : Qt(n) ? t[i] = n.slice() : t[i] = n;
  };
  for (let n = 0, o = arguments.length; n < o; n++)
    arguments[n] && wr(arguments[n], r);
  return t;
}
var bl = (e, t, r, { allOwnKeys: n } = {}) => (wr(t, (o, i) => {
  r && gt(o) ? e[i] = ai(o, r) : e[i] = o;
}, { allOwnKeys: n }), e), wl = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), Sl = (e, t, r, n) => {
  e.prototype = Object.create(t.prototype, n), e.prototype.constructor = e, Object.defineProperty(e, "super", { value: t.prototype }), r && Object.assign(e.prototype, r);
}, Ol = (e, t, r, n) => {
  let o, i, a, l = {};
  if (t = t || {}, e == null)
    return t;
  do {
    for (o = Object.getOwnPropertyNames(e), i = o.length; i-- > 0; )
      a = o[i], (!n || n(a, e, t)) && !l[a] && (t[a] = e[a], l[a] = !0);
    e = r !== !1 && Cn(e);
  } while (e && (!r || r(e, t)) && e !== Object.prototype);
  return t;
}, El = (e, t, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= t.length;
  let n = e.indexOf(t, r);
  return n !== -1 && n === r;
}, Al = (e) => {
  if (!e)
    return null;
  if (Qt(e))
    return e;
  let t = e.length;
  if (!ui(t))
    return null;
  let r = new Array(t);
  for (; t-- > 0; )
    r[t] = e[t];
  return r;
}, xl = ((e) => (t) => e && t instanceof e)(typeof Uint8Array != "undefined" && Cn(Uint8Array)), Pl = (e, t) => {
  let r = (e && e[Symbol.iterator]).call(e), n;
  for (; (n = r.next()) && !n.done; ) {
    let o = n.value;
    t.call(e, o[0], o[1]);
  }
}, jl = (e, t) => {
  let r, n = [];
  for (; (r = e.exec(t)) !== null; )
    n.push(r);
  return n;
}, Rl = lt("HTMLFormElement"), _l = (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(t, r, n) {
  return r.toUpperCase() + n;
}), uo = (({ hasOwnProperty: e }) => (t, r) => e.call(t, r))(Object.prototype), kl = lt("RegExp"), di = (e, t) => {
  let r = Object.getOwnPropertyDescriptors(e), n = {};
  wr(r, (o, i) => {
    t(o, i, e) !== !1 && (n[i] = o);
  }), Object.defineProperties(e, n);
}, $l = (e) => {
  di(e, (t, r) => {
    if (gt(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    let n = e[r];
    if (gt(n)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, Cl = (e, t) => {
  let r = {}, n = (o) => {
    o.forEach((i) => {
      r[i] = !0;
    });
  };
  return Qt(e) ? n(e) : n(String(e).split(t)), r;
}, Nl = () => {
}, Tl = (e, t) => (e = +e, Number.isFinite(e) ? e : t), Xr = "abcdefghijklmnopqrstuvwxyz", co = "0123456789", yi = { DIGIT: co, ALPHA: Xr, ALPHA_DIGIT: Xr + Xr.toUpperCase() + co }, Dl = (e = 16, t = yi.ALPHA_DIGIT) => {
  let r = "", { length: n } = t;
  for (; e--; )
    r += t[Math.random() * n | 0];
  return r;
};
function Ml(e) {
  return !!(e && gt(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
var Bl = (e) => {
  let t = new Array(10), r = (n, o) => {
    if (Tn(n)) {
      if (t.indexOf(n) >= 0)
        return;
      if (!("toJSON" in n)) {
        t[o] = n;
        let i = Qt(n) ? [] : {};
        return wr(n, (a, l) => {
          let s = r(a, o + 1);
          !hr(s) && (i[l] = s);
        }), t[o] = void 0, i;
      }
    }
    return n;
  };
  return r(e, 0);
}, B = { isArray: Qt, isArrayBuffer: li, isBuffer: sl, isFormData: ml, isArrayBufferView: ll, isString: ul, isNumber: ui, isBoolean: cl, isObject: Tn, isPlainObject: Pr, isUndefined: hr, isDate: fl, isFile: pl, isBlob: dl, isRegExp: kl, isFunction: gt, isStream: hl, isURLSearchParams: gl, isTypedArray: xl, isFileList: yl, forEach: wr, merge: fn, extend: bl, trim: vl, stripBOM: wl, inherits: Sl, toFlatObject: Ol, kindOf: Nn, kindOfTest: lt, endsWith: El, toArray: Al, forEachEntry: Pl, matchAll: jl, isHTMLForm: Rl, hasOwnProperty: uo, hasOwnProp: uo, reduceDescriptors: di, freezeMethods: $l, toObjectSet: Cl, toCamelCase: _l, noop: Nl, toFiniteNumber: Tl, findKey: ci, global: fi, isContextDefined: pi, ALPHABET: yi, generateString: Dl, isSpecCompliantForm: Ml, toJSONObject: Bl };
function qt(e, t, r, n, o) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), r && (this.config = r), n && (this.request = n), o && (this.response = o);
}
B.inherits(qt, Error, { toJSON: function() {
  return { message: this.message, name: this.name, description: this.description, number: this.number, fileName: this.fileName, lineNumber: this.lineNumber, columnNumber: this.columnNumber, stack: this.stack, config: B.toJSONObject(this.config), code: this.code, status: this.response && this.response.status ? this.response.status : null };
} });
var hi = qt.prototype, mi = {};
["ERR_BAD_OPTION_VALUE", "ERR_BAD_OPTION", "ECONNABORTED", "ETIMEDOUT", "ERR_NETWORK", "ERR_FR_TOO_MANY_REDIRECTS", "ERR_DEPRECATED", "ERR_BAD_RESPONSE", "ERR_BAD_REQUEST", "ERR_CANCELED", "ERR_NOT_SUPPORT", "ERR_INVALID_URL"].forEach((e) => {
  mi[e] = { value: e };
});
Object.defineProperties(qt, mi);
Object.defineProperty(hi, "isAxiosError", { value: !0 });
qt.from = (e, t, r, n, o, i) => {
  let a = Object.create(hi);
  return B.toFlatObject(e, a, function(l) {
    return l !== Error.prototype;
  }, (l) => l !== "isAxiosError"), qt.call(a, e.message, t, r, n, o), a.cause = e, a.name = e.name, i && Object.assign(a, i), a;
};
var se = qt, Il = null;
function pn(e) {
  return B.isPlainObject(e) || B.isArray(e);
}
function gi(e) {
  return B.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function fo(e, t, r) {
  return e ? e.concat(t).map(function(n, o) {
    return n = gi(n), !r && o ? "[" + n + "]" : n;
  }).join(r ? "." : "") : t;
}
function Fl(e) {
  return B.isArray(e) && !e.some(pn);
}
var Ul = B.toFlatObject(B, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function Ll(e, t, r) {
  if (!B.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), r = B.toFlatObject(r, { metaTokens: !0, dots: !1, indexes: !1 }, !1, function(p, f) {
    return !B.isUndefined(f[p]);
  });
  let n = r.metaTokens, o = r.visitor || h, i = r.dots, a = r.indexes, l = (r.Blob || typeof Blob != "undefined" && Blob) && B.isSpecCompliantForm(t);
  if (!B.isFunction(o))
    throw new TypeError("visitor must be a function");
  function s(p) {
    if (p === null)
      return "";
    if (B.isDate(p))
      return p.toISOString();
    if (!l && B.isBlob(p))
      throw new se("Blob is not supported. Use a Buffer instead.");
    return B.isArrayBuffer(p) || B.isTypedArray(p) ? l && typeof Blob == "function" ? new Blob([p]) : Buffer.from(p) : p;
  }
  function h(p, f, P) {
    let k = p;
    if (p && !P && typeof p == "object") {
      if (B.endsWith(f, "{}"))
        f = n ? f : f.slice(0, -2), p = JSON.stringify(p);
      else if (B.isArray(p) && Fl(p) || (B.isFileList(p) || B.endsWith(f, "[]")) && (k = B.toArray(p)))
        return f = gi(f), k.forEach(function(A, u) {
          !(B.isUndefined(A) || A === null) && t.append(a === !0 ? fo([f], u, i) : a === null ? f : f + "[]", s(A));
        }), !1;
    }
    return pn(p) ? !0 : (t.append(fo(P, f, i), s(p)), !1);
  }
  let d = [], S = Object.assign(Ul, { defaultVisitor: h, convertValue: s, isVisitable: pn });
  function O(p, f) {
    if (!B.isUndefined(p)) {
      if (d.indexOf(p) !== -1)
        throw Error("Circular reference detected in " + f.join("."));
      d.push(p), B.forEach(p, function(P, k) {
        (!(B.isUndefined(P) || P === null) && o.call(t, P, B.isString(k) ? k.trim() : k, f, S)) === !0 && O(P, f ? f.concat(k) : [k]);
      }), d.pop();
    }
  }
  if (!B.isObject(e))
    throw new TypeError("data must be an object");
  return O(e), t;
}
var Ur = Ll;
function po(e) {
  let t = { "!": "%21", "'": "%27", "(": "%28", ")": "%29", "~": "%7E", "%20": "+", "%00": "\0" };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return t[r];
  });
}
function vi(e, t) {
  this._pairs = [], e && Ur(e, this, t);
}
var bi = vi.prototype;
bi.append = function(e, t) {
  this._pairs.push([e, t]);
};
bi.toString = function(e) {
  let t = e ? function(r) {
    return e.call(this, r, po);
  } : po;
  return this._pairs.map(function(r) {
    return t(r[0]) + "=" + t(r[1]);
  }, "").join("&");
};
var wi = vi;
function Hl(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function Si(e, t, r) {
  if (!t)
    return e;
  let n = r && r.encode || Hl, o = r && r.serialize, i;
  if (o ? i = o(t, r) : i = B.isURLSearchParams(t) ? t.toString() : new wi(t, r).toString(n), i) {
    let a = e.indexOf("#");
    a !== -1 && (e = e.slice(0, a)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
var zl = class {
  constructor() {
    this.handlers = [];
  }
  use(t, r, n) {
    return this.handlers.push({ fulfilled: t, rejected: r, synchronous: n ? n.synchronous : !1, runWhen: n ? n.runWhen : null }), this.handlers.length - 1;
  }
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  clear() {
    this.handlers && (this.handlers = []);
  }
  forEach(t) {
    B.forEach(this.handlers, function(r) {
      r !== null && t(r);
    });
  }
}, yo = zl, Oi = { silentJSONParsing: !0, forcedJSONParsing: !0, clarifyTimeoutError: !1 }, Wl = typeof URLSearchParams != "undefined" ? URLSearchParams : wi, Vl = typeof FormData != "undefined" ? FormData : null, ql = typeof Blob != "undefined" ? Blob : null, Gl = (() => {
  let e;
  return typeof navigator != "undefined" && ((e = navigator.product) === "ReactNative" || e === "NativeScript" || e === "NS") ? !1 : typeof window != "undefined" && typeof document != "undefined";
})(), Jl = (() => typeof WorkerGlobalScope != "undefined" && self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), Ge = { isBrowser: !0, classes: { URLSearchParams: Wl, FormData: Vl, Blob: ql }, isStandardBrowserEnv: Gl, isStandardBrowserWebWorkerEnv: Jl, protocols: ["http", "https", "file", "blob", "url", "data"] };
function Yl(e, t) {
  return Ur(e, new Ge.classes.URLSearchParams(), Object.assign({ visitor: function(r, n, o, i) {
    return Ge.isNode && B.isBuffer(r) ? (this.append(n, r.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
  } }, t));
}
function Ql(e) {
  return B.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function Kl(e) {
  let t = {}, r = Object.keys(e), n, o = r.length, i;
  for (n = 0; n < o; n++)
    i = r[n], t[i] = e[i];
  return t;
}
function Zl(e) {
  function t(r, n, o, i) {
    let a = r[i++], l = Number.isFinite(+a), s = i >= r.length;
    return a = !a && B.isArray(o) ? o.length : a, s ? (B.hasOwnProp(o, a) ? o[a] = [o[a], n] : o[a] = n, !l) : ((!o[a] || !B.isObject(o[a])) && (o[a] = []), t(r, n, o[a], i) && B.isArray(o[a]) && (o[a] = Kl(o[a])), !l);
  }
  if (B.isFormData(e) && B.isFunction(e.entries)) {
    let r = {};
    return B.forEachEntry(e, (n, o) => {
      t(Ql(n), o, r, 0);
    }), r;
  }
  return null;
}
var Ei = Zl, Xl = { "Content-Type": void 0 };
function eu(e, t, r) {
  if (B.isString(e))
    try {
      return (t || JSON.parse)(e), B.trim(e);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (r || JSON.stringify)(e);
}
var Lr = { transitional: Oi, adapter: ["xhr", "http"], transformRequest: [function(e, t) {
  let r = t.getContentType() || "", n = r.indexOf("application/json") > -1, o = B.isObject(e);
  if (o && B.isHTMLForm(e) && (e = new FormData(e)), B.isFormData(e))
    return n && n ? JSON.stringify(Ei(e)) : e;
  if (B.isArrayBuffer(e) || B.isBuffer(e) || B.isStream(e) || B.isFile(e) || B.isBlob(e))
    return e;
  if (B.isArrayBufferView(e))
    return e.buffer;
  if (B.isURLSearchParams(e))
    return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
  let i;
  if (o) {
    if (r.indexOf("application/x-www-form-urlencoded") > -1)
      return Yl(e, this.formSerializer).toString();
    if ((i = B.isFileList(e)) || r.indexOf("multipart/form-data") > -1) {
      let a = this.env && this.env.FormData;
      return Ur(i ? { "files[]": e } : e, a && new a(), this.formSerializer);
    }
  }
  return o || n ? (t.setContentType("application/json", !1), eu(e)) : e;
}], transformResponse: [function(e) {
  let t = this.transitional || Lr.transitional, r = t && t.forcedJSONParsing, n = this.responseType === "json";
  if (e && B.isString(e) && (r && !this.responseType || n)) {
    let o = !(t && t.silentJSONParsing) && n;
    try {
      return JSON.parse(e);
    } catch (i) {
      if (o)
        throw i.name === "SyntaxError" ? se.from(i, se.ERR_BAD_RESPONSE, this, null, this.response) : i;
    }
  }
  return e;
}], timeout: 0, xsrfCookieName: "XSRF-TOKEN", xsrfHeaderName: "X-XSRF-TOKEN", maxContentLength: -1, maxBodyLength: -1, env: { FormData: Ge.classes.FormData, Blob: Ge.classes.Blob }, validateStatus: function(e) {
  return e >= 200 && e < 300;
}, headers: { common: { Accept: "application/json, text/plain, */*" } } };
B.forEach(["delete", "get", "head"], function(e) {
  Lr.headers[e] = {};
});
B.forEach(["post", "put", "patch"], function(e) {
  Lr.headers[e] = B.merge(Xl);
});
var Dn = Lr, tu = B.toObjectSet(["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"]), ru = (e) => {
  let t = {}, r, n, o;
  return e && e.split(`
`).forEach(function(i) {
    o = i.indexOf(":"), r = i.substring(0, o).trim().toLowerCase(), n = i.substring(o + 1).trim(), !(!r || t[r] && tu[r]) && (r === "set-cookie" ? t[r] ? t[r].push(n) : t[r] = [n] : t[r] = t[r] ? t[r] + ", " + n : n);
  }), t;
}, ho = Symbol("internals");
function ur(e) {
  return e && String(e).trim().toLowerCase();
}
function jr(e) {
  return e === !1 || e == null ? e : B.isArray(e) ? e.map(jr) : String(e);
}
function nu(e) {
  let t = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g, n;
  for (; n = r.exec(e); )
    t[n[1]] = n[2];
  return t;
}
function ou(e) {
  return /^[-_a-zA-Z]+$/.test(e.trim());
}
function en(e, t, r, n, o) {
  if (B.isFunction(n))
    return n.call(this, t, r);
  if (o && (t = r), !!B.isString(t)) {
    if (B.isString(n))
      return t.indexOf(n) !== -1;
    if (B.isRegExp(n))
      return n.test(t);
  }
}
function iu(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, r, n) => r.toUpperCase() + n);
}
function au(e, t) {
  let r = B.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((n) => {
    Object.defineProperty(e, n + r, { value: function(o, i, a) {
      return this[n].call(this, t, o, i, a);
    }, configurable: !0 });
  });
}
var Hr = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, r, n) {
    let o = this;
    function i(l, s, h) {
      let d = ur(s);
      if (!d)
        throw new Error("header name must be a non-empty string");
      let S = B.findKey(o, d);
      (!S || o[S] === void 0 || h === !0 || h === void 0 && o[S] !== !1) && (o[S || s] = jr(l));
    }
    let a = (l, s) => B.forEach(l, (h, d) => i(h, d, s));
    return B.isPlainObject(t) || t instanceof this.constructor ? a(t, r) : B.isString(t) && (t = t.trim()) && !ou(t) ? a(ru(t), r) : t != null && i(r, t, n), this;
  }
  get(t, r) {
    if (t = ur(t), t) {
      let n = B.findKey(this, t);
      if (n) {
        let o = this[n];
        if (!r)
          return o;
        if (r === !0)
          return nu(o);
        if (B.isFunction(r))
          return r.call(this, o, n);
        if (B.isRegExp(r))
          return r.exec(o);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, r) {
    if (t = ur(t), t) {
      let n = B.findKey(this, t);
      return !!(n && this[n] !== void 0 && (!r || en(this, this[n], n, r)));
    }
    return !1;
  }
  delete(t, r) {
    let n = this, o = !1;
    function i(a) {
      if (a = ur(a), a) {
        let l = B.findKey(n, a);
        l && (!r || en(n, n[l], l, r)) && (delete n[l], o = !0);
      }
    }
    return B.isArray(t) ? t.forEach(i) : i(t), o;
  }
  clear(t) {
    let r = Object.keys(this), n = r.length, o = !1;
    for (; n--; ) {
      let i = r[n];
      (!t || en(this, this[i], i, t, !0)) && (delete this[i], o = !0);
    }
    return o;
  }
  normalize(t) {
    let r = this, n = {};
    return B.forEach(this, (o, i) => {
      let a = B.findKey(n, i);
      if (a) {
        r[a] = jr(o), delete r[i];
        return;
      }
      let l = t ? iu(i) : String(i).trim();
      l !== i && delete r[i], r[l] = jr(o), n[l] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    let r = /* @__PURE__ */ Object.create(null);
    return B.forEach(this, (n, o) => {
      n != null && n !== !1 && (r[o] = t && B.isArray(n) ? n.join(", ") : n);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, r]) => t + ": " + r).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...r) {
    let n = new this(t);
    return r.forEach((o) => n.set(o)), n;
  }
  static accessor(t) {
    let r = (this[ho] = this[ho] = { accessors: {} }).accessors, n = this.prototype;
    function o(i) {
      let a = ur(i);
      r[a] || (au(n, i), r[a] = !0);
    }
    return B.isArray(t) ? t.forEach(o) : o(t), this;
  }
};
Hr.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
B.freezeMethods(Hr.prototype);
B.freezeMethods(Hr);
var ot = Hr;
function tn(e, t) {
  let r = this || Dn, n = t || r, o = ot.from(n.headers), i = n.data;
  return B.forEach(e, function(a) {
    i = a.call(r, i, o.normalize(), t ? t.status : void 0);
  }), o.normalize(), i;
}
function Ai(e) {
  return !!(e && e.__CANCEL__);
}
function xi(e, t, r) {
  se.call(this, e == null ? "canceled" : e, se.ERR_CANCELED, t, r), this.name = "CanceledError";
}
B.inherits(xi, se, { __CANCEL__: !0 });
var zr = xi;
function su(e, t, r) {
  let n = r.config.validateStatus;
  !r.status || !n || n(r.status) ? e(r) : t(new se("Request failed with status code " + r.status, [se.ERR_BAD_REQUEST, se.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4], r.config, r.request, r));
}
var lu = Ge.isStandardBrowserEnv ? function() {
  return { write: function(e, t, r, n, o, i) {
    let a = [];
    a.push(e + "=" + encodeURIComponent(t)), B.isNumber(r) && a.push("expires=" + new Date(r).toGMTString()), B.isString(n) && a.push("path=" + n), B.isString(o) && a.push("domain=" + o), i === !0 && a.push("secure"), document.cookie = a.join("; ");
  }, read: function(e) {
    let t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
    return t ? decodeURIComponent(t[3]) : null;
  }, remove: function(e) {
    this.write(e, "", Date.now() - 864e5);
  } };
}() : function() {
  return { write: function() {
  }, read: function() {
    return null;
  }, remove: function() {
  } };
}();
function uu(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function cu(e, t) {
  return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function Pi(e, t) {
  return e && !uu(t) ? cu(e, t) : t;
}
var fu = Ge.isStandardBrowserEnv ? function() {
  let e = /(msie|trident)/i.test(navigator.userAgent), t = document.createElement("a"), r;
  function n(o) {
    let i = o;
    return e && (t.setAttribute("href", i), i = t.href), t.setAttribute("href", i), { href: t.href, protocol: t.protocol ? t.protocol.replace(/:$/, "") : "", host: t.host, search: t.search ? t.search.replace(/^\?/, "") : "", hash: t.hash ? t.hash.replace(/^#/, "") : "", hostname: t.hostname, port: t.port, pathname: t.pathname.charAt(0) === "/" ? t.pathname : "/" + t.pathname };
  }
  return r = n(window.location.href), function(o) {
    let i = B.isString(o) ? n(o) : o;
    return i.protocol === r.protocol && i.host === r.host;
  };
}() : function() {
  return function() {
    return !0;
  };
}();
function pu(e) {
  let t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function du(e, t) {
  e = e || 10;
  let r = new Array(e), n = new Array(e), o = 0, i = 0, a;
  return t = t !== void 0 ? t : 1e3, function(l) {
    let s = Date.now(), h = n[i];
    a || (a = s), r[o] = l, n[o] = s;
    let d = i, S = 0;
    for (; d !== o; )
      S += r[d++], d = d % e;
    if (o = (o + 1) % e, o === i && (i = (i + 1) % e), s - a < t)
      return;
    let O = h && s - h;
    return O ? Math.round(S * 1e3 / O) : void 0;
  };
}
var yu = du;
function mo(e, t) {
  let r = 0, n = yu(50, 250);
  return (o) => {
    let i = o.loaded, a = o.lengthComputable ? o.total : void 0, l = i - r, s = n(l), h = i <= a;
    r = i;
    let d = { loaded: i, total: a, progress: a ? i / a : void 0, bytes: l, rate: s || void 0, estimated: s && a && h ? (a - i) / s : void 0, event: o };
    d[t ? "download" : "upload"] = !0, e(d);
  };
}
var hu = typeof XMLHttpRequest != "undefined", mu = hu && function(e) {
  return new Promise(function(t, r) {
    let n = e.data, o = ot.from(e.headers).normalize(), i = e.responseType, a;
    function l() {
      e.cancelToken && e.cancelToken.unsubscribe(a), e.signal && e.signal.removeEventListener("abort", a);
    }
    B.isFormData(n) && (Ge.isStandardBrowserEnv || Ge.isStandardBrowserWebWorkerEnv) && o.setContentType(!1);
    let s = new XMLHttpRequest();
    if (e.auth) {
      let O = e.auth.username || "", p = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
      o.set("Authorization", "Basic " + btoa(O + ":" + p));
    }
    let h = Pi(e.baseURL, e.url);
    s.open(e.method.toUpperCase(), Si(h, e.params, e.paramsSerializer), !0), s.timeout = e.timeout;
    function d() {
      if (!s)
        return;
      let O = ot.from("getAllResponseHeaders" in s && s.getAllResponseHeaders()), p = { data: !i || i === "text" || i === "json" ? s.responseText : s.response, status: s.status, statusText: s.statusText, headers: O, config: e, request: s };
      su(function(f) {
        t(f), l();
      }, function(f) {
        r(f), l();
      }, p), s = null;
    }
    if ("onloadend" in s ? s.onloadend = d : s.onreadystatechange = function() {
      !s || s.readyState !== 4 || s.status === 0 && !(s.responseURL && s.responseURL.indexOf("file:") === 0) || setTimeout(d);
    }, s.onabort = function() {
      !s || (r(new se("Request aborted", se.ECONNABORTED, e, s)), s = null);
    }, s.onerror = function() {
      r(new se("Network Error", se.ERR_NETWORK, e, s)), s = null;
    }, s.ontimeout = function() {
      let O = e.timeout ? "timeout of " + e.timeout + "ms exceeded" : "timeout exceeded", p = e.transitional || Oi;
      e.timeoutErrorMessage && (O = e.timeoutErrorMessage), r(new se(O, p.clarifyTimeoutError ? se.ETIMEDOUT : se.ECONNABORTED, e, s)), s = null;
    }, Ge.isStandardBrowserEnv) {
      let O = (e.withCredentials || fu(h)) && e.xsrfCookieName && lu.read(e.xsrfCookieName);
      O && o.set(e.xsrfHeaderName, O);
    }
    n === void 0 && o.setContentType(null), "setRequestHeader" in s && B.forEach(o.toJSON(), function(O, p) {
      s.setRequestHeader(p, O);
    }), B.isUndefined(e.withCredentials) || (s.withCredentials = !!e.withCredentials), i && i !== "json" && (s.responseType = e.responseType), typeof e.onDownloadProgress == "function" && s.addEventListener("progress", mo(e.onDownloadProgress, !0)), typeof e.onUploadProgress == "function" && s.upload && s.upload.addEventListener("progress", mo(e.onUploadProgress)), (e.cancelToken || e.signal) && (a = (O) => {
      !s || (r(!O || O.type ? new zr(null, e, s) : O), s.abort(), s = null);
    }, e.cancelToken && e.cancelToken.subscribe(a), e.signal && (e.signal.aborted ? a() : e.signal.addEventListener("abort", a)));
    let S = pu(h);
    if (S && Ge.protocols.indexOf(S) === -1) {
      r(new se("Unsupported protocol " + S + ":", se.ERR_BAD_REQUEST, e));
      return;
    }
    s.send(n || null);
  });
}, Rr = { http: Il, xhr: mu };
B.forEach(Rr, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch (r) {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
var gu = { getAdapter: (e) => {
  e = B.isArray(e) ? e : [e];
  let { length: t } = e, r, n;
  for (let o = 0; o < t && (r = e[o], !(n = B.isString(r) ? Rr[r.toLowerCase()] : r)); o++)
    ;
  if (!n)
    throw n === !1 ? new se(`Adapter ${r} is not supported by the environment`, "ERR_NOT_SUPPORT") : new Error(B.hasOwnProp(Rr, r) ? `Adapter '${r}' is not available in the build` : `Unknown adapter '${r}'`);
  if (!B.isFunction(n))
    throw new TypeError("adapter is not a function");
  return n;
}, adapters: Rr };
function rn(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new zr(null, e);
}
function go(e) {
  return rn(e), e.headers = ot.from(e.headers), e.data = tn.call(e, e.transformRequest), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), gu.getAdapter(e.adapter || Dn.adapter)(e).then(function(t) {
    return rn(e), t.data = tn.call(e, e.transformResponse, t), t.headers = ot.from(t.headers), t;
  }, function(t) {
    return Ai(t) || (rn(e), t && t.response && (t.response.data = tn.call(e, e.transformResponse, t.response), t.response.headers = ot.from(t.response.headers))), Promise.reject(t);
  });
}
var vo = (e) => e instanceof ot ? e.toJSON() : e;
function Gt(e, t) {
  t = t || {};
  let r = {};
  function n(h, d, S) {
    return B.isPlainObject(h) && B.isPlainObject(d) ? B.merge.call({ caseless: S }, h, d) : B.isPlainObject(d) ? B.merge({}, d) : B.isArray(d) ? d.slice() : d;
  }
  function o(h, d, S) {
    if (B.isUndefined(d)) {
      if (!B.isUndefined(h))
        return n(void 0, h, S);
    } else
      return n(h, d, S);
  }
  function i(h, d) {
    if (!B.isUndefined(d))
      return n(void 0, d);
  }
  function a(h, d) {
    if (B.isUndefined(d)) {
      if (!B.isUndefined(h))
        return n(void 0, h);
    } else
      return n(void 0, d);
  }
  function l(h, d, S) {
    if (S in t)
      return n(h, d);
    if (S in e)
      return n(void 0, h);
  }
  let s = { url: i, method: i, data: i, baseURL: a, transformRequest: a, transformResponse: a, paramsSerializer: a, timeout: a, timeoutMessage: a, withCredentials: a, adapter: a, responseType: a, xsrfCookieName: a, xsrfHeaderName: a, onUploadProgress: a, onDownloadProgress: a, decompress: a, maxContentLength: a, maxBodyLength: a, beforeRedirect: a, transport: a, httpAgent: a, httpsAgent: a, cancelToken: a, socketPath: a, responseEncoding: a, validateStatus: l, headers: (h, d) => o(vo(h), vo(d), !0) };
  return B.forEach(Object.keys(e).concat(Object.keys(t)), function(h) {
    let d = s[h] || o, S = d(e[h], t[h], h);
    B.isUndefined(S) && d !== l || (r[h] = S);
  }), r;
}
var ji = "1.3.4", Mn = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  Mn[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
var bo = {};
Mn.transitional = function(e, t, r) {
  function n(o, i) {
    return "[Axios v" + ji + "] Transitional option '" + o + "'" + i + (r ? ". " + r : "");
  }
  return (o, i, a) => {
    if (e === !1)
      throw new se(n(i, " has been removed" + (t ? " in " + t : "")), se.ERR_DEPRECATED);
    return t && !bo[i] && (bo[i] = !0, console.warn(n(i, " has been deprecated since v" + t + " and will be removed in the near future"))), e ? e(o, i, a) : !0;
  };
};
function vu(e, t, r) {
  if (typeof e != "object")
    throw new se("options must be an object", se.ERR_BAD_OPTION_VALUE);
  let n = Object.keys(e), o = n.length;
  for (; o-- > 0; ) {
    let i = n[o], a = t[i];
    if (a) {
      let l = e[i], s = l === void 0 || a(l, i, e);
      if (s !== !0)
        throw new se("option " + i + " must be " + s, se.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new se("Unknown option " + i, se.ERR_BAD_OPTION);
  }
}
var dn = { assertOptions: vu, validators: Mn }, yt = dn.validators, Mr = class {
  constructor(e) {
    this.defaults = e, this.interceptors = { request: new yo(), response: new yo() };
  }
  request(e, t) {
    typeof e == "string" ? (t = t || {}, t.url = e) : t = e || {}, t = Gt(this.defaults, t);
    let { transitional: r, paramsSerializer: n, headers: o } = t;
    r !== void 0 && dn.assertOptions(r, { silentJSONParsing: yt.transitional(yt.boolean), forcedJSONParsing: yt.transitional(yt.boolean), clarifyTimeoutError: yt.transitional(yt.boolean) }, !1), n !== void 0 && dn.assertOptions(n, { encode: yt.function, serialize: yt.function }, !0), t.method = (t.method || this.defaults.method || "get").toLowerCase();
    let i;
    i = o && B.merge(o.common, o[t.method]), i && B.forEach(["delete", "get", "head", "post", "put", "patch", "common"], (p) => {
      delete o[p];
    }), t.headers = ot.concat(i, o);
    let a = [], l = !0;
    this.interceptors.request.forEach(function(p) {
      typeof p.runWhen == "function" && p.runWhen(t) === !1 || (l = l && p.synchronous, a.unshift(p.fulfilled, p.rejected));
    });
    let s = [];
    this.interceptors.response.forEach(function(p) {
      s.push(p.fulfilled, p.rejected);
    });
    let h, d = 0, S;
    if (!l) {
      let p = [go.bind(this), void 0];
      for (p.unshift.apply(p, a), p.push.apply(p, s), S = p.length, h = Promise.resolve(t); d < S; )
        h = h.then(p[d++], p[d++]);
      return h;
    }
    S = a.length;
    let O = t;
    for (d = 0; d < S; ) {
      let p = a[d++], f = a[d++];
      try {
        O = p(O);
      } catch (P) {
        f.call(this, P);
        break;
      }
    }
    try {
      h = go.call(this, O);
    } catch (p) {
      return Promise.reject(p);
    }
    for (d = 0, S = s.length; d < S; )
      h = h.then(s[d++], s[d++]);
    return h;
  }
  getUri(e) {
    e = Gt(this.defaults, e);
    let t = Pi(e.baseURL, e.url);
    return Si(t, e.params, e.paramsSerializer);
  }
};
B.forEach(["delete", "get", "head", "options"], function(e) {
  Mr.prototype[e] = function(t, r) {
    return this.request(Gt(r || {}, { method: e, url: t, data: (r || {}).data }));
  };
});
B.forEach(["post", "put", "patch"], function(e) {
  function t(r) {
    return function(n, o, i) {
      return this.request(Gt(i || {}, { method: e, headers: r ? { "Content-Type": "multipart/form-data" } : {}, url: n, data: o }));
    };
  }
  Mr.prototype[e] = t(), Mr.prototype[e + "Form"] = t(!0);
});
var _r = Mr, Ri = class {
  constructor(e) {
    if (typeof e != "function")
      throw new TypeError("executor must be a function.");
    let t;
    this.promise = new Promise(function(n) {
      t = n;
    });
    let r = this;
    this.promise.then((n) => {
      if (!r._listeners)
        return;
      let o = r._listeners.length;
      for (; o-- > 0; )
        r._listeners[o](n);
      r._listeners = null;
    }), this.promise.then = (n) => {
      let o, i = new Promise((a) => {
        r.subscribe(a), o = a;
      }).then(n);
      return i.cancel = function() {
        r.unsubscribe(o);
      }, i;
    }, e(function(n, o, i) {
      r.reason || (r.reason = new zr(n, o, i), t(r.reason));
    });
  }
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  unsubscribe(e) {
    if (!this._listeners)
      return;
    let t = this._listeners.indexOf(e);
    t !== -1 && this._listeners.splice(t, 1);
  }
  static source() {
    let e;
    return { token: new Ri(function(t) {
      e = t;
    }), cancel: e };
  }
}, bu = Ri;
function wu(e) {
  return function(t) {
    return e.apply(null, t);
  };
}
function Su(e) {
  return B.isObject(e) && e.isAxiosError === !0;
}
var yn = { Continue: 100, SwitchingProtocols: 101, Processing: 102, EarlyHints: 103, Ok: 200, Created: 201, Accepted: 202, NonAuthoritativeInformation: 203, NoContent: 204, ResetContent: 205, PartialContent: 206, MultiStatus: 207, AlreadyReported: 208, ImUsed: 226, MultipleChoices: 300, MovedPermanently: 301, Found: 302, SeeOther: 303, NotModified: 304, UseProxy: 305, Unused: 306, TemporaryRedirect: 307, PermanentRedirect: 308, BadRequest: 400, Unauthorized: 401, PaymentRequired: 402, Forbidden: 403, NotFound: 404, MethodNotAllowed: 405, NotAcceptable: 406, ProxyAuthenticationRequired: 407, RequestTimeout: 408, Conflict: 409, Gone: 410, LengthRequired: 411, PreconditionFailed: 412, PayloadTooLarge: 413, UriTooLong: 414, UnsupportedMediaType: 415, RangeNotSatisfiable: 416, ExpectationFailed: 417, ImATeapot: 418, MisdirectedRequest: 421, UnprocessableEntity: 422, Locked: 423, FailedDependency: 424, TooEarly: 425, UpgradeRequired: 426, PreconditionRequired: 428, TooManyRequests: 429, RequestHeaderFieldsTooLarge: 431, UnavailableForLegalReasons: 451, InternalServerError: 500, NotImplemented: 501, BadGateway: 502, ServiceUnavailable: 503, GatewayTimeout: 504, HttpVersionNotSupported: 505, VariantAlsoNegotiates: 506, InsufficientStorage: 507, LoopDetected: 508, NotExtended: 510, NetworkAuthenticationRequired: 511 };
Object.entries(yn).forEach(([e, t]) => {
  yn[t] = e;
});
var Ou = yn;
function _i(e) {
  let t = new _r(e), r = ai(_r.prototype.request, t);
  return B.extend(r, _r.prototype, t, { allOwnKeys: !0 }), B.extend(r, t, null, { allOwnKeys: !0 }), r.create = function(n) {
    return _i(Gt(e, n));
  }, r;
}
var Oe = _i(Dn);
Oe.Axios = _r;
Oe.CanceledError = zr;
Oe.CancelToken = bu;
Oe.isCancel = Ai;
Oe.VERSION = ji;
Oe.toFormData = Ur;
Oe.AxiosError = se;
Oe.Cancel = Oe.CanceledError;
Oe.all = function(e) {
  return Promise.all(e);
};
Oe.spread = wu;
Oe.isAxiosError = Su;
Oe.mergeConfig = Gt;
Oe.AxiosHeaders = ot;
Oe.formToJSON = (e) => Ei(B.isHTMLForm(e) ? new FormData(e) : e);
Oe.HttpStatusCode = Ou;
Oe.default = Oe;
Gs(il());
var Eu = ((e) => (e[e.OK = 0] = "OK", e[e.ErrForbidden = -403] = "ErrForbidden", e[e.ErrNotFound = -404] = "ErrNotFound", e[e.ErrUserNotExist = -626] = "ErrUserNotExist", e[e.ErrRegionLimit = 10004001] = "ErrRegionLimit", e[e.ErrArchive = 10004002] = "ErrArchive", e[e.ErrEpisode = 10004003] = "ErrEpisode", e[e.ErrNeedPremium = 10004004] = "ErrNeedPremium", e[e.ErrNeedLogin = 10004005] = "ErrNeedLogin", e[e.ErrNeedBuvid = 10023006] = "ErrNeedBuvid", e[e.ErrSubmitFail = 10023007] = "ErrSubmitFail", e[e.ErrCommentClose = 10023008] = "ErrCommentClose", e[e.ErrAccountOrPassword = -629] = "ErrAccountOrPassword", e[e.ErrCaptcha = -105] = "ErrCaptcha", e[e.DecryptError = 86e3] = "DecryptError", e[e.NeedCaptcha = 86001] = "NeedCaptcha", e[e.EmptyArea = 86003] = "EmptyArea", e[e.EmptyPhone = 86004] = "EmptyPhone", e[e.ErrorPhone = 86005] = "ErrorPhone", e[e.BanPhone = 86015] = "BanPhone", e[e.FrequentSend = 86200] = "FrequentSend", e[e.ErrorSmsCode = 86202] = "ErrorSmsCode", e[e.LimitSend = 86203] = "LimitSend", e[e.TooManySend = 86204] = "TooManySend", e[e.OverdueSmsCode = 86205] = "OverdueSmsCode", e[e.DiffArea = 86206] = "DiffArea", e[e.DiffPhone = 86207] = "DiffPhone", e[e.UnlegalSend = 86208] = "UnlegalSend", e[e.ErrorPhone2 = 66031] = "ErrorPhone2", e[e.ErrorAccountOrPassword = -629] = "ErrorAccountOrPassword", e[e.ErrorCaptcha = -105] = "ErrorCaptcha", e[e.PhoneLimit = 86071] = "PhoneLimit", e[e.AreaLimit = 10003003] = "AreaLimit", e[e.EmailSendFail = 86250] = "EmailSendFail", e[e.EmailSendInvalid = 86251] = "EmailSendInvalid", e[e.EmailSent = 86252] = "EmailSent", e[e.TooManyEmailSend = 86253] = "TooManyEmailSend", e[e.TooManyEmailSendIp = 86254] = "TooManyEmailSendIp", e[e.OverdueEmail = 86255] = "OverdueEmail", e[e.DiffEmail = 86256] = "DiffEmail", e[e.ErrorEmailCode = 86257] = "ErrorEmailCode", e[e.EmailInvalid = 86258] = "EmailInvalid", e[e.InvalidPassword = 86306] = "InvalidPassword", e[e.OccupyEmail = 86259] = "OccupyEmail", e[e.ResentEmailCode = 86150] = "ResentEmailCode", e[e.QrcodeScanTimeout = 10018100] = "QrcodeScanTimeout", e[e.QrcodeNotScan = 10018101] = "QrcodeNotScan", e[e.QrcodeScaned = 10018102] = "QrcodeScaned", e))(Eu || {}), wo, So, Oo;
!lo.isSafari || Number((Oo = (So = (wo = lo) == null ? void 0 : wo.safariVersion) == null ? void 0 : So.split(".")) == null ? void 0 : Oo[0]) >= 14;
var Au = /\.(\w+)@(\w+)(\.\w+)?$/, xu = (e, t, r, n = 90) => e ? Au.test(e) ? e.replace(/(\.\w+)$/, "") : `${e}@${t ? `${t}w_` : ""}${r ? `${r}h_` : ""}1e_1c_${n}q` : "";
const Pu = { class: "bstar-image" }, ju = ["srcset"], Ru = ["srcset"], _u = ["src", "alt", "loading"], ku = {
  name: "BImage"
}, $u = /* @__PURE__ */ ge(we(be({}, ku), {
  props: {
    src: null,
    alt: { default: "" },
    width: null,
    height: null,
    loading: { default: "eager" },
    openAvif: { type: Boolean, default: !1 }
  },
  emits: ["load", "error"],
  setup(e, { emit: t }) {
    const r = e, { src: n, width: o, height: i, openAvif: a } = Ae(r), l = Q(() => {
      const O = m(o), p = m(i);
      return m(a) && O && O >= 64 && O <= 4096 && p && p >= 64 && p <= 2304 && /(p\.bstarstatic\.com)|(p-bstarstatic\.akamaized\.net)/.test(m(n));
    }), s = Q(() => n.value && !n.value.includes(".gif")), h = Q(() => {
      const O = m(n);
      return m(s) ? xu(O, m(o), m(i)) : O;
    }), d = (O) => {
      t("load", O);
    }, S = (O) => {
      t("error", O);
    };
    return (O, p) => (Y(), ee("picture", Pu, [
      m(s) && m(l) ? (Y(), ee("source", {
        key: 0,
        srcset: `${m(h)}.avif`,
        type: "image/avif"
      }, null, 8, ju)) : he("", !0),
      m(s) ? (Y(), ee("source", {
        key: 1,
        srcset: `${m(h)}.webp`,
        type: "image/webp"
      }, null, 8, Ru)) : he("", !0),
      G("img", {
        class: "bstar-image__img",
        src: m(h),
        alt: e.alt,
        loading: e.loading,
        onLoad: d,
        onError: S
      }, null, 40, _u)
    ]));
  }
}));
ze($u);
const Cu = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTRweCIgaGVpZ2h0PSIxNHB4IiB2aWV3Qm94PSIwIDAgMTQgMTQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+MTRweOWLvjwvdGl0bGU+CiAgICA8ZyBpZD0i5o6n5Lu2IiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iaWNvbl9jaGVja2JveF9zZWxlY3RlZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIuMDAwMDAwLCAtMi4wMDAwMDApIj4KICAgICAgICAgICAgPGcgaWQ9IjE0cHjli74iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIuMDAwMDAwLCAyLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPHJlY3QgaWQ9IuefqeW9oiIgZmlsbD0iI0NDQ0NDQyIgb3BhY2l0eT0iMCIgeD0iMCIgeT0iMCIgd2lkdGg9IjE0IiBoZWlnaHQ9IjE0Ij48L3JlY3Q+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMywyLjY1Njg1NDI1IEMzLjUxMjgzNTg0LDIuNjU2ODU0MjUgMy45MzU1MDcxNiwzLjA0Mjg5NDQ0IDMuOTkzMjcyMjcsMy41NDAyMzMxMiBMNCwzLjY1Njg1NDI1IEw0LDYuNjU2ODU0MjUgTDExLDYuNjU2ODU0MjUgQzExLjUxMjgzNTgsNi42NTY4NTQyNSAxMS45MzU1MDcyLDcuMDQyODk0NDQgMTEuOTkzMjcyMyw3LjU0MDIzMzEyIEwxMiw3LjY1Njg1NDI1IEMxMiw4LjE2OTY5MDA5IDExLjYxMzk1OTgsOC41OTIzNjE0MSAxMS4xMTY2MjExLDguNjUwMTI2NTIgTDExLDguNjU2ODU0MjUgTDMsOC42NTY4NTQyNSBDMi40ODcxNjQxNiw4LjY1Njg1NDI1IDIuMDY0NDkyODQsOC4yNzA4MTQwNiAyLjAwNjcyNzczLDcuNzczNDc1MzcgTDIsNy42NTY4NTQyNSBMMiwzLjY1Njg1NDI1IEMyLDMuMTA0NTY5NSAyLjQ0NzcxNTI1LDIuNjU2ODU0MjUgMywyLjY1Njg1NDI1IFoiIGlkPSLli74iIGZpbGw9IiNGRkZGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNy4wMDAwMDAsIDUuNjU2ODU0KSByb3RhdGUoLTQ1LjAwMDAwMCkgdHJhbnNsYXRlKC03LjAwMDAwMCwgLTUuNjU2ODU0KSAiPjwvcGF0aD4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+", Nu = ["src"], Tu = ["disabled", "value", "name", "checked"], Du = { class: "bstar-checkbox__label" }, Mu = {
  name: "BCheckbox"
}, Bu = /* @__PURE__ */ ge(we(be({}, Mu), {
  props: {
    modelValue: { type: Boolean, default: !1 },
    value: { type: [String, Number, Boolean], default: "" },
    label: { default: "" },
    disabled: { type: Boolean, default: !1 },
    circle: { type: Boolean, default: !1 }
  },
  emits: ["change", "update:modelValue"],
  setup(e, { emit: t }) {
    const r = e, { value: n, disabled: o, modelValue: i } = Ae(r), a = zo("CheckboxGroup", {}), l = Q(() => {
      var S;
      return a != null && a.props ? (S = a.props) == null ? void 0 : S.value.includes(m(n)) : m(i);
    }), s = Q(() => {
      var S, O;
      return (O = (S = a == null ? void 0 : a.props) == null ? void 0 : S.itemStyle) != null ? O : {};
    }), h = Q(() => {
      var S;
      return m(o) || ((S = a == null ? void 0 : a.props) == null ? void 0 : S.disabled);
    }), d = (S) => {
      const O = S.target;
      a && a.handleChange ? (t("change", !m(l)), t("update:modelValue", !m(l)), a.handleChange(`${m(n)}`, !m(l))) : (t("change", O.checked), t("update:modelValue", O.checked));
    };
    return (S, O) => (Y(), ee("label", {
      class: oe([
        "bstar-checkbox",
        {
          "is-disabled": m(h),
          "is-checked": m(l)
        }
      ]),
      style: Ut(m(s))
    }, [
      G("span", {
        class: oe(["bstar-checkbox__input", {
          "is-disabled": m(h),
          "is-checked": m(l)
        }])
      }, [
        G("span", {
          class: oe([
            "bstar-checkbox__inner",
            { "bstar-checkbox__inner--circle": e.circle }
          ])
        }, [
          G("img", {
            class: "bstar-checkbox__checked-icon",
            src: m(Cu),
            alt: "checkbox"
          }, null, 8, Nu)
        ], 2),
        G("input", {
          class: "bstar-checkbox__original",
          type: "checkbox",
          disabled: m(h),
          value: m(n),
          name: e.label,
          checked: m(l),
          tabindex: "-1",
          onChange: d
        }, null, 40, Tu)
      ], 2),
      Re(S.$slots, "default", {}, () => [
        G("span", Du, ye(e.label), 1)
      ], !0)
    ], 6));
  }
})), Iu = /* @__PURE__ */ st(Bu, [["__scopeId", "data-v-04cca47e"]]), Fu = {
  class: "bstar-checkbox-group",
  role: "checkbox"
}, Uu = {
  name: "BCheckboxGroup"
}, Lu = /* @__PURE__ */ ge(we(be({}, Uu), {
  props: {
    value: { default: () => [] },
    disabled: { type: Boolean, default: !1 },
    itemStyle: { default: () => ({}) }
  },
  emits: ["change", "input"],
  setup(e, { emit: t }) {
    const r = e, { value: n } = Ae(r);
    return Sn("CheckboxGroup", {
      name: "BCheckboxGroup",
      props: r,
      handleChange: (o, i) => {
        var a, l;
        const s = i ? [...(a = m(n)) != null ? a : [], o] : ((l = m(n)) != null ? l : []).filter((h) => h !== o);
        t("input", s), t("change", s);
      }
    }), (o, i) => (Y(), ee("div", Fu, [
      Re(o.$slots, "default")
    ]));
  }
}));
ze(Iu);
ze(Lu);
const Hu = typeof window == "undefined", zu = (e) => typeof Element == "undefined" ? !1 : e instanceof Element, mt = /* @__PURE__ */ new Map();
let Eo;
Hu || (document.addEventListener("mousedown", (e) => Eo = e), document.addEventListener("mouseup", (e) => {
  for (const t of mt.values())
    for (const { documentHandler: r } of t)
      r(e, Eo);
}));
function Ao(e, t) {
  let r = [];
  return Array.isArray(t.arg) ? r = t.arg : zu(t.arg) && r.push(t.arg), function(n, o) {
    const i = t.instance.popperRef, a = n.target, l = o == null ? void 0 : o.target, s = !t || !t.instance, h = !a || !l, d = e.contains(a) || e.contains(l), S = e === a, O = r.length && r.some((f) => f == null ? void 0 : f.contains(a)) || r.length && r.includes(l), p = i && (i.contains(a) || i.contains(l));
    s || h || d || S || O || p || t.value(n, o);
  };
}
const Bn = {
  beforeMount(e, t) {
    mt.has(e) || mt.set(e, []);
    const r = mt.get(e);
    r == null || r.push({
      documentHandler: Ao(e, t),
      bindingFn: t.value
    });
  },
  updated(e, t) {
    mt.has(e) || mt.set(e, []);
    const r = mt.get(e), n = r == null ? void 0 : r.findIndex(
      (i) => i.bindingFn === t.oldValue
    ), o = {
      documentHandler: Ao(e, t),
      bindingFn: t.value
    };
    n && n >= 0 ? r == null || r.splice(n, 1, o) : r == null || r.push(o);
  },
  unmounted(e) {
    mt.delete(e);
  }
};
function ki(e) {
  const { placement: t, offset: r, skipping: n } = e;
  return {
    placement: t,
    modifiers: Wu({
      offset: r,
      skipping: n
    })
  };
}
function Wu({
  skipping: e = 0,
  offset: t = 0
} = {}) {
  return [
    {
      name: "offset",
      options: {
        offset: [e, t]
      }
    },
    {
      name: "computeStyles",
      options: {
        gpuAcceleration: !1,
        adaptive: !1
      }
    }
  ];
}
const Vu = { class: "bstar-popper" }, qu = {
  name: "BPopper"
}, Gu = /* @__PURE__ */ ge(we(be({}, qu), {
  props: {
    visible: { type: Boolean, default: !1 },
    placement: { default: "top-start" },
    offset: { default: 0 },
    skipping: { default: 0 },
    referenceStyle: { default: () => ({}) }
  },
  setup(e, { expose: t }) {
    const r = e, n = fe(), o = fe(), i = fe(), { visible: a, placement: l, offset: s, skipping: h } = Ae(r), d = () => {
      !n.value || !o.value || (i.value = ri(
        n.value,
        o.value,
        ki({
          placement: m(l),
          offset: m(s),
          skipping: m(h)
        })
      ), setTimeout(() => {
        S();
      }, 500));
    };
    gr(() => {
      d();
    }), ya(() => {
      O();
    });
    const S = () => {
      var f;
      (f = m(i)) == null || f.update();
    };
    Ft(() => m(a), () => {
      S();
    });
    const O = () => {
      var f;
      (f = m(i)) == null || f.destroy(), i.value = null;
    }, p = Q(() => ({
      "bstar-popper__content": !0,
      "bstar-popper__content--slider": !0,
      "bstar-popper__content--active": m(a)
    }));
    return t({
      updateHandler: S
    }), (f, P) => (Y(), ee("div", Vu, [
      G("div", {
        ref_key: "referenceEl",
        ref: n,
        class: "bstar-popper__reference",
        style: Ut(e.referenceStyle)
      }, [
        Re(f.$slots, "default", {}, void 0, !0)
      ], 4),
      G("div", {
        ref_key: "contentEl",
        ref: o,
        class: oe(m(p))
      }, [
        Re(f.$slots, "content", {}, void 0, !0)
      ], 2)
    ]));
  }
})), $i = /* @__PURE__ */ st(Gu, [["__scopeId", "data-v-0ad4c5c9"]]), Ju = (e) => (va("data-v-0f552eb8"), e = e(), ba(), e), Yu = { class: "select" }, Qu = { class: "select__popper" }, Ku = {
  key: 0,
  class: "select__search"
}, Zu = /* @__PURE__ */ Ju(() => /* @__PURE__ */ G("div", { class: "select__search-icon" }, null, -1)), Xu = ["placeholder"], ec = {
  name: "BSelect"
}, tc = /* @__PURE__ */ ge(we(be({}, ec), {
  props: {
    id: { default: "" },
    label: { default: "" },
    filterable: { type: Boolean, default: !1 },
    placeholder: { default: "" }
  },
  emits: ["selectInput", "update:id"],
  setup(e, { emit: t }) {
    const r = e, { id: n, label: o, filterable: i } = Ae(r), a = fe(!1), l = fe(""), s = fe();
    Sn("selectState", {
      id: n,
      changeId: (p) => {
        a.value = !1, t("update:id", m(p));
      }
    });
    const h = () => {
      a.value = !m(a);
    }, d = () => {
      a.value = !1;
    }, S = (p) => {
      const f = p.target;
      t("selectInput", f.value);
    }, O = () => {
      const p = s.value, f = p == null ? void 0 : p.querySelector(".select-option-active");
      f && p && setTimeout(() => {
        const P = p.offsetHeight, k = f.offsetTop - P / 4;
        p.scrollTo(0, k);
      }, 0);
    };
    return Ft(a, (p) => {
      p && Wo(() => {
        O();
      });
    }), (p, f) => Lt((Y(), ee("div", Yu, [
      Tr($i, {
        visible: a.value,
        placement: "bottom-start"
      }, {
        content: Ie(() => [
          G("div", Qu, [
            m(i) ? (Y(), ee("div", Ku, [
              Zu,
              Lt(G("input", {
                "onUpdate:modelValue": f[0] || (f[0] = (P) => l.value = P),
                class: "select__search-input",
                placeholder: e.placeholder,
                onInput: S
              }, null, 40, Xu), [
                [ha, l.value]
              ])
            ])) : he("", !0),
            G("div", {
              ref_key: "selectWrapper",
              ref: s,
              class: "select__select-option"
            }, [
              Re(p.$slots, "default", {}, void 0, !0)
            ], 512)
          ])
        ]),
        default: Ie(() => [
          G("div", {
            class: "select__content",
            onClick: h
          }, [
            $t(ye(m(o)) + " ", 1),
            G("div", {
              class: oe(["select__icon", { "is-focus": a.value }])
            }, null, 2)
          ])
        ]),
        _: 3
      }, 8, ["visible"])
    ])), [
      [m(Bn), d]
    ]);
  }
})), rc = /* @__PURE__ */ st(tc, [["__scopeId", "data-v-0f552eb8"]]), nc = {
  name: "BSelectOption"
}, oc = /* @__PURE__ */ ge(we(be({}, nc), {
  props: {
    value: { default: "" },
    label: { default: "" },
    isActive: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, { value: r } = Ae(t), n = zo("selectState"), o = () => {
      n == null || n.changeId(m(r));
    };
    return (i, a) => (Y(), ee("div", {
      class: oe(["select-option", e.isActive ? "select-option-active" : ""]),
      onClick: o
    }, [
      Re(i.$slots, "default", {}, () => [
        $t(ye(e.label), 1)
      ], !0)
    ], 2));
  }
})), ic = /* @__PURE__ */ st(oc, [["__scopeId", "data-v-2f61209e"]]);
ze(rc);
ze(ic);
const ac = ["value", "type", "disabled", "readonly", "placeholder", "maxlength", "onKeyup"], sc = ["onClick"], lc = {
  key: 1,
  class: "bstar-input__count"
}, uc = {
  key: 2,
  class: "bstar-input__suffix"
}, cc = {
  name: "BInput"
}, fc = /* @__PURE__ */ ge(we(be({}, cc), {
  props: {
    modelValue: null,
    type: { default: "text" },
    placeholder: null,
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean },
    maxlength: { default: void 0 },
    error: { type: Boolean, default: !1 },
    clearable: { type: Boolean, default: !1 },
    dark: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "focus", "blur", "input", "change", "enter"],
  setup(e, { emit: t }) {
    const r = e, { modelValue: n, disabled: o, maxlength: i, error: a, clearable: l, dark: s } = Ae(r), h = Ho(), d = fe(!1), S = Q(() => h.suffix !== void 0), O = Q(() => {
      var D;
      return ((D = i == null ? void 0 : i.value) != null ? D : 0) > 0;
    }), p = Q(() => O.value && !o.value), f = Q(() => (n.value || "").length), P = Q(() => m(f) > 0 && m(l)), k = Q(() => {
      const D = "bstar-input";
      return [
        D,
        {
          [`${D}--limit`]: p.value,
          [`${D}--has-suffix`]: S.value,
          [`${D}--disabled`]: o.value,
          [`${D}--error`]: a.value,
          [`${D}--dark`]: s.value
        }
      ];
    }), A = Q(() => {
      const D = "bstar-input__inner";
      return [
        D,
        {
          [`${D}--focus`]: d.value
        }
      ];
    }), u = (D) => {
      const j = D.target;
      t("input", j.value), t("update:modelValue", j.value);
    }, v = (D) => {
      const j = D.target;
      t("change", j.value);
    }, b = (D) => {
      d.value = !0, t("focus", D);
    }, g = (D) => {
      d.value = !1, t("blur", D);
    }, w = () => {
      t("update:modelValue", "");
    }, R = (D) => {
      t("enter", D);
    };
    return (D, j) => (Y(), ee("div", {
      class: oe(m(k))
    }, [
      Re(D.$slots, "prepend", {}, void 0, !0),
      G("input", {
        class: oe(m(A)),
        value: m(n),
        type: e.type,
        disabled: m(o),
        readonly: e.readonly,
        placeholder: e.placeholder,
        maxlength: m(i),
        onInput: u,
        onChange: v,
        onBlur: g,
        onFocus: b,
        onKeyup: ma(R, ["enter"])
      }, null, 42, ac),
      m(P) ? (Y(), ee("span", {
        key: 0,
        class: "bstar-input__clear",
        onClick: Vo(w, ["stop"])
      }, null, 8, sc)) : he("", !0),
      m(p) ? (Y(), ee("span", lc, ye(m(f)) + "/" + ye(m(i)), 1)) : he("", !0),
      m(h).suffix ? (Y(), ee("div", uc, [
        Re(D.$slots, "suffix", {}, void 0, !0)
      ])) : he("", !0)
    ], 2));
  }
})), hn = /* @__PURE__ */ st(fc, [["__scopeId", "data-v-e912bc6a"]]);
ze(hn);
const pc = {
  name: "BConfigProvider"
}, dc = /* @__PURE__ */ ge(we(be({}, pc), {
  props: {
    locale: { default: "en" },
    env: { default: "prod" },
    platform: { default: "web" }
  },
  setup(e) {
    const t = e, { locale: r, env: n, platform: o } = Ae(t);
    return Sn("b-config-provider", Q(() => ({
      locale: m(r),
      env: m(n),
      platform: m(o)
    }))), (i, a) => Re(i.$slots, "default");
  }
}));
ze(dc);
var yc = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {}, Ci = { exports: {} };
(function(e, t) {
  (function(r, n) {
    e.exports = n();
  })(yc, function() {
    var r = 1e3, n = 6e4, o = 36e5, i = "millisecond", a = "second", l = "minute", s = "hour", h = "day", d = "week", S = "month", O = "quarter", p = "year", f = "date", P = "Invalid Date", k = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, A = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, u = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(C) {
      var $ = ["th", "st", "nd", "rd"], x = C % 100;
      return "[" + C + ($[(x - 20) % 10] || $[x] || $[0]) + "]";
    } }, v = function(C, $, x) {
      var T = String(C);
      return !T || T.length >= $ ? C : "" + Array($ + 1 - T.length).join(x) + C;
    }, b = { s: v, z: function(C) {
      var $ = -C.utcOffset(), x = Math.abs($), T = Math.floor(x / 60), _ = x % 60;
      return ($ <= 0 ? "+" : "-") + v(T, 2, "0") + ":" + v(_, 2, "0");
    }, m: function C($, x) {
      if ($.date() < x.date())
        return -C(x, $);
      var T = 12 * (x.year() - $.year()) + (x.month() - $.month()), _ = $.clone().add(T, S), N = x - _ < 0, E = $.clone().add(T + (N ? -1 : 1), S);
      return +(-(T + (x - _) / (N ? _ - E : E - _)) || 0);
    }, a: function(C) {
      return C < 0 ? Math.ceil(C) || 0 : Math.floor(C);
    }, p: function(C) {
      return { M: S, y: p, w: d, d: h, D: f, h: s, m: l, s: a, ms: i, Q: O }[C] || String(C || "").toLowerCase().replace(/s$/, "");
    }, u: function(C) {
      return C === void 0;
    } }, g = "en", w = {};
    w[g] = u;
    var R = function(C) {
      return C instanceof H;
    }, D = function C($, x, T) {
      var _;
      if (!$)
        return g;
      if (typeof $ == "string") {
        var N = $.toLowerCase();
        w[N] && (_ = N), x && (w[N] = x, _ = N);
        var E = $.split("-");
        if (!_ && E.length > 1)
          return C(E[0]);
      } else {
        var F = $.name;
        w[F] = $, _ = F;
      }
      return !T && _ && (g = _), _ || !T && g;
    }, j = function(C, $) {
      if (R(C))
        return C.clone();
      var x = typeof $ == "object" ? $ : {};
      return x.date = C, x.args = arguments, new H(x);
    }, M = b;
    M.l = D, M.i = R, M.w = function(C, $) {
      return j(C, { locale: $.$L, utc: $.$u, x: $.$x, $offset: $.$offset });
    };
    var H = function() {
      function C(x) {
        this.$L = D(x.locale, null, !0), this.parse(x);
      }
      var $ = C.prototype;
      return $.parse = function(x) {
        this.$d = function(T) {
          var _ = T.date, N = T.utc;
          if (_ === null)
            return new Date(NaN);
          if (M.u(_))
            return new Date();
          if (_ instanceof Date)
            return new Date(_);
          if (typeof _ == "string" && !/Z$/i.test(_)) {
            var E = _.match(k);
            if (E) {
              var F = E[2] - 1 || 0, V = (E[7] || "0").substring(0, 3);
              return N ? new Date(Date.UTC(E[1], F, E[3] || 1, E[4] || 0, E[5] || 0, E[6] || 0, V)) : new Date(E[1], F, E[3] || 1, E[4] || 0, E[5] || 0, E[6] || 0, V);
            }
          }
          return new Date(_);
        }(x), this.$x = x.x || {}, this.init();
      }, $.init = function() {
        var x = this.$d;
        this.$y = x.getFullYear(), this.$M = x.getMonth(), this.$D = x.getDate(), this.$W = x.getDay(), this.$H = x.getHours(), this.$m = x.getMinutes(), this.$s = x.getSeconds(), this.$ms = x.getMilliseconds();
      }, $.$utils = function() {
        return M;
      }, $.isValid = function() {
        return this.$d.toString() !== P;
      }, $.isSame = function(x, T) {
        var _ = j(x);
        return this.startOf(T) <= _ && _ <= this.endOf(T);
      }, $.isAfter = function(x, T) {
        return j(x) < this.startOf(T);
      }, $.isBefore = function(x, T) {
        return this.endOf(T) < j(x);
      }, $.$g = function(x, T, _) {
        return M.u(x) ? this[T] : this.set(_, x);
      }, $.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, $.valueOf = function() {
        return this.$d.getTime();
      }, $.startOf = function(x, T) {
        var _ = this, N = !!M.u(T) || T, E = M.p(x), F = function(ie, ne) {
          var me = M.w(_.$u ? Date.UTC(_.$y, ne, ie) : new Date(_.$y, ne, ie), _);
          return N ? me : me.endOf(h);
        }, V = function(ie, ne) {
          return M.w(_.toDate()[ie].apply(_.toDate("s"), (N ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(ne)), _);
        }, z = this.$W, W = this.$M, L = this.$D, Z = "set" + (this.$u ? "UTC" : "");
        switch (E) {
          case p:
            return N ? F(1, 0) : F(31, 11);
          case S:
            return N ? F(1, W) : F(0, W + 1);
          case d:
            var te = this.$locale().weekStart || 0, re = (z < te ? z + 7 : z) - te;
            return F(N ? L - re : L + (6 - re), W);
          case h:
          case f:
            return V(Z + "Hours", 0);
          case s:
            return V(Z + "Minutes", 1);
          case l:
            return V(Z + "Seconds", 2);
          case a:
            return V(Z + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, $.endOf = function(x) {
        return this.startOf(x, !1);
      }, $.$set = function(x, T) {
        var _, N = M.p(x), E = "set" + (this.$u ? "UTC" : ""), F = (_ = {}, _[h] = E + "Date", _[f] = E + "Date", _[S] = E + "Month", _[p] = E + "FullYear", _[s] = E + "Hours", _[l] = E + "Minutes", _[a] = E + "Seconds", _[i] = E + "Milliseconds", _)[N], V = N === h ? this.$D + (T - this.$W) : T;
        if (N === S || N === p) {
          var z = this.clone().set(f, 1);
          z.$d[F](V), z.init(), this.$d = z.set(f, Math.min(this.$D, z.daysInMonth())).$d;
        } else
          F && this.$d[F](V);
        return this.init(), this;
      }, $.set = function(x, T) {
        return this.clone().$set(x, T);
      }, $.get = function(x) {
        return this[M.p(x)]();
      }, $.add = function(x, T) {
        var _, N = this;
        x = Number(x);
        var E = M.p(T), F = function(W) {
          var L = j(N);
          return M.w(L.date(L.date() + Math.round(W * x)), N);
        };
        if (E === S)
          return this.set(S, this.$M + x);
        if (E === p)
          return this.set(p, this.$y + x);
        if (E === h)
          return F(1);
        if (E === d)
          return F(7);
        var V = (_ = {}, _[l] = n, _[s] = o, _[a] = r, _)[E] || 1, z = this.$d.getTime() + x * V;
        return M.w(z, this);
      }, $.subtract = function(x, T) {
        return this.add(-1 * x, T);
      }, $.format = function(x) {
        var T = this, _ = this.$locale();
        if (!this.isValid())
          return _.invalidDate || P;
        var N = x || "YYYY-MM-DDTHH:mm:ssZ", E = M.z(this), F = this.$H, V = this.$m, z = this.$M, W = _.weekdays, L = _.months, Z = function(ne, me, ve, Se) {
          return ne && (ne[me] || ne(T, N)) || ve[me].slice(0, Se);
        }, te = function(ne) {
          return M.s(F % 12 || 12, ne, "0");
        }, re = _.meridiem || function(ne, me, ve) {
          var Se = ne < 12 ? "AM" : "PM";
          return ve ? Se.toLowerCase() : Se;
        }, ie = { YY: String(this.$y).slice(-2), YYYY: this.$y, M: z + 1, MM: M.s(z + 1, 2, "0"), MMM: Z(_.monthsShort, z, L, 3), MMMM: Z(L, z), D: this.$D, DD: M.s(this.$D, 2, "0"), d: String(this.$W), dd: Z(_.weekdaysMin, this.$W, W, 2), ddd: Z(_.weekdaysShort, this.$W, W, 3), dddd: W[this.$W], H: String(F), HH: M.s(F, 2, "0"), h: te(1), hh: te(2), a: re(F, V, !0), A: re(F, V, !1), m: String(V), mm: M.s(V, 2, "0"), s: String(this.$s), ss: M.s(this.$s, 2, "0"), SSS: M.s(this.$ms, 3, "0"), Z: E };
        return N.replace(A, function(ne, me) {
          return me || ie[ne] || E.replace(":", "");
        });
      }, $.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, $.diff = function(x, T, _) {
        var N, E = M.p(T), F = j(x), V = (F.utcOffset() - this.utcOffset()) * n, z = this - F, W = M.m(this, F);
        return W = (N = {}, N[p] = W / 12, N[S] = W, N[O] = W / 3, N[d] = (z - V) / 6048e5, N[h] = (z - V) / 864e5, N[s] = z / o, N[l] = z / n, N[a] = z / r, N)[E] || z, _ ? W : M.a(W);
      }, $.daysInMonth = function() {
        return this.endOf(S).$D;
      }, $.$locale = function() {
        return w[this.$L];
      }, $.locale = function(x, T) {
        if (!x)
          return this.$L;
        var _ = this.clone(), N = D(x, T, !0);
        return N && (_.$L = N), _;
      }, $.clone = function() {
        return M.w(this.$d, this);
      }, $.toDate = function() {
        return new Date(this.valueOf());
      }, $.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, $.toISOString = function() {
        return this.$d.toISOString();
      }, $.toString = function() {
        return this.$d.toUTCString();
      }, C;
    }(), K = H.prototype;
    return j.prototype = K, [["$ms", i], ["$s", a], ["$m", l], ["$H", s], ["$W", h], ["$M", S], ["$y", p], ["$D", f]].forEach(function(C) {
      K[C[1]] = function($) {
        return this.$g($, C[0], C[1]);
      };
    }), j.extend = function(C, $) {
      return C.$i || (C($, H, j), C.$i = !0), j;
    }, j.locale = D, j.isDayjs = R, j.unix = function(C) {
      return j(1e3 * C);
    }, j.en = w[g], j.Ls = w, j.p = {}, j;
  });
})(Ci);
const je = Ci.exports, hc = /* @__PURE__ */ new Map([
  ["en", {
    placeholder: "Select date",
    mon: "Mon",
    tue: "Tue",
    wed: "Wed",
    thu: "Thu",
    fri: "Fri",
    sat: "Sat",
    sun: "Sun"
  }],
  ["th", {
    placeholder: "กรุณาเลือกวันที่",
    mon: "จ",
    tue: "อ",
    wed: "พ",
    thu: "พฤ",
    fri: "ศ",
    sat: "ส",
    sun: "อา"
  }],
  ["vi", {
    placeholder: "Lựa chọn thời gian",
    mon: "T2",
    tue: "T3",
    wed: "T4",
    thu: "T5",
    fri: "T6",
    sat: "T7",
    sun: "CN"
  }],
  ["id", {
    placeholder: "Pilih tanggal",
    mon: "Sen",
    tue: "Sel",
    wed: "Rab",
    thu: "Kam",
    fri: "Jum",
    sat: "Sab",
    sun: "Min"
  }],
  ["ms", {
    placeholder: "Pilih tarikh",
    mon: "Isn",
    tue: "Sel",
    wed: "Rabu",
    thu: "Kha",
    fri: "Jum",
    sat: "Sab",
    sun: "Ahad"
  }]
]), mc = hc, nn = (e, t) => Array(t - e + 1).fill(0).map((r, n) => e + n);
function gc(e, t = 1) {
  const r = e.length;
  if (!r || t < 1)
    return e;
  let n = 0, o = 0;
  const i = Array(Math.ceil(r / t));
  for (; n < r; )
    i[o++] = e.slice(n, n += t);
  return i;
}
const vc = {
  ref: "pickerEl",
  class: "bstar-calendar-panel"
}, bc = { class: "bstar-calendar-panel__header" }, wc = { class: "bstar-calendar-panel__header__month" }, Sc = { class: "bstar-calendar-panel__body" }, Oc = {
  cellspacing: "0",
  cellpadding: "0"
}, Ec = ["onClick"], Ac = {
  name: "BDatePicker"
}, xc = /* @__PURE__ */ ge(we(be({}, Ac), {
  props: {
    modelValue: null,
    format: { default: "YYYY-MM-DD" },
    disabled: { type: Boolean, default: !1 },
    locale: { default: "en" },
    error: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "change", "panel-change", "visible-change", "focus", "blur"],
  setup(e, { emit: t }) {
    const r = e, n = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"], o = 7, i = 6 * o, a = "bstar-calendar-panel__body-cell", l = new Date().getTime(), { format: s, modelValue: h, locale: d, error: S } = Ae(r), O = fe(je(m(h))), p = fe(!1), f = fe(m(O).format(m(s))), { isMobile: P } = ni(), k = Q(() => mc.get(m(d))), A = Q(() => m(O).year() || je(l).year()), u = Q(() => {
      const N = m(O).month();
      return N || N === 0 ? N : je(l).month();
    }), v = Q(() => {
      var N, E;
      return (E = (N = m(k)) == null ? void 0 : N.placeholder) != null ? E : "";
    }), b = Q(() => je(new Date(m(A), m(u), 1)).format("YYYY-MM")), g = Q(() => {
      const N = "bstar-date-picker";
      return [N, {
        [`${N}--error`]: m(S)
      }];
    }), w = Q(
      () => je(new Date(m(A), m(u), 1)).format("YYYY-MM-DD")
    ), R = Q(() => je(m(w)).day()), D = Q(() => {
      const N = je(new Date(m(A), m(u), 1)).daysInMonth(), E = je(new Date(m(A), m(u) - 1, 1)).daysInMonth(), F = je(new Date(m(A), m(u) + 1, 1)).daysInMonth(), V = nn(1, N).map((L) => ({
        year: m(A),
        month: m(u) + 1,
        day: L,
        active: !0
      })).map((L) => we(be({}, L), { date: `${L.year}-${L.month}-${L.day}` })).map((L) => we(be({}, L), {
        today: je().isSame(je(L.date), "day"),
        selected: m(h) ? je(L.date).isSame(je(m(h)), "date") : !1
      })), z = nn(1, E).map((L) => ({
        year: m(u) === 0 ? m(A) - 1 : m(A),
        month: m(u) === 0 ? 12 : m(u),
        day: L,
        active: !1,
        today: !1,
        selected: !1
      })).map((L) => we(be({}, L), { date: `${L.year}-${L.month}-${L.day}` })).slice(-(m(R) || 7)), W = nn(1, F).map((L) => ({
        year: m(u) === 11 ? m(A) + 1 : m(A),
        month: m(u) === 11 ? 1 : m(u) + 2,
        day: L,
        active: !1,
        today: !1,
        selected: !1
      })).map((L) => we(be({}, L), { date: `${L.year}-${L.month}-${L.day}` })).slice(0, i - (m(R) || 7) - N);
      return gc([
        ...z,
        ...V,
        ...W
      ], o);
    }), j = (N) => {
      t(
        "panel-change",
        m(O),
        N
      );
    }, M = () => {
      O.value = m(O).subtract(1, "month"), j("month");
    }, H = () => {
      O.value = m(O).add(1, "month"), j("month");
    }, K = () => {
      O.value = m(O).subtract(1, "year"), j("year");
    }, C = () => {
      O.value = m(O).add(1, "year"), j("year");
    }, $ = (N) => {
      O.value = je(N), !(!m(O) || !m(O).isValid()) && (f.value = m(O).format(m(s)), t("update:modelValue", m(f)), t("change", m(f), m(O).valueOf()), p.value = !1, t("visible-change", !1));
    }, x = (N) => {
      const E = je(N, m(s));
      if (!N) {
        t("update:modelValue", ""), t("change", "", "");
        return;
      }
      E.isValid() && (O.value = E, t("update:modelValue", m(f)), t("change", m(f), m(O).valueOf()), p.value = !1, t("visible-change", !1));
    }, T = (N) => {
      p.value = !0, t("focus", N), t("visible-change", !0);
    }, _ = (N) => {
      p.value = !1, O.value = je(m(h)), t("visible-change", !1), t("blur", N);
    };
    return (N, E) => Lt((Y(), ee("div", {
      class: oe(m(g))
    }, [
      m(P) ? (Y(), Ne(hn, {
        key: 0,
        modelValue: f.value,
        "onUpdate:modelValue": E[0] || (E[0] = (F) => f.value = F),
        type: "date",
        disabled: e.disabled,
        error: m(S),
        placeholder: m(v),
        onChange: x
      }, null, 8, ["modelValue", "disabled", "error", "placeholder"])) : (Y(), Ne($i, {
        key: 1,
        visible: p.value,
        placement: "bottom-start",
        offset: 4
      }, {
        content: Ie(() => [
          G("div", vc, [
            G("div", bc, [
              G("div", null, [
                G("i", {
                  class: "icon-double-arrow last",
                  onClick: K
                }),
                G("i", {
                  class: "icon-arrow last",
                  onClick: M
                })
              ]),
              G("p", wc, ye(m(b)), 1),
              G("div", null, [
                G("i", {
                  class: "icon-arrow next",
                  onClick: H
                }),
                G("i", {
                  class: "icon-double-arrow next",
                  onClick: C
                })
              ])
            ]),
            G("div", Sc, [
              G("table", Oc, [
                G("thead", null, [
                  G("tr", null, [
                    (Y(), ee(rt, null, It(n, (F) => G("th", { key: F }, ye(F), 1)), 64))
                  ])
                ]),
                G("tbody", null, [
                  (Y(!0), ee(rt, null, It(m(D), (F, V) => (Y(), ee("tr", { key: V }, [
                    (Y(!0), ee(rt, null, It(F, (z) => (Y(), ee("td", {
                      key: z.date,
                      onClick: Vo((W) => $(z.date), ["prevent"])
                    }, [
                      G("div", {
                        class: oe([a, {
                          [`${a}--active`]: z.active,
                          [`${a}--today`]: z.today,
                          [`${a}--selected`]: z.selected
                        }])
                      }, ye(z.day), 3)
                    ], 8, Ec))), 128))
                  ]))), 128))
                ])
              ])
            ])
          ], 512)
        ]),
        default: Ie(() => [
          Tr(hn, {
            modelValue: f.value,
            "onUpdate:modelValue": E[1] || (E[1] = (F) => f.value = F),
            placeholder: m(v),
            disabled: e.disabled,
            error: m(S),
            onChange: x,
            onFocus: T
          }, {
            suffix: Ie(() => [
              G("i", {
                class: "icon-time",
                onClick: T
              })
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder", "disabled", "error"])
        ]),
        _: 1
      }, 8, ["visible"]))
    ], 2)), [
      [m(Bn), _]
    ]);
  }
})), Pc = /* @__PURE__ */ st(xc, [["__scopeId", "data-v-1227f91b"]]);
ze(Pc);
const jc = {
  key: 0,
  class: "bstar-tooltip__arrow"
}, Rc = {
  name: "BTooltipContent"
}, _c = /* @__PURE__ */ ge(we(be({}, Rc), {
  props: {
    reference: null,
    content: null,
    placement: { default: "bottom" },
    offset: { default: 0 },
    skipping: { default: 0 },
    showArrow: { type: Boolean, default: !0 },
    zIndex: { default: 8e3 }
  },
  setup(e) {
    const t = e, { reference: r, placement: n, offset: o, skipping: i, zIndex: a } = Ae(t), l = fe(), s = fe(), h = () => {
      !r.value || !l.value || (s.value = ri(
        r.value,
        l.value,
        ki({
          placement: m(n),
          offset: m(o),
          skipping: m(i)
        })
      ), setTimeout(() => {
        d();
      }, 500));
    }, d = () => {
      Wo(() => {
        var O;
        (O = m(s)) == null || O.update();
      });
    }, S = Q(() => ({
      "z-index": m(a)
    }));
    return gr(() => {
      h();
    }), (O, p) => (Y(), Ne(wn, { to: "body" }, [
      G("div", {
        ref_key: "contentEl",
        ref: l,
        class: "bstar-tooltip__content",
        style: Ut(m(S))
      }, [
        G("p", null, ye(e.content), 1),
        e.showArrow ? (Y(), ee("div", jc)) : he("", !0)
      ], 4)
    ]));
  }
})), kc = /* @__PURE__ */ st(_c, [["__scopeId", "data-v-51fdbb2c"]]), $c = { class: "bstar-tooltip" }, Cc = {
  name: "BTooltip"
}, Nc = /* @__PURE__ */ ge(we(be({}, Cc), {
  props: {
    visible: { type: Boolean, default: !1 },
    content: { default: "" },
    trigger: { default: "hover" },
    placement: { default: "top" },
    offset: { default: 0 },
    skipping: { default: 0 },
    disabled: { type: Boolean, default: !1 },
    showArrow: { type: Boolean, default: !0 },
    zIndex: { default: 8e3 }
  },
  emits: ["update:visible"],
  setup(e, { emit: t }) {
    var r;
    const n = e, {
      placement: o,
      trigger: i,
      visible: a,
      offset: l,
      skipping: s,
      disabled: h
    } = Ae(n), d = fe(null), S = fe((r = m(a)) != null ? r : !1), O = (k) => {
      const { type: A } = k;
      if (m(i) === "hover")
        switch (A) {
          case "mouseenter":
            f();
            break;
          case "mouseleave":
            P();
            break;
        }
    };
    Ft(() => m(a), (k) => {
      k ? f() : P();
    });
    const p = () => {
      m(i) === "click" && (m(S) ? P() : f());
    }, f = () => {
      m(h) || (S.value = !0, t("update:visible", !0));
    }, P = () => {
      m(h) || (S.value = !1, t("update:visible", !1));
    };
    return (k, A) => Lt((Y(), ee("div", $c, [
      G("div", {
        ref_key: "reference",
        ref: d,
        class: "bstar-tooltip__body-reference",
        onMouseenter: O,
        onMouseleave: O,
        onClick: p
      }, [
        Re(k.$slots, "default", {}, void 0, !0)
      ], 544),
      S.value ? (Y(), Ne(kc, {
        key: 0,
        content: e.content,
        reference: d.value,
        placement: m(o),
        offset: m(l),
        "z-index": e.zIndex,
        skipping: m(s),
        "show-arrow": e.showArrow
      }, null, 8, ["content", "reference", "placement", "offset", "z-index", "skipping", "show-arrow"])) : he("", !0)
    ])), [
      [m(Bn), P]
    ]);
  }
})), Tc = /* @__PURE__ */ st(Nc, [["__scopeId", "data-v-9bfba902"]]);
ze(Tc);
const Dc = {
  name: "BCollapsedTransition"
}, Mc = /* @__PURE__ */ ge(we(be({}, Dc), {
  props: {
    appear: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = (l) => {
      l.dataset || (l.dataset = {}), l.style.maxHeight = 0;
    }, r = (l) => {
      l.dataset.oldOverflow = l.style.overflow, l.scrollHeight !== 0 ? l.style.maxHeight = `${l.scrollHeight}px` : l.style.maxHeight = 0, l.style.overflow = "hidden";
    }, n = (l) => {
      l.style.maxHeight = "", l.style.overflow = l.dataset.oldOverflow;
    }, o = (l) => {
      l.dataset || (l.dataset = {}), l.dataset.oldOverflow = l.style.overflow, l.style.maxHeight = `${l.scrollHeight}px`, l.style.overflow = "hidden";
    }, i = (l) => {
      l.scrollHeight !== 0 && (l.style.maxHeight = 0);
    }, a = (l) => {
      l.style.maxHeight = "", l.style.overflow = l.dataset.oldOverflow;
    };
    return (l, s) => (Y(), Ne(qo, {
      name: "bstar-collapse",
      appear: e.appear,
      onBeforeEnter: t,
      onEnter: r,
      onAfterEnter: n,
      onBeforeLeave: o,
      onLeave: i,
      onAfterLeave: a
    }, {
      default: Ie(() => [
        Re(l.$slots, "default")
      ]),
      _: 3
    }, 8, ["appear"]));
  }
}));
ze(Mc);
const Bc = ["id"], Ic = { class: "bstar-message__content" }, Fc = { class: "bstar-message__container" }, Uc = {
  name: "BMessage"
};
we(be({}, Uc), {
  props: {
    id: null,
    type: { default: "warning" },
    text: null,
    duration: { default: 3e3 },
    offset: { default: 96 },
    onDestroy: { type: Function, default: () => {
    } },
    onClose: { type: Function, default: () => {
    } }
  },
  setup(e) {
    const t = e, { id: r, type: n, text: o, offset: i, duration: a } = Ae(t), l = fe(!1), s = Q(() => ({
      top: `${i.value}px`
    })), h = Q(() => `bstar-message-${r == null ? void 0 : r.value}`), d = Q(() => ({
      "bstar-message__icon": !0,
      [`bstar-message__icon--${m(n)}`]: !0
    })), S = () => {
      setTimeout(() => {
        O();
      }, a.value);
    }, O = () => {
      l.value = !1;
    };
    return gr(() => {
      S(), l.value = !0;
    }), (p, f) => (Y(), Ne(qo, {
      name: "message-fade",
      onBeforeLeave: e.onClose,
      onAfterLeave: e.onDestroy
    }, {
      default: Ie(() => [
        Lt(G("div", {
          id: m(h),
          class: "bstar-message",
          style: Ut(m(s))
        }, [
          G("div", Ic, [
            G("i", {
              class: oe(m(d))
            }, null, 2),
            G("p", Fc, ye(m(o)), 1)
          ])
        ], 12, Bc), [
          [ga, l.value]
        ])
      ]),
      _: 1
    }, 8, ["onBeforeLeave", "onAfterLeave"]));
  }
});
var Lc = Object.create, In = Object.defineProperty, Hc = Object.getOwnPropertyDescriptor, zc = Object.getOwnPropertyNames, xo = Object.getOwnPropertySymbols, Wc = Object.getPrototypeOf, Ni = Object.prototype.hasOwnProperty, Vc = Object.prototype.propertyIsEnumerable, Po = (e, t, r) => t in e ? In(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, qc = (e, t) => {
  for (var r in t || (t = {}))
    Ni.call(t, r) && Po(e, r, t[r]);
  if (xo)
    for (var r of xo(t))
      Vc.call(t, r) && Po(e, r, t[r]);
  return e;
}, ke = (e, t) => () => (t || e((t = { exports: {} }).exports, t), t.exports), Gc = (e, t, r, n) => {
  if (t && typeof t == "object" || typeof t == "function")
    for (let o of zc(t))
      !Ni.call(e, o) && o !== r && In(e, o, { get: () => t[o], enumerable: !(n = Hc(t, o)) || n.enumerable });
  return e;
}, Jc = (e, t, r) => (r = e != null ? Lc(Wc(e)) : {}, Gc(t || !e || !e.__esModule ? In(r, "default", { value: e, enumerable: !0 }) : r, e)), Yc = (e, t, r) => new Promise((n, o) => {
  var i = (s) => {
    try {
      l(r.next(s));
    } catch (h) {
      o(h);
    }
  }, a = (s) => {
    try {
      l(r.throw(s));
    } catch (h) {
      o(h);
    }
  }, l = (s) => s.done ? n(s.value) : Promise.resolve(s.value).then(i, a);
  l((r = r.apply(e, t)).next());
}), Qc = ke((e, t) => {
  t.exports = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var r = {}, n = Symbol("test"), o = Object(n);
    if (typeof n == "string" || Object.prototype.toString.call(n) !== "[object Symbol]" || Object.prototype.toString.call(o) !== "[object Symbol]")
      return !1;
    var i = 42;
    r[n] = i;
    for (n in r)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(r).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(r).length !== 0)
      return !1;
    var a = Object.getOwnPropertySymbols(r);
    if (a.length !== 1 || a[0] !== n || !Object.prototype.propertyIsEnumerable.call(r, n))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var l = Object.getOwnPropertyDescriptor(r, n);
      if (l.value !== i || l.enumerable !== !0)
        return !1;
    }
    return !0;
  };
}), Kc = ke((e, t) => {
  var r = typeof Symbol != "undefined" && Symbol, n = Qc();
  t.exports = function() {
    return typeof r != "function" || typeof Symbol != "function" || typeof r("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : n();
  };
}), Zc = ke((e, t) => {
  var r = "Function.prototype.bind called on incompatible ", n = Array.prototype.slice, o = Object.prototype.toString, i = "[object Function]";
  t.exports = function(a) {
    var l = this;
    if (typeof l != "function" || o.call(l) !== i)
      throw new TypeError(r + l);
    for (var s = n.call(arguments, 1), h, d = function() {
      if (this instanceof h) {
        var P = l.apply(this, s.concat(n.call(arguments)));
        return Object(P) === P ? P : this;
      } else
        return l.apply(a, s.concat(n.call(arguments)));
    }, S = Math.max(0, l.length - s.length), O = [], p = 0; p < S; p++)
      O.push("$" + p);
    if (h = Function("binder", "return function (" + O.join(",") + "){ return binder.apply(this,arguments); }")(d), l.prototype) {
      var f = function() {
      };
      f.prototype = l.prototype, h.prototype = new f(), f.prototype = null;
    }
    return h;
  };
}), Fn = ke((e, t) => {
  var r = Zc();
  t.exports = Function.prototype.bind || r;
}), Xc = ke((e, t) => {
  var r = Fn();
  t.exports = r.call(Function.call, Object.prototype.hasOwnProperty);
}), Un = ke((e, t) => {
  var r, n = SyntaxError, o = Function, i = TypeError, a = function(C) {
    try {
      return o('"use strict"; return (' + C + ").constructor;")();
    } catch ($) {
    }
  }, l = Object.getOwnPropertyDescriptor;
  if (l)
    try {
      l({}, "");
    } catch (C) {
      l = null;
    }
  var s = function() {
    throw new i();
  }, h = l ? function() {
    try {
      return arguments.callee, s;
    } catch (C) {
      try {
        return l(arguments, "callee").get;
      } catch ($) {
        return s;
      }
    }
  }() : s, d = Kc()(), S = Object.getPrototypeOf || function(C) {
    return C.__proto__;
  }, O = {}, p = typeof Uint8Array == "undefined" ? r : S(Uint8Array), f = { "%AggregateError%": typeof AggregateError == "undefined" ? r : AggregateError, "%Array%": Array, "%ArrayBuffer%": typeof ArrayBuffer == "undefined" ? r : ArrayBuffer, "%ArrayIteratorPrototype%": d ? S([][Symbol.iterator]()) : r, "%AsyncFromSyncIteratorPrototype%": r, "%AsyncFunction%": O, "%AsyncGenerator%": O, "%AsyncGeneratorFunction%": O, "%AsyncIteratorPrototype%": O, "%Atomics%": typeof Atomics == "undefined" ? r : Atomics, "%BigInt%": typeof BigInt == "undefined" ? r : BigInt, "%BigInt64Array%": typeof BigInt64Array == "undefined" ? r : BigInt64Array, "%BigUint64Array%": typeof BigUint64Array == "undefined" ? r : BigUint64Array, "%Boolean%": Boolean, "%DataView%": typeof DataView == "undefined" ? r : DataView, "%Date%": Date, "%decodeURI%": decodeURI, "%decodeURIComponent%": decodeURIComponent, "%encodeURI%": encodeURI, "%encodeURIComponent%": encodeURIComponent, "%Error%": Error, "%eval%": eval, "%EvalError%": EvalError, "%Float32Array%": typeof Float32Array == "undefined" ? r : Float32Array, "%Float64Array%": typeof Float64Array == "undefined" ? r : Float64Array, "%FinalizationRegistry%": typeof FinalizationRegistry == "undefined" ? r : FinalizationRegistry, "%Function%": o, "%GeneratorFunction%": O, "%Int8Array%": typeof Int8Array == "undefined" ? r : Int8Array, "%Int16Array%": typeof Int16Array == "undefined" ? r : Int16Array, "%Int32Array%": typeof Int32Array == "undefined" ? r : Int32Array, "%isFinite%": isFinite, "%isNaN%": isNaN, "%IteratorPrototype%": d ? S(S([][Symbol.iterator]())) : r, "%JSON%": typeof JSON == "object" ? JSON : r, "%Map%": typeof Map == "undefined" ? r : Map, "%MapIteratorPrototype%": typeof Map == "undefined" || !d ? r : S((/* @__PURE__ */ new Map())[Symbol.iterator]()), "%Math%": Math, "%Number%": Number, "%Object%": Object, "%parseFloat%": parseFloat, "%parseInt%": parseInt, "%Promise%": typeof Promise == "undefined" ? r : Promise, "%Proxy%": typeof Proxy == "undefined" ? r : Proxy, "%RangeError%": RangeError, "%ReferenceError%": ReferenceError, "%Reflect%": typeof Reflect == "undefined" ? r : Reflect, "%RegExp%": RegExp, "%Set%": typeof Set == "undefined" ? r : Set, "%SetIteratorPrototype%": typeof Set == "undefined" || !d ? r : S((/* @__PURE__ */ new Set())[Symbol.iterator]()), "%SharedArrayBuffer%": typeof SharedArrayBuffer == "undefined" ? r : SharedArrayBuffer, "%String%": String, "%StringIteratorPrototype%": d ? S(""[Symbol.iterator]()) : r, "%Symbol%": d ? Symbol : r, "%SyntaxError%": n, "%ThrowTypeError%": h, "%TypedArray%": p, "%TypeError%": i, "%Uint8Array%": typeof Uint8Array == "undefined" ? r : Uint8Array, "%Uint8ClampedArray%": typeof Uint8ClampedArray == "undefined" ? r : Uint8ClampedArray, "%Uint16Array%": typeof Uint16Array == "undefined" ? r : Uint16Array, "%Uint32Array%": typeof Uint32Array == "undefined" ? r : Uint32Array, "%URIError%": URIError, "%WeakMap%": typeof WeakMap == "undefined" ? r : WeakMap, "%WeakRef%": typeof WeakRef == "undefined" ? r : WeakRef, "%WeakSet%": typeof WeakSet == "undefined" ? r : WeakSet };
  try {
    null.error;
  } catch (C) {
    P = S(S(C)), f["%Error.prototype%"] = P;
  }
  var P, k = function C($) {
    var x;
    if ($ === "%AsyncFunction%")
      x = a("async function () {}");
    else if ($ === "%GeneratorFunction%")
      x = a("function* () {}");
    else if ($ === "%AsyncGeneratorFunction%")
      x = a("async function* () {}");
    else if ($ === "%AsyncGenerator%") {
      var T = C("%AsyncGeneratorFunction%");
      T && (x = T.prototype);
    } else if ($ === "%AsyncIteratorPrototype%") {
      var _ = C("%AsyncGenerator%");
      _ && (x = S(_.prototype));
    }
    return f[$] = x, x;
  }, A = { "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"], "%ArrayPrototype%": ["Array", "prototype"], "%ArrayProto_entries%": ["Array", "prototype", "entries"], "%ArrayProto_forEach%": ["Array", "prototype", "forEach"], "%ArrayProto_keys%": ["Array", "prototype", "keys"], "%ArrayProto_values%": ["Array", "prototype", "values"], "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"], "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"], "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"], "%BooleanPrototype%": ["Boolean", "prototype"], "%DataViewPrototype%": ["DataView", "prototype"], "%DatePrototype%": ["Date", "prototype"], "%ErrorPrototype%": ["Error", "prototype"], "%EvalErrorPrototype%": ["EvalError", "prototype"], "%Float32ArrayPrototype%": ["Float32Array", "prototype"], "%Float64ArrayPrototype%": ["Float64Array", "prototype"], "%FunctionPrototype%": ["Function", "prototype"], "%Generator%": ["GeneratorFunction", "prototype"], "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"], "%Int8ArrayPrototype%": ["Int8Array", "prototype"], "%Int16ArrayPrototype%": ["Int16Array", "prototype"], "%Int32ArrayPrototype%": ["Int32Array", "prototype"], "%JSONParse%": ["JSON", "parse"], "%JSONStringify%": ["JSON", "stringify"], "%MapPrototype%": ["Map", "prototype"], "%NumberPrototype%": ["Number", "prototype"], "%ObjectPrototype%": ["Object", "prototype"], "%ObjProto_toString%": ["Object", "prototype", "toString"], "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"], "%PromisePrototype%": ["Promise", "prototype"], "%PromiseProto_then%": ["Promise", "prototype", "then"], "%Promise_all%": ["Promise", "all"], "%Promise_reject%": ["Promise", "reject"], "%Promise_resolve%": ["Promise", "resolve"], "%RangeErrorPrototype%": ["RangeError", "prototype"], "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"], "%RegExpPrototype%": ["RegExp", "prototype"], "%SetPrototype%": ["Set", "prototype"], "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"], "%StringPrototype%": ["String", "prototype"], "%SymbolPrototype%": ["Symbol", "prototype"], "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"], "%TypedArrayPrototype%": ["TypedArray", "prototype"], "%TypeErrorPrototype%": ["TypeError", "prototype"], "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"], "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"], "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"], "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"], "%URIErrorPrototype%": ["URIError", "prototype"], "%WeakMapPrototype%": ["WeakMap", "prototype"], "%WeakSetPrototype%": ["WeakSet", "prototype"] }, u = Fn(), v = Xc(), b = u.call(Function.call, Array.prototype.concat), g = u.call(Function.apply, Array.prototype.splice), w = u.call(Function.call, String.prototype.replace), R = u.call(Function.call, String.prototype.slice), D = u.call(Function.call, RegExp.prototype.exec), j = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, M = /\\(\\)?/g, H = function(C) {
    var $ = R(C, 0, 1), x = R(C, -1);
    if ($ === "%" && x !== "%")
      throw new n("invalid intrinsic syntax, expected closing `%`");
    if (x === "%" && $ !== "%")
      throw new n("invalid intrinsic syntax, expected opening `%`");
    var T = [];
    return w(C, j, function(_, N, E, F) {
      T[T.length] = E ? w(F, M, "$1") : N || _;
    }), T;
  }, K = function(C, $) {
    var x = C, T;
    if (v(A, x) && (T = A[x], x = "%" + T[0] + "%"), v(f, x)) {
      var _ = f[x];
      if (_ === O && (_ = k(x)), typeof _ == "undefined" && !$)
        throw new i("intrinsic " + C + " exists, but is not available. Please file an issue!");
      return { alias: T, name: x, value: _ };
    }
    throw new n("intrinsic " + C + " does not exist!");
  };
  t.exports = function(C, $) {
    if (typeof C != "string" || C.length === 0)
      throw new i("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof $ != "boolean")
      throw new i('"allowMissing" argument must be a boolean');
    if (D(/^%?[^%]*%?$/, C) === null)
      throw new n("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var x = H(C), T = x.length > 0 ? x[0] : "", _ = K("%" + T + "%", $), N = _.name, E = _.value, F = !1, V = _.alias;
    V && (T = V[0], g(x, b([0, 1], V)));
    for (var z = 1, W = !0; z < x.length; z += 1) {
      var L = x[z], Z = R(L, 0, 1), te = R(L, -1);
      if ((Z === '"' || Z === "'" || Z === "`" || te === '"' || te === "'" || te === "`") && Z !== te)
        throw new n("property names with quotes must have matching quotes");
      if ((L === "constructor" || !W) && (F = !0), T += "." + L, N = "%" + T + "%", v(f, N))
        E = f[N];
      else if (E != null) {
        if (!(L in E)) {
          if (!$)
            throw new i("base intrinsic for " + C + " exists, but the property is not available.");
          return;
        }
        if (l && z + 1 >= x.length) {
          var re = l(E, L);
          W = !!re, W && "get" in re && !("originalValue" in re.get) ? E = re.get : E = E[L];
        } else
          W = v(E, L), E = E[L];
        W && !F && (f[N] = E);
      }
    }
    return E;
  };
}), ef = ke((e, t) => {
  var r = Fn(), n = Un(), o = n("%Function.prototype.apply%"), i = n("%Function.prototype.call%"), a = n("%Reflect.apply%", !0) || r.call(i, o), l = n("%Object.getOwnPropertyDescriptor%", !0), s = n("%Object.defineProperty%", !0), h = n("%Math.max%");
  if (s)
    try {
      s({}, "a", { value: 1 });
    } catch (S) {
      s = null;
    }
  t.exports = function(S) {
    var O = a(r, i, arguments);
    if (l && s) {
      var p = l(O, "length");
      p.configurable && s(O, "length", { value: 1 + h(0, S.length - (arguments.length - 1)) });
    }
    return O;
  };
  var d = function() {
    return a(r, o, arguments);
  };
  s ? s(t.exports, "apply", { value: d }) : t.exports.apply = d;
}), tf = ke((e, t) => {
  var r = Un(), n = ef(), o = n(r("String.prototype.indexOf"));
  t.exports = function(i, a) {
    var l = r(i, !!a);
    return typeof l == "function" && o(i, ".prototype.") > -1 ? n(l) : l;
  };
}), rf = ke(() => {
}), nf = ke((e, t) => {
  var r = typeof Map == "function" && Map.prototype, n = Object.getOwnPropertyDescriptor && r ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, o = r && n && typeof n.get == "function" ? n.get : null, i = r && Map.prototype.forEach, a = typeof Set == "function" && Set.prototype, l = Object.getOwnPropertyDescriptor && a ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, s = a && l && typeof l.get == "function" ? l.get : null, h = a && Set.prototype.forEach, d = typeof WeakMap == "function" && WeakMap.prototype, S = d ? WeakMap.prototype.has : null, O = typeof WeakSet == "function" && WeakSet.prototype, p = O ? WeakSet.prototype.has : null, f = typeof WeakRef == "function" && WeakRef.prototype, P = f ? WeakRef.prototype.deref : null, k = Boolean.prototype.valueOf, A = Object.prototype.toString, u = Function.prototype.toString, v = String.prototype.match, b = String.prototype.slice, g = String.prototype.replace, w = String.prototype.toUpperCase, R = String.prototype.toLowerCase, D = RegExp.prototype.test, j = Array.prototype.concat, M = Array.prototype.join, H = Array.prototype.slice, K = Math.floor, C = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, $ = Object.getOwnPropertySymbols, x = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, T = typeof Symbol == "function" && typeof Symbol.iterator == "object", _ = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === T || "symbol") ? Symbol.toStringTag : null, N = Object.prototype.propertyIsEnumerable, E = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(c) {
    return c.__proto__;
  } : null);
  function F(c, y) {
    if (c === 1 / 0 || c === -1 / 0 || c !== c || c && c > -1e3 && c < 1e3 || D.call(/e/, y))
      return y;
    var q = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof c == "number") {
      var J = c < 0 ? -K(-c) : K(c);
      if (J !== c) {
        var X = String(J), U = b.call(y, X.length + 1);
        return g.call(X, q, "$&_") + "." + g.call(g.call(U, /([0-9]{3})/g, "$&_"), /_$/, "");
      }
    }
    return g.call(y, q, "$&_");
  }
  var V = rf(), z = V.custom, W = pe(z) ? z : null;
  t.exports = function c(y, q, J, X) {
    var U = q || {};
    if (ce(U, "quoteStyle") && U.quoteStyle !== "single" && U.quoteStyle !== "double")
      throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (ce(U, "maxStringLength") && (typeof U.maxStringLength == "number" ? U.maxStringLength < 0 && U.maxStringLength !== 1 / 0 : U.maxStringLength !== null))
      throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var xe = ce(U, "customInspect") ? U.customInspect : !0;
    if (typeof xe != "boolean" && xe !== "symbol")
      throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if (ce(U, "indent") && U.indent !== null && U.indent !== "	" && !(parseInt(U.indent, 10) === U.indent && U.indent > 0))
      throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if (ce(U, "numericSeparator") && typeof U.numericSeparator != "boolean")
      throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var $e = U.numericSeparator;
    if (typeof y == "undefined")
      return "undefined";
    if (y === null)
      return "null";
    if (typeof y == "boolean")
      return y ? "true" : "false";
    if (typeof y == "string")
      return ft(y, U);
    if (typeof y == "number") {
      if (y === 0)
        return 1 / 0 / y > 0 ? "0" : "-0";
      var ue = String(y);
      return $e ? F(y, ue) : ue;
    }
    if (typeof y == "bigint") {
      var Pe = String(y) + "n";
      return $e ? F(y, Pe) : Pe;
    }
    var At = typeof U.depth == "undefined" ? 5 : U.depth;
    if (typeof J == "undefined" && (J = 0), J >= At && At > 0 && typeof y == "object")
      return te(y) ? "[Array]" : "[Object]";
    var Me = Qr(U, J);
    if (typeof X == "undefined")
      X = [];
    else if (wt(X, y) >= 0)
      return "[Circular]";
    function de(Be, et, Zr) {
      if (et && (X = H.call(X), X.push(et)), Zr) {
        var sr = { depth: U.depth };
        return ce(U, "quoteStyle") && (sr.quoteStyle = U.quoteStyle), c(Be, sr, J + 1, X);
      }
      return c(Be, U, J + 1, X);
    }
    if (typeof y == "function" && !ie(y)) {
      var er = Zt(y), tr = Ze(y, de);
      return "[Function" + (er ? ": " + er : " (anonymous)") + "]" + (tr.length > 0 ? " { " + M.call(tr, ", ") + " }" : "");
    }
    if (pe(y)) {
      var rr = T ? g.call(String(y), /^(Symbol\(.*\))_[^)]*$/, "$1") : x.call(y);
      return typeof y == "object" && !T ? Ce(rr) : rr;
    }
    if (Mt(y)) {
      for (var qe = "<" + R.call(String(y.nodeName)), xt = y.attributes || [], Xe = 0; Xe < xt.length; Xe++)
        qe += " " + xt[Xe].name + "=" + L(Z(xt[Xe].value), "double", U);
      return qe += ">", y.childNodes && y.childNodes.length && (qe += "..."), qe += "</" + R.call(String(y.nodeName)) + ">", qe;
    }
    if (te(y)) {
      if (y.length === 0)
        return "[]";
      var Pt = Ze(y, de);
      return Me && !Yr(Pt) ? "[" + Et(Pt, Me) + "]" : "[ " + M.call(Pt, ", ") + " ]";
    }
    if (ne(y)) {
      var jt = Ze(y, de);
      return !("cause" in Error.prototype) && "cause" in y && !N.call(y, "cause") ? "{ [" + String(y) + "] " + M.call(j.call("[cause]: " + de(y.cause), jt), ", ") + " }" : jt.length === 0 ? "[" + String(y) + "]" : "{ [" + String(y) + "] " + M.call(jt, ", ") + " }";
    }
    if (typeof y == "object" && xe) {
      if (W && typeof y[W] == "function" && V)
        return V(y, { depth: At - J });
      if (xe !== "symbol" && typeof y.inspect == "function")
        return y.inspect();
    }
    if (Ve(y)) {
      var nr = [];
      return i && i.call(y, function(Be, et) {
        nr.push(de(et, y, !0) + " => " + de(Be, y));
      }), Xt("Map", o.call(y), nr, Me);
    }
    if (Dt(y)) {
      var or = [];
      return h && h.call(y, function(Be) {
        or.push(de(Be, y));
      }), Xt("Set", s.call(y), or, Me);
    }
    if (ct(y))
      return Ot("WeakMap");
    if (St(y))
      return Ot("WeakSet");
    if (Tt(y))
      return Ot("WeakRef");
    if (ve(y))
      return Ce(de(Number(y)));
    if (We(y))
      return Ce(de(C.call(y)));
    if (Se(y))
      return Ce(k.call(y));
    if (me(y))
      return Ce(de(String(y)));
    if (!re(y) && !ie(y)) {
      var Rt = Ze(y, de), ir = E ? E(y) === Object.prototype : y instanceof Object || y.constructor === Object, _t = y instanceof Object ? "" : "null prototype", ar = !ir && _ && Object(y) === y && _ in y ? b.call(ae(y), 8, -1) : _t ? "Object" : "", Kr = ir || typeof y.constructor != "function" ? "" : y.constructor.name ? y.constructor.name + " " : "", kt = Kr + (ar || _t ? "[" + M.call(j.call([], ar || [], _t || []), ": ") + "] " : "");
      return Rt.length === 0 ? kt + "{}" : Me ? kt + "{" + Et(Rt, Me) + "}" : kt + "{ " + M.call(Rt, ", ") + " }";
    }
    return String(y);
  };
  function L(c, y, q) {
    var J = (q.quoteStyle || y) === "double" ? '"' : "'";
    return J + c + J;
  }
  function Z(c) {
    return g.call(String(c), /"/g, "&quot;");
  }
  function te(c) {
    return ae(c) === "[object Array]" && (!_ || !(typeof c == "object" && _ in c));
  }
  function re(c) {
    return ae(c) === "[object Date]" && (!_ || !(typeof c == "object" && _ in c));
  }
  function ie(c) {
    return ae(c) === "[object RegExp]" && (!_ || !(typeof c == "object" && _ in c));
  }
  function ne(c) {
    return ae(c) === "[object Error]" && (!_ || !(typeof c == "object" && _ in c));
  }
  function me(c) {
    return ae(c) === "[object String]" && (!_ || !(typeof c == "object" && _ in c));
  }
  function ve(c) {
    return ae(c) === "[object Number]" && (!_ || !(typeof c == "object" && _ in c));
  }
  function Se(c) {
    return ae(c) === "[object Boolean]" && (!_ || !(typeof c == "object" && _ in c));
  }
  function pe(c) {
    if (T)
      return c && typeof c == "object" && c instanceof Symbol;
    if (typeof c == "symbol")
      return !0;
    if (!c || typeof c != "object" || !x)
      return !1;
    try {
      return x.call(c), !0;
    } catch (y) {
    }
    return !1;
  }
  function We(c) {
    if (!c || typeof c != "object" || !C)
      return !1;
    try {
      return C.call(c), !0;
    } catch (y) {
    }
    return !1;
  }
  var Ke = Object.prototype.hasOwnProperty || function(c) {
    return c in this;
  };
  function ce(c, y) {
    return Ke.call(c, y);
  }
  function ae(c) {
    return A.call(c);
  }
  function Zt(c) {
    if (c.name)
      return c.name;
    var y = v.call(u.call(c), /^function\s*([\w$]+)/);
    return y ? y[1] : null;
  }
  function wt(c, y) {
    if (c.indexOf)
      return c.indexOf(y);
    for (var q = 0, J = c.length; q < J; q++)
      if (c[q] === y)
        return q;
    return -1;
  }
  function Ve(c) {
    if (!o || !c || typeof c != "object")
      return !1;
    try {
      o.call(c);
      try {
        s.call(c);
      } catch (y) {
        return !0;
      }
      return c instanceof Map;
    } catch (y) {
    }
    return !1;
  }
  function ct(c) {
    if (!S || !c || typeof c != "object")
      return !1;
    try {
      S.call(c, S);
      try {
        p.call(c, p);
      } catch (y) {
        return !0;
      }
      return c instanceof WeakMap;
    } catch (y) {
    }
    return !1;
  }
  function Tt(c) {
    if (!P || !c || typeof c != "object")
      return !1;
    try {
      return P.call(c), !0;
    } catch (y) {
    }
    return !1;
  }
  function Dt(c) {
    if (!s || !c || typeof c != "object")
      return !1;
    try {
      s.call(c);
      try {
        o.call(c);
      } catch (y) {
        return !0;
      }
      return c instanceof Set;
    } catch (y) {
    }
    return !1;
  }
  function St(c) {
    if (!p || !c || typeof c != "object")
      return !1;
    try {
      p.call(c, p);
      try {
        S.call(c, S);
      } catch (y) {
        return !0;
      }
      return c instanceof WeakSet;
    } catch (y) {
    }
    return !1;
  }
  function Mt(c) {
    return !c || typeof c != "object" ? !1 : typeof HTMLElement != "undefined" && c instanceof HTMLElement ? !0 : typeof c.nodeName == "string" && typeof c.getAttribute == "function";
  }
  function ft(c, y) {
    if (c.length > y.maxStringLength) {
      var q = c.length - y.maxStringLength, J = "... " + q + " more character" + (q > 1 ? "s" : "");
      return ft(b.call(c, 0, y.maxStringLength), y) + J;
    }
    var X = g.call(g.call(c, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, Bt);
    return L(X, "single", y);
  }
  function Bt(c) {
    var y = c.charCodeAt(0), q = { 8: "b", 9: "t", 10: "n", 12: "f", 13: "r" }[y];
    return q ? "\\" + q : "\\x" + (y < 16 ? "0" : "") + w.call(y.toString(16));
  }
  function Ce(c) {
    return "Object(" + c + ")";
  }
  function Ot(c) {
    return c + " { ? }";
  }
  function Xt(c, y, q, J) {
    var X = J ? Et(q, J) : M.call(q, ", ");
    return c + " (" + y + ") {" + X + "}";
  }
  function Yr(c) {
    for (var y = 0; y < c.length; y++)
      if (wt(c[y], `
`) >= 0)
        return !1;
    return !0;
  }
  function Qr(c, y) {
    var q;
    if (c.indent === "	")
      q = "	";
    else if (typeof c.indent == "number" && c.indent > 0)
      q = M.call(Array(c.indent + 1), " ");
    else
      return null;
    return { base: q, prev: M.call(Array(y + 1), q) };
  }
  function Et(c, y) {
    if (c.length === 0)
      return "";
    var q = `
` + y.prev + y.base;
    return q + M.call(c, "," + q) + `
` + y.prev;
  }
  function Ze(c, y) {
    var q = te(c), J = [];
    if (q) {
      J.length = c.length;
      for (var X = 0; X < c.length; X++)
        J[X] = ce(c, X) ? y(c[X], c) : "";
    }
    var U = typeof $ == "function" ? $(c) : [], xe;
    if (T) {
      xe = {};
      for (var $e = 0; $e < U.length; $e++)
        xe["$" + U[$e]] = U[$e];
    }
    for (var ue in c)
      !ce(c, ue) || q && String(Number(ue)) === ue && ue < c.length || T && xe["$" + ue] instanceof Symbol || (D.call(/[^\w$]/, ue) ? J.push(y(ue, c) + ": " + y(c[ue], c)) : J.push(ue + ": " + y(c[ue], c)));
    if (typeof $ == "function")
      for (var Pe = 0; Pe < U.length; Pe++)
        N.call(c, U[Pe]) && J.push("[" + y(U[Pe]) + "]: " + y(c[U[Pe]], c));
    return J;
  }
}), of = ke((e, t) => {
  var r = Un(), n = tf(), o = nf(), i = r("%TypeError%"), a = r("%WeakMap%", !0), l = r("%Map%", !0), s = n("WeakMap.prototype.get", !0), h = n("WeakMap.prototype.set", !0), d = n("WeakMap.prototype.has", !0), S = n("Map.prototype.get", !0), O = n("Map.prototype.set", !0), p = n("Map.prototype.has", !0), f = function(u, v) {
    for (var b = u, g; (g = b.next) !== null; b = g)
      if (g.key === v)
        return b.next = g.next, g.next = u.next, u.next = g, g;
  }, P = function(u, v) {
    var b = f(u, v);
    return b && b.value;
  }, k = function(u, v, b) {
    var g = f(u, v);
    g ? g.value = b : u.next = { key: v, next: u.next, value: b };
  }, A = function(u, v) {
    return !!f(u, v);
  };
  t.exports = function() {
    var u, v, b, g = { assert: function(w) {
      if (!g.has(w))
        throw new i("Side channel does not contain " + o(w));
    }, get: function(w) {
      if (a && w && (typeof w == "object" || typeof w == "function")) {
        if (u)
          return s(u, w);
      } else if (l) {
        if (v)
          return S(v, w);
      } else if (b)
        return P(b, w);
    }, has: function(w) {
      if (a && w && (typeof w == "object" || typeof w == "function")) {
        if (u)
          return d(u, w);
      } else if (l) {
        if (v)
          return p(v, w);
      } else if (b)
        return A(b, w);
      return !1;
    }, set: function(w, R) {
      a && w && (typeof w == "object" || typeof w == "function") ? (u || (u = new a()), h(u, w, R)) : l ? (v || (v = new l()), O(v, w, R)) : (b || (b = { key: {}, next: null }), k(b, w, R));
    } };
    return g;
  };
}), Ln = ke((e, t) => {
  var r = String.prototype.replace, n = /%20/g, o = { RFC1738: "RFC1738", RFC3986: "RFC3986" };
  t.exports = { default: o.RFC3986, formatters: { RFC1738: function(i) {
    return r.call(i, n, "+");
  }, RFC3986: function(i) {
    return String(i);
  } }, RFC1738: o.RFC1738, RFC3986: o.RFC3986 };
}), Ti = ke((e, t) => {
  var r = Ln(), n = Object.prototype.hasOwnProperty, o = Array.isArray, i = function() {
    for (var A = [], u = 0; u < 256; ++u)
      A.push("%" + ((u < 16 ? "0" : "") + u.toString(16)).toUpperCase());
    return A;
  }(), a = function(A) {
    for (; A.length > 1; ) {
      var u = A.pop(), v = u.obj[u.prop];
      if (o(v)) {
        for (var b = [], g = 0; g < v.length; ++g)
          typeof v[g] != "undefined" && b.push(v[g]);
        u.obj[u.prop] = b;
      }
    }
  }, l = function(A, u) {
    for (var v = u && u.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, b = 0; b < A.length; ++b)
      typeof A[b] != "undefined" && (v[b] = A[b]);
    return v;
  }, s = function A(u, v, b) {
    if (!v)
      return u;
    if (typeof v != "object") {
      if (o(u))
        u.push(v);
      else if (u && typeof u == "object")
        (b && (b.plainObjects || b.allowPrototypes) || !n.call(Object.prototype, v)) && (u[v] = !0);
      else
        return [u, v];
      return u;
    }
    if (!u || typeof u != "object")
      return [u].concat(v);
    var g = u;
    return o(u) && !o(v) && (g = l(u, b)), o(u) && o(v) ? (v.forEach(function(w, R) {
      if (n.call(u, R)) {
        var D = u[R];
        D && typeof D == "object" && w && typeof w == "object" ? u[R] = A(D, w, b) : u.push(w);
      } else
        u[R] = w;
    }), u) : Object.keys(v).reduce(function(w, R) {
      var D = v[R];
      return n.call(w, R) ? w[R] = A(w[R], D, b) : w[R] = D, w;
    }, g);
  }, h = function(A, u) {
    return Object.keys(u).reduce(function(v, b) {
      return v[b] = u[b], v;
    }, A);
  }, d = function(A, u, v) {
    var b = A.replace(/\+/g, " ");
    if (v === "iso-8859-1")
      return b.replace(/%[0-9a-f]{2}/gi, unescape);
    try {
      return decodeURIComponent(b);
    } catch (g) {
      return b;
    }
  }, S = function(A, u, v, b, g) {
    if (A.length === 0)
      return A;
    var w = A;
    if (typeof A == "symbol" ? w = Symbol.prototype.toString.call(A) : typeof A != "string" && (w = String(A)), v === "iso-8859-1")
      return escape(w).replace(/%u[0-9a-f]{4}/gi, function(M) {
        return "%26%23" + parseInt(M.slice(2), 16) + "%3B";
      });
    for (var R = "", D = 0; D < w.length; ++D) {
      var j = w.charCodeAt(D);
      if (j === 45 || j === 46 || j === 95 || j === 126 || j >= 48 && j <= 57 || j >= 65 && j <= 90 || j >= 97 && j <= 122 || g === r.RFC1738 && (j === 40 || j === 41)) {
        R += w.charAt(D);
        continue;
      }
      if (j < 128) {
        R = R + i[j];
        continue;
      }
      if (j < 2048) {
        R = R + (i[192 | j >> 6] + i[128 | j & 63]);
        continue;
      }
      if (j < 55296 || j >= 57344) {
        R = R + (i[224 | j >> 12] + i[128 | j >> 6 & 63] + i[128 | j & 63]);
        continue;
      }
      D += 1, j = 65536 + ((j & 1023) << 10 | w.charCodeAt(D) & 1023), R += i[240 | j >> 18] + i[128 | j >> 12 & 63] + i[128 | j >> 6 & 63] + i[128 | j & 63];
    }
    return R;
  }, O = function(A) {
    for (var u = [{ obj: { o: A }, prop: "o" }], v = [], b = 0; b < u.length; ++b)
      for (var g = u[b], w = g.obj[g.prop], R = Object.keys(w), D = 0; D < R.length; ++D) {
        var j = R[D], M = w[j];
        typeof M == "object" && M !== null && v.indexOf(M) === -1 && (u.push({ obj: w, prop: j }), v.push(M));
      }
    return a(u), A;
  }, p = function(A) {
    return Object.prototype.toString.call(A) === "[object RegExp]";
  }, f = function(A) {
    return !A || typeof A != "object" ? !1 : !!(A.constructor && A.constructor.isBuffer && A.constructor.isBuffer(A));
  }, P = function(A, u) {
    return [].concat(A, u);
  }, k = function(A, u) {
    if (o(A)) {
      for (var v = [], b = 0; b < A.length; b += 1)
        v.push(u(A[b]));
      return v;
    }
    return u(A);
  };
  t.exports = { arrayToObject: l, assign: h, combine: P, compact: O, decode: d, encode: S, isBuffer: f, isRegExp: p, maybeMap: k, merge: s };
}), af = ke((e, t) => {
  var r = of(), n = Ti(), o = Ln(), i = Object.prototype.hasOwnProperty, a = { brackets: function(u) {
    return u + "[]";
  }, comma: "comma", indices: function(u, v) {
    return u + "[" + v + "]";
  }, repeat: function(u) {
    return u;
  } }, l = Array.isArray, s = String.prototype.split, h = Array.prototype.push, d = function(u, v) {
    h.apply(u, l(v) ? v : [v]);
  }, S = Date.prototype.toISOString, O = o.default, p = { addQueryPrefix: !1, allowDots: !1, charset: "utf-8", charsetSentinel: !1, delimiter: "&", encode: !0, encoder: n.encode, encodeValuesOnly: !1, format: O, formatter: o.formatters[O], indices: !1, serializeDate: function(u) {
    return S.call(u);
  }, skipNulls: !1, strictNullHandling: !1 }, f = function(u) {
    return typeof u == "string" || typeof u == "number" || typeof u == "boolean" || typeof u == "symbol" || typeof u == "bigint";
  }, P = {}, k = function u(v, b, g, w, R, D, j, M, H, K, C, $, x, T, _, N) {
    for (var E = v, F = N, V = 0, z = !1; (F = F.get(P)) !== void 0 && !z; ) {
      var W = F.get(v);
      if (V += 1, typeof W != "undefined") {
        if (W === V)
          throw new RangeError("Cyclic object value");
        z = !0;
      }
      typeof F.get(P) == "undefined" && (V = 0);
    }
    if (typeof M == "function" ? E = M(b, E) : E instanceof Date ? E = C(E) : g === "comma" && l(E) && (E = n.maybeMap(E, function(ae) {
      return ae instanceof Date ? C(ae) : ae;
    })), E === null) {
      if (R)
        return j && !T ? j(b, p.encoder, _, "key", $) : b;
      E = "";
    }
    if (f(E) || n.isBuffer(E)) {
      if (j) {
        var L = T ? b : j(b, p.encoder, _, "key", $);
        if (g === "comma" && T) {
          for (var Z = s.call(String(E), ","), te = "", re = 0; re < Z.length; ++re)
            te += (re === 0 ? "" : ",") + x(j(Z[re], p.encoder, _, "value", $));
          return [x(L) + (w && l(E) && Z.length === 1 ? "[]" : "") + "=" + te];
        }
        return [x(L) + "=" + x(j(E, p.encoder, _, "value", $))];
      }
      return [x(b) + "=" + x(String(E))];
    }
    var ie = [];
    if (typeof E == "undefined")
      return ie;
    var ne;
    if (g === "comma" && l(E))
      ne = [{ value: E.length > 0 ? E.join(",") || null : void 0 }];
    else if (l(M))
      ne = M;
    else {
      var me = Object.keys(E);
      ne = H ? me.sort(H) : me;
    }
    for (var ve = w && l(E) && E.length === 1 ? b + "[]" : b, Se = 0; Se < ne.length; ++Se) {
      var pe = ne[Se], We = typeof pe == "object" && typeof pe.value != "undefined" ? pe.value : E[pe];
      if (!(D && We === null)) {
        var Ke = l(E) ? typeof g == "function" ? g(ve, pe) : ve : ve + (K ? "." + pe : "[" + pe + "]");
        N.set(v, V);
        var ce = r();
        ce.set(P, N), d(ie, u(We, Ke, g, w, R, D, j, M, H, K, C, $, x, T, _, ce));
      }
    }
    return ie;
  }, A = function(u) {
    if (!u)
      return p;
    if (u.encoder !== null && typeof u.encoder != "undefined" && typeof u.encoder != "function")
      throw new TypeError("Encoder has to be a function.");
    var v = u.charset || p.charset;
    if (typeof u.charset != "undefined" && u.charset !== "utf-8" && u.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var b = o.default;
    if (typeof u.format != "undefined") {
      if (!i.call(o.formatters, u.format))
        throw new TypeError("Unknown format option provided.");
      b = u.format;
    }
    var g = o.formatters[b], w = p.filter;
    return (typeof u.filter == "function" || l(u.filter)) && (w = u.filter), { addQueryPrefix: typeof u.addQueryPrefix == "boolean" ? u.addQueryPrefix : p.addQueryPrefix, allowDots: typeof u.allowDots == "undefined" ? p.allowDots : !!u.allowDots, charset: v, charsetSentinel: typeof u.charsetSentinel == "boolean" ? u.charsetSentinel : p.charsetSentinel, delimiter: typeof u.delimiter == "undefined" ? p.delimiter : u.delimiter, encode: typeof u.encode == "boolean" ? u.encode : p.encode, encoder: typeof u.encoder == "function" ? u.encoder : p.encoder, encodeValuesOnly: typeof u.encodeValuesOnly == "boolean" ? u.encodeValuesOnly : p.encodeValuesOnly, filter: w, format: b, formatter: g, serializeDate: typeof u.serializeDate == "function" ? u.serializeDate : p.serializeDate, skipNulls: typeof u.skipNulls == "boolean" ? u.skipNulls : p.skipNulls, sort: typeof u.sort == "function" ? u.sort : null, strictNullHandling: typeof u.strictNullHandling == "boolean" ? u.strictNullHandling : p.strictNullHandling };
  };
  t.exports = function(u, v) {
    var b = u, g = A(v), w, R;
    typeof g.filter == "function" ? (R = g.filter, b = R("", b)) : l(g.filter) && (R = g.filter, w = R);
    var D = [];
    if (typeof b != "object" || b === null)
      return "";
    var j;
    v && v.arrayFormat in a ? j = v.arrayFormat : v && "indices" in v ? j = v.indices ? "indices" : "repeat" : j = "indices";
    var M = a[j];
    if (v && "commaRoundTrip" in v && typeof v.commaRoundTrip != "boolean")
      throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var H = M === "comma" && v && v.commaRoundTrip;
    w || (w = Object.keys(b)), g.sort && w.sort(g.sort);
    for (var K = r(), C = 0; C < w.length; ++C) {
      var $ = w[C];
      g.skipNulls && b[$] === null || d(D, k(b[$], $, M, H, g.strictNullHandling, g.skipNulls, g.encode ? g.encoder : null, g.filter, g.sort, g.allowDots, g.serializeDate, g.format, g.formatter, g.encodeValuesOnly, g.charset, K));
    }
    var x = D.join(g.delimiter), T = g.addQueryPrefix === !0 ? "?" : "";
    return g.charsetSentinel && (g.charset === "iso-8859-1" ? T += "utf8=%26%2310003%3B&" : T += "utf8=%E2%9C%93&"), x.length > 0 ? T + x : "";
  };
}), sf = ke((e, t) => {
  var r = Ti(), n = Object.prototype.hasOwnProperty, o = Array.isArray, i = { allowDots: !1, allowPrototypes: !1, allowSparse: !1, arrayLimit: 20, charset: "utf-8", charsetSentinel: !1, comma: !1, decoder: r.decode, delimiter: "&", depth: 5, ignoreQueryPrefix: !1, interpretNumericEntities: !1, parameterLimit: 1e3, parseArrays: !0, plainObjects: !1, strictNullHandling: !1 }, a = function(f) {
    return f.replace(/&#(\d+);/g, function(P, k) {
      return String.fromCharCode(parseInt(k, 10));
    });
  }, l = function(f, P) {
    return f && typeof f == "string" && P.comma && f.indexOf(",") > -1 ? f.split(",") : f;
  }, s = "utf8=%26%2310003%3B", h = "utf8=%E2%9C%93", d = function(f, P) {
    var k = {}, A = P.ignoreQueryPrefix ? f.replace(/^\?/, "") : f, u = P.parameterLimit === 1 / 0 ? void 0 : P.parameterLimit, v = A.split(P.delimiter, u), b = -1, g, w = P.charset;
    if (P.charsetSentinel)
      for (g = 0; g < v.length; ++g)
        v[g].indexOf("utf8=") === 0 && (v[g] === h ? w = "utf-8" : v[g] === s && (w = "iso-8859-1"), b = g, g = v.length);
    for (g = 0; g < v.length; ++g)
      if (g !== b) {
        var R = v[g], D = R.indexOf("]="), j = D === -1 ? R.indexOf("=") : D + 1, M, H;
        j === -1 ? (M = P.decoder(R, i.decoder, w, "key"), H = P.strictNullHandling ? null : "") : (M = P.decoder(R.slice(0, j), i.decoder, w, "key"), H = r.maybeMap(l(R.slice(j + 1), P), function(K) {
          return P.decoder(K, i.decoder, w, "value");
        })), H && P.interpretNumericEntities && w === "iso-8859-1" && (H = a(H)), R.indexOf("[]=") > -1 && (H = o(H) ? [H] : H), n.call(k, M) ? k[M] = r.combine(k[M], H) : k[M] = H;
      }
    return k;
  }, S = function(f, P, k, A) {
    for (var u = A ? P : l(P, k), v = f.length - 1; v >= 0; --v) {
      var b, g = f[v];
      if (g === "[]" && k.parseArrays)
        b = [].concat(u);
      else {
        b = k.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
        var w = g.charAt(0) === "[" && g.charAt(g.length - 1) === "]" ? g.slice(1, -1) : g, R = parseInt(w, 10);
        !k.parseArrays && w === "" ? b = { 0: u } : !isNaN(R) && g !== w && String(R) === w && R >= 0 && k.parseArrays && R <= k.arrayLimit ? (b = [], b[R] = u) : w !== "__proto__" && (b[w] = u);
      }
      u = b;
    }
    return u;
  }, O = function(f, P, k, A) {
    if (f) {
      var u = k.allowDots ? f.replace(/\.([^.[]+)/g, "[$1]") : f, v = /(\[[^[\]]*])/, b = /(\[[^[\]]*])/g, g = k.depth > 0 && v.exec(u), w = g ? u.slice(0, g.index) : u, R = [];
      if (w) {
        if (!k.plainObjects && n.call(Object.prototype, w) && !k.allowPrototypes)
          return;
        R.push(w);
      }
      for (var D = 0; k.depth > 0 && (g = b.exec(u)) !== null && D < k.depth; ) {
        if (D += 1, !k.plainObjects && n.call(Object.prototype, g[1].slice(1, -1)) && !k.allowPrototypes)
          return;
        R.push(g[1]);
      }
      return g && R.push("[" + u.slice(g.index) + "]"), S(R, P, k, A);
    }
  }, p = function(f) {
    if (!f)
      return i;
    if (f.decoder !== null && f.decoder !== void 0 && typeof f.decoder != "function")
      throw new TypeError("Decoder has to be a function.");
    if (typeof f.charset != "undefined" && f.charset !== "utf-8" && f.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var P = typeof f.charset == "undefined" ? i.charset : f.charset;
    return { allowDots: typeof f.allowDots == "undefined" ? i.allowDots : !!f.allowDots, allowPrototypes: typeof f.allowPrototypes == "boolean" ? f.allowPrototypes : i.allowPrototypes, allowSparse: typeof f.allowSparse == "boolean" ? f.allowSparse : i.allowSparse, arrayLimit: typeof f.arrayLimit == "number" ? f.arrayLimit : i.arrayLimit, charset: P, charsetSentinel: typeof f.charsetSentinel == "boolean" ? f.charsetSentinel : i.charsetSentinel, comma: typeof f.comma == "boolean" ? f.comma : i.comma, decoder: typeof f.decoder == "function" ? f.decoder : i.decoder, delimiter: typeof f.delimiter == "string" || r.isRegExp(f.delimiter) ? f.delimiter : i.delimiter, depth: typeof f.depth == "number" || f.depth === !1 ? +f.depth : i.depth, ignoreQueryPrefix: f.ignoreQueryPrefix === !0, interpretNumericEntities: typeof f.interpretNumericEntities == "boolean" ? f.interpretNumericEntities : i.interpretNumericEntities, parameterLimit: typeof f.parameterLimit == "number" ? f.parameterLimit : i.parameterLimit, parseArrays: f.parseArrays !== !1, plainObjects: typeof f.plainObjects == "boolean" ? f.plainObjects : i.plainObjects, strictNullHandling: typeof f.strictNullHandling == "boolean" ? f.strictNullHandling : i.strictNullHandling };
  };
  t.exports = function(f, P) {
    var k = p(P);
    if (f === "" || f === null || typeof f == "undefined")
      return k.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
    for (var A = typeof f == "string" ? d(f, k) : f, u = k.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, v = Object.keys(A), b = 0; b < v.length; ++b) {
      var g = v[b], w = O(g, A[g], k, typeof f == "string");
      u = r.merge(u, w, k);
    }
    return k.allowSparse === !0 ? u : r.compact(u);
  };
}), lf = ke((e, t) => {
  var r = af(), n = sf(), o = Ln();
  t.exports = { formats: o, parse: n, stringify: r };
}), uf = (e) => {
  var t, r, n, o, i, a;
  let l = typeof window != "undefined";
  if (!e && !l)
    return { inBrowser: l };
  let s = e != null ? e : window.navigator.userAgent;
  return { inBrowser: l, isAndroid: s.includes("Android") || s.includes("Adr"), androidVersion: (r = (t = s.match(/Android\s*([\d|\\.]+)/)) == null ? void 0 : t[1]) != null ? r : "0", iosVersion: ((o = (n = s.match(/\s*OS\s*([\d|\\_]+)/)) == null ? void 0 : n[1]) != null ? o : "0").replace(/_/g, "."), isiOS: /iPad|iPhone|iPod/.test(s), isSafari: s.includes("Safari") && !s.includes("Chrome"), isOpera: !!window.opr && !!window.opr.addons || !!window.opera || s.includes("OPR/"), isChrome: s.includes("Chrome"), isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(s), isInApp: /bstar_[a|i]/i.test(s), safariVersion: (a = (i = s.match(/[v|V]ersion\/([\w|.]+)/)) == null ? void 0 : i[1]) != null ? a : "0" };
}, jo = uf();
function Di(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
var { toString: Mi } = Object.prototype, { getPrototypeOf: Hn } = Object, zn = ((e) => (t) => {
  let r = Mi.call(t);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), ut = (e) => (e = e.toLowerCase(), (t) => zn(t) === e), Wr = (e) => (t) => typeof t === e, { isArray: Kt } = Array, mr = Wr("undefined");
function cf(e) {
  return e !== null && !mr(e) && e.constructor !== null && !mr(e.constructor) && vt(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
var Bi = ut("ArrayBuffer");
function ff(e) {
  let t;
  return typeof ArrayBuffer != "undefined" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Bi(e.buffer), t;
}
var pf = Wr("string"), vt = Wr("function"), Ii = Wr("number"), Wn = (e) => e !== null && typeof e == "object", df = (e) => e === !0 || e === !1, kr = (e) => {
  if (zn(e) !== "object")
    return !1;
  let t = Hn(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, yf = ut("Date"), hf = ut("File"), mf = ut("Blob"), gf = ut("FileList"), vf = (e) => Wn(e) && vt(e.pipe), bf = (e) => {
  let t = "[object FormData]";
  return e && (typeof FormData == "function" && e instanceof FormData || Mi.call(e) === t || vt(e.toString) && e.toString() === t);
}, wf = ut("URLSearchParams"), Sf = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Sr(e, t, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e == "undefined")
    return;
  let n, o;
  if (typeof e != "object" && (e = [e]), Kt(e))
    for (n = 0, o = e.length; n < o; n++)
      t.call(null, e[n], n, e);
  else {
    let i = r ? Object.getOwnPropertyNames(e) : Object.keys(e), a = i.length, l;
    for (n = 0; n < a; n++)
      l = i[n], t.call(null, e[l], l, e);
  }
}
function Fi(e, t) {
  t = t.toLowerCase();
  let r = Object.keys(e), n = r.length, o;
  for (; n-- > 0; )
    if (o = r[n], t === o.toLowerCase())
      return o;
  return null;
}
var Ui = (() => typeof globalThis != "undefined" ? globalThis : typeof self != "undefined" ? self : typeof window != "undefined" ? window : global)(), Li = (e) => !mr(e) && e !== Ui;
function mn() {
  let { caseless: e } = Li(this) && this || {}, t = {}, r = (n, o) => {
    let i = e && Fi(t, o) || o;
    kr(t[i]) && kr(n) ? t[i] = mn(t[i], n) : kr(n) ? t[i] = mn({}, n) : Kt(n) ? t[i] = n.slice() : t[i] = n;
  };
  for (let n = 0, o = arguments.length; n < o; n++)
    arguments[n] && Sr(arguments[n], r);
  return t;
}
var Of = (e, t, r, { allOwnKeys: n } = {}) => (Sr(t, (o, i) => {
  r && vt(o) ? e[i] = Di(o, r) : e[i] = o;
}, { allOwnKeys: n }), e), Ef = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), Af = (e, t, r, n) => {
  e.prototype = Object.create(t.prototype, n), e.prototype.constructor = e, Object.defineProperty(e, "super", { value: t.prototype }), r && Object.assign(e.prototype, r);
}, xf = (e, t, r, n) => {
  let o, i, a, l = {};
  if (t = t || {}, e == null)
    return t;
  do {
    for (o = Object.getOwnPropertyNames(e), i = o.length; i-- > 0; )
      a = o[i], (!n || n(a, e, t)) && !l[a] && (t[a] = e[a], l[a] = !0);
    e = r !== !1 && Hn(e);
  } while (e && (!r || r(e, t)) && e !== Object.prototype);
  return t;
}, Pf = (e, t, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= t.length;
  let n = e.indexOf(t, r);
  return n !== -1 && n === r;
}, jf = (e) => {
  if (!e)
    return null;
  if (Kt(e))
    return e;
  let t = e.length;
  if (!Ii(t))
    return null;
  let r = new Array(t);
  for (; t-- > 0; )
    r[t] = e[t];
  return r;
}, Rf = ((e) => (t) => e && t instanceof e)(typeof Uint8Array != "undefined" && Hn(Uint8Array)), _f = (e, t) => {
  let r = (e && e[Symbol.iterator]).call(e), n;
  for (; (n = r.next()) && !n.done; ) {
    let o = n.value;
    t.call(e, o[0], o[1]);
  }
}, kf = (e, t) => {
  let r, n = [];
  for (; (r = e.exec(t)) !== null; )
    n.push(r);
  return n;
}, $f = ut("HTMLFormElement"), Cf = (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(t, r, n) {
  return r.toUpperCase() + n;
}), Ro = (({ hasOwnProperty: e }) => (t, r) => e.call(t, r))(Object.prototype), Nf = ut("RegExp"), Hi = (e, t) => {
  let r = Object.getOwnPropertyDescriptors(e), n = {};
  Sr(r, (o, i) => {
    t(o, i, e) !== !1 && (n[i] = o);
  }), Object.defineProperties(e, n);
}, Tf = (e) => {
  Hi(e, (t, r) => {
    if (vt(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    let n = e[r];
    if (vt(n)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, Df = (e, t) => {
  let r = {}, n = (o) => {
    o.forEach((i) => {
      r[i] = !0;
    });
  };
  return Kt(e) ? n(e) : n(String(e).split(t)), r;
}, Mf = () => {
}, Bf = (e, t) => (e = +e, Number.isFinite(e) ? e : t), on = "abcdefghijklmnopqrstuvwxyz", _o = "0123456789", zi = { DIGIT: _o, ALPHA: on, ALPHA_DIGIT: on + on.toUpperCase() + _o }, If = (e = 16, t = zi.ALPHA_DIGIT) => {
  let r = "", { length: n } = t;
  for (; e--; )
    r += t[Math.random() * n | 0];
  return r;
};
function Ff(e) {
  return !!(e && vt(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
var Uf = (e) => {
  let t = new Array(10), r = (n, o) => {
    if (Wn(n)) {
      if (t.indexOf(n) >= 0)
        return;
      if (!("toJSON" in n)) {
        t[o] = n;
        let i = Kt(n) ? [] : {};
        return Sr(n, (a, l) => {
          let s = r(a, o + 1);
          !mr(s) && (i[l] = s);
        }), t[o] = void 0, i;
      }
    }
    return n;
  };
  return r(e, 0);
}, I = { isArray: Kt, isArrayBuffer: Bi, isBuffer: cf, isFormData: bf, isArrayBufferView: ff, isString: pf, isNumber: Ii, isBoolean: df, isObject: Wn, isPlainObject: kr, isUndefined: mr, isDate: yf, isFile: hf, isBlob: mf, isRegExp: Nf, isFunction: vt, isStream: vf, isURLSearchParams: wf, isTypedArray: Rf, isFileList: gf, forEach: Sr, merge: mn, extend: Of, trim: Sf, stripBOM: Ef, inherits: Af, toFlatObject: xf, kindOf: zn, kindOfTest: ut, endsWith: Pf, toArray: jf, forEachEntry: _f, matchAll: kf, isHTMLForm: $f, hasOwnProperty: Ro, hasOwnProp: Ro, reduceDescriptors: Hi, freezeMethods: Tf, toObjectSet: Df, toCamelCase: Cf, noop: Mf, toFiniteNumber: Bf, findKey: Fi, global: Ui, isContextDefined: Li, ALPHABET: zi, generateString: If, isSpecCompliantForm: Ff, toJSONObject: Uf };
function Jt(e, t, r, n, o) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), r && (this.config = r), n && (this.request = n), o && (this.response = o);
}
I.inherits(Jt, Error, { toJSON: function() {
  return { message: this.message, name: this.name, description: this.description, number: this.number, fileName: this.fileName, lineNumber: this.lineNumber, columnNumber: this.columnNumber, stack: this.stack, config: I.toJSONObject(this.config), code: this.code, status: this.response && this.response.status ? this.response.status : null };
} });
var Wi = Jt.prototype, Vi = {};
["ERR_BAD_OPTION_VALUE", "ERR_BAD_OPTION", "ECONNABORTED", "ETIMEDOUT", "ERR_NETWORK", "ERR_FR_TOO_MANY_REDIRECTS", "ERR_DEPRECATED", "ERR_BAD_RESPONSE", "ERR_BAD_REQUEST", "ERR_CANCELED", "ERR_NOT_SUPPORT", "ERR_INVALID_URL"].forEach((e) => {
  Vi[e] = { value: e };
});
Object.defineProperties(Jt, Vi);
Object.defineProperty(Wi, "isAxiosError", { value: !0 });
Jt.from = (e, t, r, n, o, i) => {
  let a = Object.create(Wi);
  return I.toFlatObject(e, a, function(l) {
    return l !== Error.prototype;
  }, (l) => l !== "isAxiosError"), Jt.call(a, e.message, t, r, n, o), a.cause = e, a.name = e.name, i && Object.assign(a, i), a;
};
var le = Jt, Lf = null;
function gn(e) {
  return I.isPlainObject(e) || I.isArray(e);
}
function qi(e) {
  return I.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function ko(e, t, r) {
  return e ? e.concat(t).map(function(n, o) {
    return n = qi(n), !r && o ? "[" + n + "]" : n;
  }).join(r ? "." : "") : t;
}
function Hf(e) {
  return I.isArray(e) && !e.some(gn);
}
var zf = I.toFlatObject(I, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function Wf(e, t, r) {
  if (!I.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), r = I.toFlatObject(r, { metaTokens: !0, dots: !1, indexes: !1 }, !1, function(p, f) {
    return !I.isUndefined(f[p]);
  });
  let n = r.metaTokens, o = r.visitor || h, i = r.dots, a = r.indexes, l = (r.Blob || typeof Blob != "undefined" && Blob) && I.isSpecCompliantForm(t);
  if (!I.isFunction(o))
    throw new TypeError("visitor must be a function");
  function s(p) {
    if (p === null)
      return "";
    if (I.isDate(p))
      return p.toISOString();
    if (!l && I.isBlob(p))
      throw new le("Blob is not supported. Use a Buffer instead.");
    return I.isArrayBuffer(p) || I.isTypedArray(p) ? l && typeof Blob == "function" ? new Blob([p]) : Buffer.from(p) : p;
  }
  function h(p, f, P) {
    let k = p;
    if (p && !P && typeof p == "object") {
      if (I.endsWith(f, "{}"))
        f = n ? f : f.slice(0, -2), p = JSON.stringify(p);
      else if (I.isArray(p) && Hf(p) || (I.isFileList(p) || I.endsWith(f, "[]")) && (k = I.toArray(p)))
        return f = qi(f), k.forEach(function(A, u) {
          !(I.isUndefined(A) || A === null) && t.append(a === !0 ? ko([f], u, i) : a === null ? f : f + "[]", s(A));
        }), !1;
    }
    return gn(p) ? !0 : (t.append(ko(P, f, i), s(p)), !1);
  }
  let d = [], S = Object.assign(zf, { defaultVisitor: h, convertValue: s, isVisitable: gn });
  function O(p, f) {
    if (!I.isUndefined(p)) {
      if (d.indexOf(p) !== -1)
        throw Error("Circular reference detected in " + f.join("."));
      d.push(p), I.forEach(p, function(P, k) {
        (!(I.isUndefined(P) || P === null) && o.call(t, P, I.isString(k) ? k.trim() : k, f, S)) === !0 && O(P, f ? f.concat(k) : [k]);
      }), d.pop();
    }
  }
  if (!I.isObject(e))
    throw new TypeError("data must be an object");
  return O(e), t;
}
var Vr = Wf;
function $o(e) {
  let t = { "!": "%21", "'": "%27", "(": "%28", ")": "%29", "~": "%7E", "%20": "+", "%00": "\0" };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return t[r];
  });
}
function Gi(e, t) {
  this._pairs = [], e && Vr(e, this, t);
}
var Ji = Gi.prototype;
Ji.append = function(e, t) {
  this._pairs.push([e, t]);
};
Ji.toString = function(e) {
  let t = e ? function(r) {
    return e.call(this, r, $o);
  } : $o;
  return this._pairs.map(function(r) {
    return t(r[0]) + "=" + t(r[1]);
  }, "").join("&");
};
var Yi = Gi;
function Vf(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function Qi(e, t, r) {
  if (!t)
    return e;
  let n = r && r.encode || Vf, o = r && r.serialize, i;
  if (o ? i = o(t, r) : i = I.isURLSearchParams(t) ? t.toString() : new Yi(t, r).toString(n), i) {
    let a = e.indexOf("#");
    a !== -1 && (e = e.slice(0, a)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
var qf = class {
  constructor() {
    this.handlers = [];
  }
  use(e, t, r) {
    return this.handlers.push({ fulfilled: e, rejected: t, synchronous: r ? r.synchronous : !1, runWhen: r ? r.runWhen : null }), this.handlers.length - 1;
  }
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  clear() {
    this.handlers && (this.handlers = []);
  }
  forEach(e) {
    I.forEach(this.handlers, function(t) {
      t !== null && e(t);
    });
  }
}, Co = qf, Ki = { silentJSONParsing: !0, forcedJSONParsing: !0, clarifyTimeoutError: !1 }, Gf = typeof URLSearchParams != "undefined" ? URLSearchParams : Yi, Jf = typeof FormData != "undefined" ? FormData : null, Yf = typeof Blob != "undefined" ? Blob : null, Qf = (() => {
  let e;
  return typeof navigator != "undefined" && ((e = navigator.product) === "ReactNative" || e === "NativeScript" || e === "NS") ? !1 : typeof window != "undefined" && typeof document != "undefined";
})(), Kf = (() => typeof WorkerGlobalScope != "undefined" && self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), Je = { isBrowser: !0, classes: { URLSearchParams: Gf, FormData: Jf, Blob: Yf }, isStandardBrowserEnv: Qf, isStandardBrowserWebWorkerEnv: Kf, protocols: ["http", "https", "file", "blob", "url", "data"] };
function Zf(e, t) {
  return Vr(e, new Je.classes.URLSearchParams(), Object.assign({ visitor: function(r, n, o, i) {
    return Je.isNode && I.isBuffer(r) ? (this.append(n, r.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
  } }, t));
}
function Xf(e) {
  return I.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function ep(e) {
  let t = {}, r = Object.keys(e), n, o = r.length, i;
  for (n = 0; n < o; n++)
    i = r[n], t[i] = e[i];
  return t;
}
function tp(e) {
  function t(r, n, o, i) {
    let a = r[i++], l = Number.isFinite(+a), s = i >= r.length;
    return a = !a && I.isArray(o) ? o.length : a, s ? (I.hasOwnProp(o, a) ? o[a] = [o[a], n] : o[a] = n, !l) : ((!o[a] || !I.isObject(o[a])) && (o[a] = []), t(r, n, o[a], i) && I.isArray(o[a]) && (o[a] = ep(o[a])), !l);
  }
  if (I.isFormData(e) && I.isFunction(e.entries)) {
    let r = {};
    return I.forEachEntry(e, (n, o) => {
      t(Xf(n), o, r, 0);
    }), r;
  }
  return null;
}
var Zi = tp, rp = { "Content-Type": void 0 };
function np(e, t, r) {
  if (I.isString(e))
    try {
      return (t || JSON.parse)(e), I.trim(e);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (r || JSON.stringify)(e);
}
var qr = { transitional: Ki, adapter: ["xhr", "http"], transformRequest: [function(e, t) {
  let r = t.getContentType() || "", n = r.indexOf("application/json") > -1, o = I.isObject(e);
  if (o && I.isHTMLForm(e) && (e = new FormData(e)), I.isFormData(e))
    return n && n ? JSON.stringify(Zi(e)) : e;
  if (I.isArrayBuffer(e) || I.isBuffer(e) || I.isStream(e) || I.isFile(e) || I.isBlob(e))
    return e;
  if (I.isArrayBufferView(e))
    return e.buffer;
  if (I.isURLSearchParams(e))
    return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
  let i;
  if (o) {
    if (r.indexOf("application/x-www-form-urlencoded") > -1)
      return Zf(e, this.formSerializer).toString();
    if ((i = I.isFileList(e)) || r.indexOf("multipart/form-data") > -1) {
      let a = this.env && this.env.FormData;
      return Vr(i ? { "files[]": e } : e, a && new a(), this.formSerializer);
    }
  }
  return o || n ? (t.setContentType("application/json", !1), np(e)) : e;
}], transformResponse: [function(e) {
  let t = this.transitional || qr.transitional, r = t && t.forcedJSONParsing, n = this.responseType === "json";
  if (e && I.isString(e) && (r && !this.responseType || n)) {
    let o = !(t && t.silentJSONParsing) && n;
    try {
      return JSON.parse(e);
    } catch (i) {
      if (o)
        throw i.name === "SyntaxError" ? le.from(i, le.ERR_BAD_RESPONSE, this, null, this.response) : i;
    }
  }
  return e;
}], timeout: 0, xsrfCookieName: "XSRF-TOKEN", xsrfHeaderName: "X-XSRF-TOKEN", maxContentLength: -1, maxBodyLength: -1, env: { FormData: Je.classes.FormData, Blob: Je.classes.Blob }, validateStatus: function(e) {
  return e >= 200 && e < 300;
}, headers: { common: { Accept: "application/json, text/plain, */*" } } };
I.forEach(["delete", "get", "head"], function(e) {
  qr.headers[e] = {};
});
I.forEach(["post", "put", "patch"], function(e) {
  qr.headers[e] = I.merge(rp);
});
var Vn = qr, op = I.toObjectSet(["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"]), ip = (e) => {
  let t = {}, r, n, o;
  return e && e.split(`
`).forEach(function(i) {
    o = i.indexOf(":"), r = i.substring(0, o).trim().toLowerCase(), n = i.substring(o + 1).trim(), !(!r || t[r] && op[r]) && (r === "set-cookie" ? t[r] ? t[r].push(n) : t[r] = [n] : t[r] = t[r] ? t[r] + ", " + n : n);
  }), t;
}, No = Symbol("internals");
function cr(e) {
  return e && String(e).trim().toLowerCase();
}
function $r(e) {
  return e === !1 || e == null ? e : I.isArray(e) ? e.map($r) : String(e);
}
function ap(e) {
  let t = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g, n;
  for (; n = r.exec(e); )
    t[n[1]] = n[2];
  return t;
}
function sp(e) {
  return /^[-_a-zA-Z]+$/.test(e.trim());
}
function an(e, t, r, n, o) {
  if (I.isFunction(n))
    return n.call(this, t, r);
  if (o && (t = r), !!I.isString(t)) {
    if (I.isString(n))
      return t.indexOf(n) !== -1;
    if (I.isRegExp(n))
      return n.test(t);
  }
}
function lp(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, r, n) => r.toUpperCase() + n);
}
function up(e, t) {
  let r = I.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((n) => {
    Object.defineProperty(e, n + r, { value: function(o, i, a) {
      return this[n].call(this, t, o, i, a);
    }, configurable: !0 });
  });
}
var Gr = class {
  constructor(e) {
    e && this.set(e);
  }
  set(e, t, r) {
    let n = this;
    function o(a, l, s) {
      let h = cr(l);
      if (!h)
        throw new Error("header name must be a non-empty string");
      let d = I.findKey(n, h);
      (!d || n[d] === void 0 || s === !0 || s === void 0 && n[d] !== !1) && (n[d || l] = $r(a));
    }
    let i = (a, l) => I.forEach(a, (s, h) => o(s, h, l));
    return I.isPlainObject(e) || e instanceof this.constructor ? i(e, t) : I.isString(e) && (e = e.trim()) && !sp(e) ? i(ip(e), t) : e != null && o(t, e, r), this;
  }
  get(e, t) {
    if (e = cr(e), e) {
      let r = I.findKey(this, e);
      if (r) {
        let n = this[r];
        if (!t)
          return n;
        if (t === !0)
          return ap(n);
        if (I.isFunction(t))
          return t.call(this, n, r);
        if (I.isRegExp(t))
          return t.exec(n);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, t) {
    if (e = cr(e), e) {
      let r = I.findKey(this, e);
      return !!(r && this[r] !== void 0 && (!t || an(this, this[r], r, t)));
    }
    return !1;
  }
  delete(e, t) {
    let r = this, n = !1;
    function o(i) {
      if (i = cr(i), i) {
        let a = I.findKey(r, i);
        a && (!t || an(r, r[a], a, t)) && (delete r[a], n = !0);
      }
    }
    return I.isArray(e) ? e.forEach(o) : o(e), n;
  }
  clear(e) {
    let t = Object.keys(this), r = t.length, n = !1;
    for (; r--; ) {
      let o = t[r];
      (!e || an(this, this[o], o, e, !0)) && (delete this[o], n = !0);
    }
    return n;
  }
  normalize(e) {
    let t = this, r = {};
    return I.forEach(this, (n, o) => {
      let i = I.findKey(r, o);
      if (i) {
        t[i] = $r(n), delete t[o];
        return;
      }
      let a = e ? lp(o) : String(o).trim();
      a !== o && delete t[o], t[a] = $r(n), r[a] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    let t = /* @__PURE__ */ Object.create(null);
    return I.forEach(this, (r, n) => {
      r != null && r !== !1 && (t[n] = e && I.isArray(r) ? r.join(", ") : r);
    }), t;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, t]) => e + ": " + t).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...t) {
    let r = new this(e);
    return t.forEach((n) => r.set(n)), r;
  }
  static accessor(e) {
    let t = (this[No] = this[No] = { accessors: {} }).accessors, r = this.prototype;
    function n(o) {
      let i = cr(o);
      t[i] || (up(r, o), t[i] = !0);
    }
    return I.isArray(e) ? e.forEach(n) : n(e), this;
  }
};
Gr.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
I.freezeMethods(Gr.prototype);
I.freezeMethods(Gr);
var it = Gr;
function sn(e, t) {
  let r = this || Vn, n = t || r, o = it.from(n.headers), i = n.data;
  return I.forEach(e, function(a) {
    i = a.call(r, i, o.normalize(), t ? t.status : void 0);
  }), o.normalize(), i;
}
function Xi(e) {
  return !!(e && e.__CANCEL__);
}
function ea(e, t, r) {
  le.call(this, e == null ? "canceled" : e, le.ERR_CANCELED, t, r), this.name = "CanceledError";
}
I.inherits(ea, le, { __CANCEL__: !0 });
var Jr = ea;
function cp(e, t, r) {
  let n = r.config.validateStatus;
  !r.status || !n || n(r.status) ? e(r) : t(new le("Request failed with status code " + r.status, [le.ERR_BAD_REQUEST, le.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4], r.config, r.request, r));
}
var fp = Je.isStandardBrowserEnv ? function() {
  return { write: function(e, t, r, n, o, i) {
    let a = [];
    a.push(e + "=" + encodeURIComponent(t)), I.isNumber(r) && a.push("expires=" + new Date(r).toGMTString()), I.isString(n) && a.push("path=" + n), I.isString(o) && a.push("domain=" + o), i === !0 && a.push("secure"), document.cookie = a.join("; ");
  }, read: function(e) {
    let t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
    return t ? decodeURIComponent(t[3]) : null;
  }, remove: function(e) {
    this.write(e, "", Date.now() - 864e5);
  } };
}() : function() {
  return { write: function() {
  }, read: function() {
    return null;
  }, remove: function() {
  } };
}();
function pp(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function dp(e, t) {
  return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function ta(e, t) {
  return e && !pp(t) ? dp(e, t) : t;
}
var yp = Je.isStandardBrowserEnv ? function() {
  let e = /(msie|trident)/i.test(navigator.userAgent), t = document.createElement("a"), r;
  function n(o) {
    let i = o;
    return e && (t.setAttribute("href", i), i = t.href), t.setAttribute("href", i), { href: t.href, protocol: t.protocol ? t.protocol.replace(/:$/, "") : "", host: t.host, search: t.search ? t.search.replace(/^\?/, "") : "", hash: t.hash ? t.hash.replace(/^#/, "") : "", hostname: t.hostname, port: t.port, pathname: t.pathname.charAt(0) === "/" ? t.pathname : "/" + t.pathname };
  }
  return r = n(window.location.href), function(o) {
    let i = I.isString(o) ? n(o) : o;
    return i.protocol === r.protocol && i.host === r.host;
  };
}() : function() {
  return function() {
    return !0;
  };
}();
function hp(e) {
  let t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function mp(e, t) {
  e = e || 10;
  let r = new Array(e), n = new Array(e), o = 0, i = 0, a;
  return t = t !== void 0 ? t : 1e3, function(l) {
    let s = Date.now(), h = n[i];
    a || (a = s), r[o] = l, n[o] = s;
    let d = i, S = 0;
    for (; d !== o; )
      S += r[d++], d = d % e;
    if (o = (o + 1) % e, o === i && (i = (i + 1) % e), s - a < t)
      return;
    let O = h && s - h;
    return O ? Math.round(S * 1e3 / O) : void 0;
  };
}
var gp = mp;
function To(e, t) {
  let r = 0, n = gp(50, 250);
  return (o) => {
    let i = o.loaded, a = o.lengthComputable ? o.total : void 0, l = i - r, s = n(l), h = i <= a;
    r = i;
    let d = { loaded: i, total: a, progress: a ? i / a : void 0, bytes: l, rate: s || void 0, estimated: s && a && h ? (a - i) / s : void 0, event: o };
    d[t ? "download" : "upload"] = !0, e(d);
  };
}
var vp = typeof XMLHttpRequest != "undefined", bp = vp && function(e) {
  return new Promise(function(t, r) {
    let n = e.data, o = it.from(e.headers).normalize(), i = e.responseType, a;
    function l() {
      e.cancelToken && e.cancelToken.unsubscribe(a), e.signal && e.signal.removeEventListener("abort", a);
    }
    I.isFormData(n) && (Je.isStandardBrowserEnv || Je.isStandardBrowserWebWorkerEnv) && o.setContentType(!1);
    let s = new XMLHttpRequest();
    if (e.auth) {
      let O = e.auth.username || "", p = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
      o.set("Authorization", "Basic " + btoa(O + ":" + p));
    }
    let h = ta(e.baseURL, e.url);
    s.open(e.method.toUpperCase(), Qi(h, e.params, e.paramsSerializer), !0), s.timeout = e.timeout;
    function d() {
      if (!s)
        return;
      let O = it.from("getAllResponseHeaders" in s && s.getAllResponseHeaders()), p = { data: !i || i === "text" || i === "json" ? s.responseText : s.response, status: s.status, statusText: s.statusText, headers: O, config: e, request: s };
      cp(function(f) {
        t(f), l();
      }, function(f) {
        r(f), l();
      }, p), s = null;
    }
    if ("onloadend" in s ? s.onloadend = d : s.onreadystatechange = function() {
      !s || s.readyState !== 4 || s.status === 0 && !(s.responseURL && s.responseURL.indexOf("file:") === 0) || setTimeout(d);
    }, s.onabort = function() {
      !s || (r(new le("Request aborted", le.ECONNABORTED, e, s)), s = null);
    }, s.onerror = function() {
      r(new le("Network Error", le.ERR_NETWORK, e, s)), s = null;
    }, s.ontimeout = function() {
      let O = e.timeout ? "timeout of " + e.timeout + "ms exceeded" : "timeout exceeded", p = e.transitional || Ki;
      e.timeoutErrorMessage && (O = e.timeoutErrorMessage), r(new le(O, p.clarifyTimeoutError ? le.ETIMEDOUT : le.ECONNABORTED, e, s)), s = null;
    }, Je.isStandardBrowserEnv) {
      let O = (e.withCredentials || yp(h)) && e.xsrfCookieName && fp.read(e.xsrfCookieName);
      O && o.set(e.xsrfHeaderName, O);
    }
    n === void 0 && o.setContentType(null), "setRequestHeader" in s && I.forEach(o.toJSON(), function(O, p) {
      s.setRequestHeader(p, O);
    }), I.isUndefined(e.withCredentials) || (s.withCredentials = !!e.withCredentials), i && i !== "json" && (s.responseType = e.responseType), typeof e.onDownloadProgress == "function" && s.addEventListener("progress", To(e.onDownloadProgress, !0)), typeof e.onUploadProgress == "function" && s.upload && s.upload.addEventListener("progress", To(e.onUploadProgress)), (e.cancelToken || e.signal) && (a = (O) => {
      !s || (r(!O || O.type ? new Jr(null, e, s) : O), s.abort(), s = null);
    }, e.cancelToken && e.cancelToken.subscribe(a), e.signal && (e.signal.aborted ? a() : e.signal.addEventListener("abort", a)));
    let S = hp(h);
    if (S && Je.protocols.indexOf(S) === -1) {
      r(new le("Unsupported protocol " + S + ":", le.ERR_BAD_REQUEST, e));
      return;
    }
    s.send(n || null);
  });
}, Cr = { http: Lf, xhr: bp };
I.forEach(Cr, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch (r) {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
var wp = { getAdapter: (e) => {
  e = I.isArray(e) ? e : [e];
  let { length: t } = e, r, n;
  for (let o = 0; o < t && (r = e[o], !(n = I.isString(r) ? Cr[r.toLowerCase()] : r)); o++)
    ;
  if (!n)
    throw n === !1 ? new le(`Adapter ${r} is not supported by the environment`, "ERR_NOT_SUPPORT") : new Error(I.hasOwnProp(Cr, r) ? `Adapter '${r}' is not available in the build` : `Unknown adapter '${r}'`);
  if (!I.isFunction(n))
    throw new TypeError("adapter is not a function");
  return n;
}, adapters: Cr };
function ln(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Jr(null, e);
}
function Do(e) {
  return ln(e), e.headers = it.from(e.headers), e.data = sn.call(e, e.transformRequest), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), wp.getAdapter(e.adapter || Vn.adapter)(e).then(function(t) {
    return ln(e), t.data = sn.call(e, e.transformResponse, t), t.headers = it.from(t.headers), t;
  }, function(t) {
    return Xi(t) || (ln(e), t && t.response && (t.response.data = sn.call(e, e.transformResponse, t.response), t.response.headers = it.from(t.response.headers))), Promise.reject(t);
  });
}
var Mo = (e) => e instanceof it ? e.toJSON() : e;
function Yt(e, t) {
  t = t || {};
  let r = {};
  function n(h, d, S) {
    return I.isPlainObject(h) && I.isPlainObject(d) ? I.merge.call({ caseless: S }, h, d) : I.isPlainObject(d) ? I.merge({}, d) : I.isArray(d) ? d.slice() : d;
  }
  function o(h, d, S) {
    if (I.isUndefined(d)) {
      if (!I.isUndefined(h))
        return n(void 0, h, S);
    } else
      return n(h, d, S);
  }
  function i(h, d) {
    if (!I.isUndefined(d))
      return n(void 0, d);
  }
  function a(h, d) {
    if (I.isUndefined(d)) {
      if (!I.isUndefined(h))
        return n(void 0, h);
    } else
      return n(void 0, d);
  }
  function l(h, d, S) {
    if (S in t)
      return n(h, d);
    if (S in e)
      return n(void 0, h);
  }
  let s = { url: i, method: i, data: i, baseURL: a, transformRequest: a, transformResponse: a, paramsSerializer: a, timeout: a, timeoutMessage: a, withCredentials: a, adapter: a, responseType: a, xsrfCookieName: a, xsrfHeaderName: a, onUploadProgress: a, onDownloadProgress: a, decompress: a, maxContentLength: a, maxBodyLength: a, beforeRedirect: a, transport: a, httpAgent: a, httpsAgent: a, cancelToken: a, socketPath: a, responseEncoding: a, validateStatus: l, headers: (h, d) => o(Mo(h), Mo(d), !0) };
  return I.forEach(Object.keys(e).concat(Object.keys(t)), function(h) {
    let d = s[h] || o, S = d(e[h], t[h], h);
    I.isUndefined(S) && d !== l || (r[h] = S);
  }), r;
}
var ra = "1.3.4", qn = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  qn[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
var Bo = {};
qn.transitional = function(e, t, r) {
  function n(o, i) {
    return "[Axios v" + ra + "] Transitional option '" + o + "'" + i + (r ? ". " + r : "");
  }
  return (o, i, a) => {
    if (e === !1)
      throw new le(n(i, " has been removed" + (t ? " in " + t : "")), le.ERR_DEPRECATED);
    return t && !Bo[i] && (Bo[i] = !0, console.warn(n(i, " has been deprecated since v" + t + " and will be removed in the near future"))), e ? e(o, i, a) : !0;
  };
};
function Sp(e, t, r) {
  if (typeof e != "object")
    throw new le("options must be an object", le.ERR_BAD_OPTION_VALUE);
  let n = Object.keys(e), o = n.length;
  for (; o-- > 0; ) {
    let i = n[o], a = t[i];
    if (a) {
      let l = e[i], s = l === void 0 || a(l, i, e);
      if (s !== !0)
        throw new le("option " + i + " must be " + s, le.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new le("Unknown option " + i, le.ERR_BAD_OPTION);
  }
}
var vn = { assertOptions: Sp, validators: qn }, ht = vn.validators, Br = class {
  constructor(e) {
    this.defaults = e, this.interceptors = { request: new Co(), response: new Co() };
  }
  request(e, t) {
    typeof e == "string" ? (t = t || {}, t.url = e) : t = e || {}, t = Yt(this.defaults, t);
    let { transitional: r, paramsSerializer: n, headers: o } = t;
    r !== void 0 && vn.assertOptions(r, { silentJSONParsing: ht.transitional(ht.boolean), forcedJSONParsing: ht.transitional(ht.boolean), clarifyTimeoutError: ht.transitional(ht.boolean) }, !1), n !== void 0 && vn.assertOptions(n, { encode: ht.function, serialize: ht.function }, !0), t.method = (t.method || this.defaults.method || "get").toLowerCase();
    let i;
    i = o && I.merge(o.common, o[t.method]), i && I.forEach(["delete", "get", "head", "post", "put", "patch", "common"], (p) => {
      delete o[p];
    }), t.headers = it.concat(i, o);
    let a = [], l = !0;
    this.interceptors.request.forEach(function(p) {
      typeof p.runWhen == "function" && p.runWhen(t) === !1 || (l = l && p.synchronous, a.unshift(p.fulfilled, p.rejected));
    });
    let s = [];
    this.interceptors.response.forEach(function(p) {
      s.push(p.fulfilled, p.rejected);
    });
    let h, d = 0, S;
    if (!l) {
      let p = [Do.bind(this), void 0];
      for (p.unshift.apply(p, a), p.push.apply(p, s), S = p.length, h = Promise.resolve(t); d < S; )
        h = h.then(p[d++], p[d++]);
      return h;
    }
    S = a.length;
    let O = t;
    for (d = 0; d < S; ) {
      let p = a[d++], f = a[d++];
      try {
        O = p(O);
      } catch (P) {
        f.call(this, P);
        break;
      }
    }
    try {
      h = Do.call(this, O);
    } catch (p) {
      return Promise.reject(p);
    }
    for (d = 0, S = s.length; d < S; )
      h = h.then(s[d++], s[d++]);
    return h;
  }
  getUri(e) {
    e = Yt(this.defaults, e);
    let t = ta(e.baseURL, e.url);
    return Qi(t, e.params, e.paramsSerializer);
  }
};
I.forEach(["delete", "get", "head", "options"], function(e) {
  Br.prototype[e] = function(t, r) {
    return this.request(Yt(r || {}, { method: e, url: t, data: (r || {}).data }));
  };
});
I.forEach(["post", "put", "patch"], function(e) {
  function t(r) {
    return function(n, o, i) {
      return this.request(Yt(i || {}, { method: e, headers: r ? { "Content-Type": "multipart/form-data" } : {}, url: n, data: o }));
    };
  }
  Br.prototype[e] = t(), Br.prototype[e + "Form"] = t(!0);
});
var Nr = Br, na = class {
  constructor(e) {
    if (typeof e != "function")
      throw new TypeError("executor must be a function.");
    let t;
    this.promise = new Promise(function(n) {
      t = n;
    });
    let r = this;
    this.promise.then((n) => {
      if (!r._listeners)
        return;
      let o = r._listeners.length;
      for (; o-- > 0; )
        r._listeners[o](n);
      r._listeners = null;
    }), this.promise.then = (n) => {
      let o, i = new Promise((a) => {
        r.subscribe(a), o = a;
      }).then(n);
      return i.cancel = function() {
        r.unsubscribe(o);
      }, i;
    }, e(function(n, o, i) {
      r.reason || (r.reason = new Jr(n, o, i), t(r.reason));
    });
  }
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  unsubscribe(e) {
    if (!this._listeners)
      return;
    let t = this._listeners.indexOf(e);
    t !== -1 && this._listeners.splice(t, 1);
  }
  static source() {
    let e;
    return { token: new na(function(t) {
      e = t;
    }), cancel: e };
  }
}, Op = na;
function Ep(e) {
  return function(t) {
    return e.apply(null, t);
  };
}
function Ap(e) {
  return I.isObject(e) && e.isAxiosError === !0;
}
var bn = { Continue: 100, SwitchingProtocols: 101, Processing: 102, EarlyHints: 103, Ok: 200, Created: 201, Accepted: 202, NonAuthoritativeInformation: 203, NoContent: 204, ResetContent: 205, PartialContent: 206, MultiStatus: 207, AlreadyReported: 208, ImUsed: 226, MultipleChoices: 300, MovedPermanently: 301, Found: 302, SeeOther: 303, NotModified: 304, UseProxy: 305, Unused: 306, TemporaryRedirect: 307, PermanentRedirect: 308, BadRequest: 400, Unauthorized: 401, PaymentRequired: 402, Forbidden: 403, NotFound: 404, MethodNotAllowed: 405, NotAcceptable: 406, ProxyAuthenticationRequired: 407, RequestTimeout: 408, Conflict: 409, Gone: 410, LengthRequired: 411, PreconditionFailed: 412, PayloadTooLarge: 413, UriTooLong: 414, UnsupportedMediaType: 415, RangeNotSatisfiable: 416, ExpectationFailed: 417, ImATeapot: 418, MisdirectedRequest: 421, UnprocessableEntity: 422, Locked: 423, FailedDependency: 424, TooEarly: 425, UpgradeRequired: 426, PreconditionRequired: 428, TooManyRequests: 429, RequestHeaderFieldsTooLarge: 431, UnavailableForLegalReasons: 451, InternalServerError: 500, NotImplemented: 501, BadGateway: 502, ServiceUnavailable: 503, GatewayTimeout: 504, HttpVersionNotSupported: 505, VariantAlsoNegotiates: 506, InsufficientStorage: 507, LoopDetected: 508, NotExtended: 510, NetworkAuthenticationRequired: 511 };
Object.entries(bn).forEach(([e, t]) => {
  bn[t] = e;
});
var xp = bn;
function oa(e) {
  let t = new Nr(e), r = Di(Nr.prototype.request, t);
  return I.extend(r, Nr.prototype, t, { allOwnKeys: !0 }), I.extend(r, t, null, { allOwnKeys: !0 }), r.create = function(n) {
    return oa(Yt(e, n));
  }, r;
}
var Ee = oa(Vn);
Ee.Axios = Nr;
Ee.CanceledError = Jr;
Ee.CancelToken = Op;
Ee.isCancel = Xi;
Ee.VERSION = ra;
Ee.toFormData = Vr;
Ee.AxiosError = le;
Ee.Cancel = Ee.CanceledError;
Ee.all = function(e) {
  return Promise.all(e);
};
Ee.spread = Ep;
Ee.isAxiosError = Ap;
Ee.mergeConfig = Yt;
Ee.AxiosHeaders = it;
Ee.formToJSON = (e) => Zi(I.isHTMLForm(e) ? new FormData(e) : e);
Ee.HttpStatusCode = xp;
Ee.default = Ee;
Jc(lf());
var Pp = /* @__PURE__ */ new Map([["en", "en_US"], ["th", "th_TH"], ["vi", "vi_VN"], ["id", "id_ID"], ["ms", "ms_MY"]]), jp = ((e) => (e[e.OK = 0] = "OK", e[e.ErrForbidden = -403] = "ErrForbidden", e[e.ErrNotFound = -404] = "ErrNotFound", e[e.ErrUserNotExist = -626] = "ErrUserNotExist", e[e.ErrRegionLimit = 10004001] = "ErrRegionLimit", e[e.ErrArchive = 10004002] = "ErrArchive", e[e.ErrEpisode = 10004003] = "ErrEpisode", e[e.ErrNeedPremium = 10004004] = "ErrNeedPremium", e[e.ErrNeedLogin = 10004005] = "ErrNeedLogin", e[e.ErrNeedBuvid = 10023006] = "ErrNeedBuvid", e[e.ErrSubmitFail = 10023007] = "ErrSubmitFail", e[e.ErrCommentClose = 10023008] = "ErrCommentClose", e[e.ErrAccountOrPassword = -629] = "ErrAccountOrPassword", e[e.ErrCaptcha = -105] = "ErrCaptcha", e[e.DecryptError = 86e3] = "DecryptError", e[e.NeedCaptcha = 86001] = "NeedCaptcha", e[e.EmptyArea = 86003] = "EmptyArea", e[e.EmptyPhone = 86004] = "EmptyPhone", e[e.ErrorPhone = 86005] = "ErrorPhone", e[e.BanPhone = 86015] = "BanPhone", e[e.FrequentSend = 86200] = "FrequentSend", e[e.ErrorSmsCode = 86202] = "ErrorSmsCode", e[e.LimitSend = 86203] = "LimitSend", e[e.TooManySend = 86204] = "TooManySend", e[e.OverdueSmsCode = 86205] = "OverdueSmsCode", e[e.DiffArea = 86206] = "DiffArea", e[e.DiffPhone = 86207] = "DiffPhone", e[e.UnlegalSend = 86208] = "UnlegalSend", e[e.ErrorPhone2 = 66031] = "ErrorPhone2", e[e.ErrorAccountOrPassword = -629] = "ErrorAccountOrPassword", e[e.ErrorCaptcha = -105] = "ErrorCaptcha", e[e.PhoneLimit = 86071] = "PhoneLimit", e[e.AreaLimit = 10003003] = "AreaLimit", e[e.EmailSendFail = 86250] = "EmailSendFail", e[e.EmailSendInvalid = 86251] = "EmailSendInvalid", e[e.EmailSent = 86252] = "EmailSent", e[e.TooManyEmailSend = 86253] = "TooManyEmailSend", e[e.TooManyEmailSendIp = 86254] = "TooManyEmailSendIp", e[e.OverdueEmail = 86255] = "OverdueEmail", e[e.DiffEmail = 86256] = "DiffEmail", e[e.ErrorEmailCode = 86257] = "ErrorEmailCode", e[e.EmailInvalid = 86258] = "EmailInvalid", e[e.InvalidPassword = 86306] = "InvalidPassword", e[e.OccupyEmail = 86259] = "OccupyEmail", e[e.ResentEmailCode = 86150] = "ResentEmailCode", e[e.QrcodeScanTimeout = 10018100] = "QrcodeScanTimeout", e[e.QrcodeNotScan = 10018101] = "QrcodeNotScan", e[e.QrcodeScaned = 10018102] = "QrcodeScaned", e))(jp || {}), Rp = { apiUrl: "//uat-api.bilibili.tv", studioUrl: "http://uat-studio.bilibili.tv", loginUrl: "//uat-passport.bilibili.tv", fmLoginUrl: "//uat-passport.pogo.fm", domain: "http://uat-www.bilibili.tv", fmDomain: "http://uat-www.pogo.fm" }, _p = { apiUrl: "//uat-api.bilibili.tv", studioUrl: "http://uat-studio.bilibili.tv", loginUrl: "//uat-passport.bilibili.tv", fmLoginUrl: "//uat-passport.pogo.fm", domain: "http://uat-www.bilibili.tv", fmDomain: "http://uat-www.pogo.fm" }, kp = { apiUrl: "//pre-api.bilibili.tv", studioUrl: "http://pre-studio.bilibili.tv", loginUrl: "//pre-passport.bilibili.tv", fmLoginUrl: "//pre-passport.pogo.fm", domain: "http://pre-www.bilibili.tv", fmDomain: "http://pre-www.pogo.fm" }, ia = { apiUrl: "//api.bilibili.tv", studioUrl: "https://studio.bilibili.tv", loginUrl: "//passport.bilibili.tv", fmLoginUrl: "//passport.pogo.fm", domain: "https://www.bilibili.tv", fmDomain: "https://www.pogo.fm" }, $p = /* @__PURE__ */ new Map([["dev", Rp], ["uat", _p], ["pre", kp], ["prod", ia]]), aa = (e) => {
  var t;
  return (t = $p.get(e)) != null ? t : ia;
}, Io, Fo, Uo, Cp = !jo.isSafari || Number((Uo = (Fo = (Io = jo) == null ? void 0 : Io.safariVersion) == null ? void 0 : Fo.split(".")) == null ? void 0 : Uo[0]) >= 14, Np = (e, t, r, n = !1) => {
  if (!t || !r || !e)
    return e;
  let o = `${e.replace("http:", "https:")}@${t}w_${r}h_1e_1c_1f`;
  if (n && Cp)
    return `${o}.webp`;
  if (e.includes("p.bstarstatic.com")) {
    let i = e.match(/\.(\w+)$/) || [];
    return `${o}.${i[1] || "jpg"}`;
  }
  return o;
}, Tp = (e, t) => {
  let r = aa(e);
  return (n, o) => `${r.domain}/${t}/${n}${o ? `?${o}` : ""}`;
}, Dp = (e, t, r) => {
  let n = aa(e), o = r ? `${n.loginUrl}/x/intl/passport-login/web/` : `${n.apiUrl}/intl/gateway/web/v2/`, i = (a, l) => Yc(void 0, null, function* () {
    let s = yield fetch(`${o}${a}`, l), { code: h, message: d, data: S } = yield s.json();
    if (h !== 0)
      throw new Error(d);
    return S;
  });
  return { get: (a, l) => {
    let s = Object.entries(qc({ s_locale: Pp.get(t), platform: "web" }, l)).map((h) => h.join("=")).join("&");
    return i(`${a}?${s}`, { credentials: "include" });
  }, sendBeacon: (a, l) => {
    navigator.sendBeacon(`${o}${a}`, l);
  } };
}, Lo = (e, t) => {
  var r, n, o;
  (r = t.value) != null && r.id && (e.dataset.bExposeId = t.value.id), (n = t.value) != null && n.key && (e.dataset.bExposeKey = t.value.key), (o = t.value) != null && o.data && (e.dataset.bExposeData = t.value.data);
}, Mp = { mounted: Lo, updated: Lo };
const Bp = /* @__PURE__ */ new Map([
  ["en", {
    nav: { home: "Home", anime: "Anime", trending: "Trending", category: "Category", history: "History", live: "LIVE" },
    footer: {
      about: "About us",
      contactUs: "Contact us",
      agreement: "Terms of Service",
      videoRules: "Punishment Rules for Video Violations",
      accountRules: "Punishment Rules for Account Violations",
      privacy: "Privacy Policy",
      infringe: "Infringement Complaint",
      download: "Get App"
    },
    followings: {
      tips: 'Log in to view your "Followed" content.',
      login: "Log in",
      viewMore: "View More",
      following: "Following"
    }
  }],
  ["th", {
    nav: { home: "หน้าหลัก", anime: "อนิเมะ", trending: "กำลังมาแรง", category: "หมวดหมู่", history: "ประวัติ", live: "ไลฟ์สด" },
    footer: {
      about: "เกี่ยวกับเรา",
      contactUs: "ติดต่อเรา",
      agreement: "ข้อกำหนดการให้บริการ",
      videoRules: "ข้อกำหนดการลงโทษวิดีโอที่ละเมิดกฎ",
      accountRules: "ข้อกำหนดการลงโทษบัญชีที่ละเมิดกฎ",
      privacy: "นโยบายความเป็นส่วนตัว",
      infringe: "การร้องเรียนการละเมิด",
      download: "ดาวน์โหลดแอป"
    },
    followings: {
      tips: "เข้าสู่ระบบเพื่อดูเนื้อหาที่ติดตาม",
      login: "เข้าสู่ระบบทันที",
      viewMore: "ดูเพิ่มเติม",
      following: "ติดตามแล้ว"
    }
  }],
  ["vi", {
    nav: { home: "Trang chủ", anime: "Anime", trending: "Thịnh hành", category: "Mục lục", history: "Lịch sử", live: "Trực tiếp" },
    footer: {
      about: "Về chúng tôi",
      contactUs: "Liên hệ chúng tôi",
      agreement: "Điều khoản sử dụng",
      videoRules: "Nguyên Tắc Xử Phạt Video Vi Phạm",
      accountRules: "Nguyên Tắc Xử Phạt Tài Khoản Vi Phạm",
      privacy: "Chính sách riêng tư",
      infringe: "Khiếu nại vi phạm",
      download: "Tải ứng dụng"
    },
    followings: {
      tips: "Đăng nhập để xem nội dung liên quan.",
      login: "Đăng nhập",
      viewMore: "Xem thêm",
      following: "Đang theo dõi"
    }
  }],
  ["id", {
    nav: { home: "Halaman utama", anime: "Anime", trending: "Trending", category: "Kategori", history: "Sejarah", live: "LIVE" },
    footer: {
      about: "Tentang kami",
      contactUs: "Hubungi kami",
      agreement: "Syarat Layanan",
      videoRules: "Aturan Hukuman untuk Pelanggaran Video",
      accountRules: "Aturan Hukuman untuk Pelanggaran Akun",
      privacy: "Kebijakan Privasi",
      infringe: "Keluhan pelanggaran",
      download: "Dapatkan aplikasi"
    },
    followings: {
      tips: "Masuk untuk lihat konten yang Anda ikuti",
      login: "Login",
      viewMore: "Menonton Lebih Banyak",
      following: "Mengikuti"
    }
  }],
  ["ms", {
    nav: { home: "Laman utama", anime: "Anime", trending: "Trend", category: "Kategori", history: "Sejarah", live: "LIVE" },
    footer: {
      about: "Tentang Kami",
      contactUs: "Hubungi Kami",
      agreement: "Syarat Perkhidmatan",
      videoRules: "Peraturan Penalti untuk Pelanggaran Video",
      accountRules: "Peraturan Penalti untuk Pelanggaran Akaun",
      privacy: "Dasar Privasi",
      infringe: "Aduan Pelanggaran",
      download: "Dapatkan Apl"
    },
    followings: {
      tips: "Log masuk untuk lihat kandungan yang anda ikuti",
      login: "Log masuk",
      viewMore: "Yang lain",
      following: "Mengikuti"
    }
  }]
]), Ip = Bp;
var nt = /* @__PURE__ */ ((e) => (e.home = "home", e.anime = "anime", e.trending = "trending", e.category = "category", e.live = "live", e))(nt || {});
const Fp = () => {
  const e = typeof window != "undefined" ? Oa({ logId: { pv: "", click: "000017", expose: "" } }) : null;
  return { sendEvent: (r, n) => {
    e && e.sendClick({ event: r, value: n != null ? n : {} });
  } };
}, Up = /* @__PURE__ */ new Map([
  [nt.home, "side_nav_home_click"],
  [nt.anime, "side_nav_anime_click"],
  [nt.category, "side_nav_category_click"],
  [nt.trending, "side_nav_trending_click"]
]);
var Gn = /* @__PURE__ */ ((e) => (e.clickSideUpIcon = "side_up_icon_click", e.showSideUpIcon = "side_up_icon_show", e))(Gn || {});
const sa = Fp();
var tt = /* @__PURE__ */ ((e) => (e[e.Normal = 0] = "Normal", e[e.RedDot = 1] = "RedDot", e[e.Live = 2] = "Live", e))(tt || {});
const Lp = (e, t) => {
  const r = fe([]), n = fe(!1), o = fe(!1), i = Dp(e, t);
  return { followings: r, hasMore: n, isFetching: o, fetchFollowings: () => Qn(void 0, null, function* () {
    var s;
    o.value = !0;
    try {
      const h = yield i.get("user/following/top");
      r.value = (s = h.followings) != null ? s : [], n.value = h.has_more;
    } catch (h) {
    } finally {
      o.value = !1;
    }
  }), updateRedDot: (s) => {
    const h = new FormData();
    h.set("mid", s), i.sendBeacon("user/following/offset/update", h), r.value = m(r).map((d) => d.mid === s ? dt(pt({}, d), { type: tt.Normal }) : d);
  } };
}, Hp = ["href"], zp = {
  name: "NavItem"
}, Wp = /* @__PURE__ */ ge(dt(pt({}, zp), {
  props: {
    classPrefix: null,
    name: null,
    link: null,
    active: { type: Boolean }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const r = e, { classPrefix: n, name: o, active: i } = Ae(r), a = Q(() => [`${m(n)}__link`, `${m(n)}__link--${m(o)}`]), l = (s) => {
      t("click", { e: s, name: m(o) });
    };
    return (s, h) => (Y(), ee("li", {
      class: oe([`${m(n)}__item`, m(o), { active: m(i) }])
    }, [
      G("a", {
        href: e.link,
        class: oe(m(a)),
        onClick: l
      }, [
        Re(s.$slots, "default")
      ], 10, Hp)
    ], 2));
  }
}));
const Vp = ["href", "target"], qp = ["src", "alt"], Gp = {
  name: "FollowingItem"
}, Jp = /* @__PURE__ */ ge(dt(pt({}, Gp), {
  props: {
    classPrefix: null,
    url: null,
    item: null
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const r = e, { classPrefix: n, item: o } = Ae(r), i = Q(() => [
      `${m(n)}__followings-item`,
      { [`${m(n)}__followings-item--normal`]: m(o).type === tt.Normal }
    ]), a = Q(() => Np(m(o).avatar, 36, 36, !0)), l = Q(() => m(o).type !== tt.Normal && {
      [`${m(n)}__followings-dot`]: m(o).type === tt.RedDot,
      [`${m(n)}__followings-live`]: m(o).type === tt.Live
    }), s = Q(() => m(o).type === tt.Live ? "_blank" : "_self"), h = () => {
      m(o).type === tt.RedDot && (sa.sendEvent(Gn.clickSideUpIcon, { uid: m(o).mid }), t("click", m(o).mid));
    };
    return (d, S) => (Y(), ee("li", null, [
      G("a", {
        class: oe(m(i)),
        href: e.url,
        target: m(s),
        onClick: h
      }, [
        G("div", {
          class: oe(`${m(n)}__followings-avatar`)
        }, [
          G("img", {
            src: m(a),
            alt: m(o).nickname
          }, null, 8, qp)
        ], 2),
        G("p", null, ye(m(o).nickname), 1),
        m(l) ? (Y(), ee("span", {
          key: 0,
          class: oe(m(l))
        }, null, 2)) : he("", !0)
      ], 10, Vp)
    ]));
  }
}));
const Yp = ["href"], Qp = {
  name: "SideFooter"
}, Kp = /* @__PURE__ */ ge(dt(pt({}, Qp), {
  props: {
    classPrefix: null,
    items: null,
    isBstation: { type: Boolean }
  },
  setup(e) {
    return (t, r) => (Y(), ee("div", {
      class: oe(`${e.classPrefix}__footer`)
    }, [
      (Y(!0), ee(rt, null, It(e.items, (n, o) => (Y(), ee("a", {
        key: o,
        href: n.link,
        target: "_blank"
      }, ye(n.name), 9, Yp))), 128)),
      G("span", null, "© " + ye(new Date().getFullYear()) + " " + ye(e.isBstation ? "Bstation" : "BiliBili"), 1)
    ], 2));
  }
}));
const Zp = ["href"], Xp = ["src", "alt"], ed = {
  name: "SideHeader"
}, td = /* @__PURE__ */ ge(dt(pt({}, ed), {
  props: {
    classPrefix: null,
    url: null,
    isBstation: { type: Boolean }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const r = e, { isBstation: n } = Ae(r), o = Q(() => m(n) ? "top_logo_Bstation.svg" : "top_logo.svg"), i = () => {
      t("click");
    };
    return (a, l) => (Y(), ee("div", {
      class: oe(`${e.classPrefix}__header`)
    }, [
      G("button", {
        class: oe(`${e.classPrefix}__menu`),
        onClick: i
      }, null, 2),
      G("a", {
        href: e.url,
        class: oe(`${e.classPrefix}__logo`)
      }, [
        G("img", {
          src: `https://p.bstarstatic.com/fe-lib/images/web/${m(o)}`,
          alt: `${m(n) ? "bstation" : "bilibili"}-logo`
        }, null, 8, Xp)
      ], 10, Zp)
    ], 2));
  }
}));
const rd = ["href"], nd = {
  name: "BSidebar"
}, od = /* @__PURE__ */ ge(dt(pt({}, nd), {
  props: {
    value: { default: "" },
    env: { default: "prod" },
    locale: { default: "en" },
    type: { default: "normal" },
    mid: null,
    toggleWidth: { type: Boolean },
    isBstation: { type: Boolean },
    isMobile: { type: Boolean },
    isLogin: { type: Boolean, default: !1 },
    showFollows: { type: Boolean, default: !0 },
    useRouter: { type: Boolean }
  },
  emits: ["change", "click", "toggle"],
  setup(e, { emit: t }) {
    const r = e, { value: n, env: o, locale: i, type: a, mid: l, toggleWidth: s, isMobile: h, isLogin: d, useRouter: S, showFollows: O } = Ae(r), p = "bstar-sidebar", f = "bstar-sidebar__mask", { followings: P, hasMore: k, fetchFollowings: A, updateRedDot: u } = Lp(m(o), m(i)), v = Tp(m(o), m(i)), b = fe(m(n)), g = v(""), w = Q(() => Ip.get(m(i))), R = Q(() => v(`space/${m(l)}/followings`)), D = Q(
      () => m(O) && (!m(d) || m(d) && m(K).length > 0)
    ), j = Q(() => [
      p,
      `${p}--${m(a)}`,
      {
        [`${p}--mobile`]: m(h),
        [`${p}--toggle`]: m(s),
        [`${p}--follows`]: m(D)
      }
    ]), M = Q(() => [
      `${f}`,
      `${f}--${m(a)}`,
      {
        [`${f}--show`]: m(s)
      }
    ]), H = Q(
      () => Object.keys(nt).filter((N) => !m(h) || N !== nt.category && N !== nt.live).map((N) => {
        var E;
        return {
          name: N,
          label: (E = m(w)) == null ? void 0 : E.nav[N],
          link: N === nt.home ? g : v(N),
          active: m(b) === N
        };
      })
    ), K = Q(() => m(P).map((N, E) => ({
      url: v(N.type === tt.Live && N.live ? `live/${N.live.room_id}` : `space/${N.mid}`),
      item: N,
      expose: { id: Gn.showSideUpIcon, key: E, data: JSON.stringify({ uid: N.mid }) }
    }))), C = Q(() => {
      var N, E, F, V, z, W, L, Z;
      return [
        { name: (N = m(w)) == null ? void 0 : N.footer.about, link: v("about") },
        { name: (E = m(w)) == null ? void 0 : E.footer.contactUs, link: "mailto:contact@bilibili.tv" },
        { name: (F = m(w)) == null ? void 0 : F.footer.download, link: v("download") },
        { name: (V = m(w)) == null ? void 0 : V.footer.agreement, link: v("user-agreement") },
        { name: (z = m(w)) == null ? void 0 : z.footer.videoRules, link: v("video-rules") },
        { name: (W = m(w)) == null ? void 0 : W.footer.accountRules, link: v("account-rules") },
        { name: (L = m(w)) == null ? void 0 : L.footer.privacy, link: v("privacy-policy") },
        { name: (Z = m(w)) == null ? void 0 : Z.footer.infringe, link: v("copyright-policy") }
      ];
    }), $ = ({ e: N, name: E }) => {
      const F = m(b) === E;
      m(S) ? (N.preventDefault(), t("click", { name: E, isActive: F })) : F && window.location.reload(), b.value = E, t("change", E);
      const V = Up.get(E);
      V && sa.sendEvent(V);
    }, x = (N) => {
      u(N);
    }, T = () => {
      t("toggle");
    }, _ = () => {
      typeof window != "undefined" && window.postMessage({ name: "bstar-header-login", source: 12 }, "*");
    };
    return Ft(d, (N) => {
      !m(h) && m(O) && N && A();
    }), Ft(n, (N) => {
      N && m(b) !== N && (b.value = N);
    }), gr(() => {
      !m(h) && m(d) && m(O) && A();
    }), (N, E) => {
      var F, V, z;
      return Y(), ee("nav", {
        class: oe(m(j))
      }, [
        !m(h) && m(s) ? (Y(), Ne(td, {
          key: 0,
          "class-prefix": p,
          url: m(g),
          "is-bstation": e.isBstation,
          onClick: T
        }, null, 8, ["url", "is-bstation"])) : he("", !0),
        G("ul", {
          class: oe(`${p}__list`)
        }, [
          (Y(!0), ee(rt, null, It(m(H), (W) => (Y(), Ne(Wp, {
            key: W.name,
            "class-prefix": p,
            name: W.name,
            link: W.link,
            active: W.active,
            onClick: $
          }, {
            default: Ie(() => [
              $t(ye(W.label), 1)
            ]),
            _: 2
          }, 1032, ["name", "link", "active"]))), 128))
        ], 2),
        m(h) ? he("", !0) : (Y(), ee(rt, { key: 1 }, [
          m(D) ? (Y(), ee("div", {
            key: 0,
            class: oe([`${p}__followings`, { [`${p}__followings--login`]: m(d) }])
          }, [
            m(d) ? (Y(), ee(rt, { key: 0 }, [
              G("p", {
                class: oe(`${p}__followings-title`)
              }, ye((F = m(w)) == null ? void 0 : F.followings.following), 3),
              G("ul", null, [
                (Y(!0), ee(rt, null, It(m(K), (W) => Lt((Y(), Ne(Jp, {
                  key: W.item.mid,
                  "class-prefix": p,
                  url: W.url,
                  item: W.item,
                  onClick: x
                }, null, 8, ["url", "item"])), [
                  [m(Mp), W.expose]
                ])), 128))
              ]),
              m(k) ? (Y(), ee("a", {
                key: 0,
                class: oe(`${p}__followings-more`),
                href: m(R)
              }, ye((V = m(w)) == null ? void 0 : V.followings.viewMore), 11, rd)) : he("", !0)
            ], 64)) : (Y(), ee(rt, { key: 1 }, [
              G("p", {
                class: oe(`${p}__followings-tips`)
              }, ye((z = m(w)) == null ? void 0 : z.followings.tips), 3),
              Tr(m(Ds), {
                size: "large",
                hollow: "",
                block: "",
                onClick: _
              }, {
                default: Ie(() => {
                  var W;
                  return [
                    $t(ye((W = m(w)) == null ? void 0 : W.followings.login), 1)
                  ];
                }),
                _: 1
              })
            ], 64))
          ], 2)) : he("", !0),
          Tr(Kp, {
            "class-prefix": p,
            items: m(C),
            "is-bstation": e.isBstation
          }, null, 8, ["items", "is-bstation"]),
          m(h) ? he("", !0) : (Y(), Ne(wn, {
            key: 1,
            to: "body"
          }, [
            G("div", {
              class: oe(m(M)),
              onClick: T
            }, null, 2)
          ]))
        ], 64))
      ], 2);
    };
  }
}));
const cd = (e, t) => {
  var s, h;
  const r = fe((s = t.toggleWidth) != null ? s : !1), n = fe((h = t.isLogin) != null ? h : !1), o = Q(() => dt(pt({}, t), {
    toggleWidth: m(r),
    isLogin: m(n),
    onToggle: i
  })), i = () => {
    r.value = !m(r), l(), t.onToggle && t.onToggle();
  }, a = (d) => {
    n.value = d, l();
  }, l = () => {
    const d = wa(od, m(o)), S = document.getElementById(e);
    S && Sa(d, S);
  };
  return { renderSidebar: l, toggle: i, changeLogin: a };
};
export {
  od as BSidebar,
  cd as useRenderSidebar
};
//# sourceMappingURL=b-sidebar.es.js.map
